(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[333],{

/***/ 37340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YF": function() { return /* binding */ useFloating; }
/* harmony export */ });
/* unused harmony export arrow */
/* harmony import */ var _floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82622);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10422);






/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = options => {
  function isRef(value) {
    return {}.hasOwnProperty.call(value, 'current');
  }
  return {
    name: 'arrow',
    options,
    fn(state) {
      const {
        element,
        padding
      } = typeof options === 'function' ? options(state) : options;
      if (element && isRef(element)) {
        if (element.current != null) {
          return arrow$1({
            element: element.current,
            padding
          }).fn(state);
        }
        return {};
      } else if (element) {
        return arrow$1({
          element,
          padding
        }).fn(state);
      }
      return {};
    }
  };
};

var index = typeof document !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;

// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (typeof a === 'function' && a.toString() === b.toString()) {
    return true;
  }
  let length, i, keys;
  if (a && b && typeof a == 'object') {
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) {
        if (!deepEqual(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (i = length; i-- !== 0;) {
      if (!{}.hasOwnProperty.call(b, keys[i])) {
        return false;
      }
    }
    for (i = length; i-- !== 0;) {
      const key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        continue;
      }
      if (!deepEqual(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
}

function getDPR(element) {
  if (typeof window === 'undefined') {
    return 1;
  }
  const win = element.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}

function roundByDPR(element, value) {
  const dpr = getDPR(element);
  return Math.round(value * dpr) / dpr;
}

function useLatestRef(value) {
  const ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}

/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/react
 */
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open
  } = options;
  const [data, setData] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = react__WEBPACK_IMPORTED_MODULE_0__.useState(middleware);
  if (!deepEqual(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const [_reference, _setReference] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const [_floating, _setFloating] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const setReference = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(node => {
    if (node != referenceRef.current) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, [_setReference]);
  const setFloating = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(node => {
    if (node !== floatingRef.current) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, [_setFloating]);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  const floatingRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  const dataRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(data);
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const platformRef = useLatestRef(platform);
  const update = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config.platform = platformRef.current;
    }
    (0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__/* .computePosition */ .oo)(referenceRef.current, floatingRef.current, config).then(data => {
      const fullData = {
        ...data,
        isPositioned: true
      };
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        react_dom__WEBPACK_IMPORTED_MODULE_1__.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef]);
  index(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData(data => ({
        ...data,
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(false);
  index(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      } else {
        update();
      }
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef]);
  const refs = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x = roundByDPR(elements.floating, data.x);
    const y = roundByDPR(elements.floating, data.y);
    if (transform) {
      return {
        ...initialStyles,
        transform: "translate(" + x + "px, " + y + "px)",
        ...(getDPR(elements.floating) >= 1.5 && {
          willChange: 'transform'
        })
      };
    }
    return {
      position: strategy,
      left: x,
      top: y
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => ({
    ...data,
    update,
    refs,
    elements,
    floatingStyles
  }), [data, update, refs, elements, floatingStyles]);
}




/***/ }),

/***/ 23014:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(50959);

function CheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CheckIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 9602:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(50959);

function ChevronLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ChevronLeftIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 43240:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(50959);

function ChevronRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ChevronRightIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 37878:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(50959);

function ChevronUpDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75 0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908 2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ChevronUpDownIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 84039:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(50959);

function EllipsisHorizontalIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3 10a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM8.5 10a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM15.5 8.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
  }));
}

const ForwardRef = React.forwardRef(EllipsisHorizontalIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 83720:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(50959);

function XMarkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"
  }));
}

const ForwardRef = React.forwardRef(XMarkIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 42966:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(50959);

function CheckCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

const ForwardRef = React.forwardRef(CheckCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 30429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(50959);

function ExclamationTriangleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
  }));
}

const ForwardRef = React.forwardRef(ExclamationTriangleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 52111:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(50959);

function InformationCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
  }));
}

const ForwardRef = React.forwardRef(InformationCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 90333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bZ": function() { return /* binding */ Alert; },
  "Ct": function() { return /* binding */ Badge; },
  "zx": function() { return /* binding */ Button; },
  "XZ": function() { return /* binding */ Checkbox; },
  "XV": function() { return /* binding */ ComboboxFields; },
  "W2": function() { return /* binding */ Container; },
  "Vq": function() { return /* binding */ Dialog; },
  "CE": function() { return /* binding */ LoadingCircular; },
  "tl": function() { return /* binding */ Pagination; },
  "s_": function() { return /* binding */ Panel; },
  "Y8": function() { return /* binding */ Checkbox$1; },
  "mg": function() { return /* binding */ SelectField; },
  "Od": function() { return /* binding */ Skeleton; },
  "N7": function() { return /* binding */ TextAreaField; },
  "nv": function() { return /* binding */ TextField; },
  "u": function() { return /* binding */ Tooltip; },
  "fg": function() { return /* binding */ buttonCls; },
  "wj": function() { return /* binding */ buttonIconCls; },
  "Xr": function() { return /* binding */ classx; },
  "CM": function() { return /* binding */ containerCls$2; },
  "xq": function() { return /* binding */ defaultFieldElement; },
  "FR": function() { return /* binding */ defaultOptionElement; },
  "Cu": function() { return /* binding */ optionCheckCls; },
  "hJ": function() { return /* binding */ optionCls; }
});

// UNUSED EXPORTS: CheckboxGroup, FileUpload, LoadingDotted, ProgressCircular, calculateClasses

// EXTERNAL MODULE: ./node_modules/.pnpm/class-variance-authority@0.7.0/node_modules/class-variance-authority/dist/index.mjs + 1 modules
var dist = __webpack_require__(2808);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/utils/class-names.js
function class_names_e(...n){return n.filter(Boolean).join(" ")}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/utils/match.js
function match_u(r,n,...a){if(r in n){let e=n[r];return typeof e=="function"?e(...a):e}let t=new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map(e=>`"${e}"`).join(", ")}.`);throw Error.captureStackTrace&&Error.captureStackTrace(t,match_u),t}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/utils/render.js
var j=(a=>(a[a.None=0]="None",a[a.RenderStrategy=1]="RenderStrategy",a[a.Static=2]="Static",a))(j||{}),render_w=(e=>(e[e.Unmount=0]="Unmount",e[e.Hidden=1]="Hidden",e))(render_w||{});function render_D({ourProps:r,theirProps:t,slot:e,defaultTag:a,features:s,visible:n=!0,name:l}){let o=h(t,r);if(n)return render_m(o,e,a,l);let f=s!=null?s:0;if(f&2){let{static:i=!1,...u}=o;if(i)return render_m(u,e,a,l)}if(f&1){let{unmount:i=!0,...u}=o;return match_u(i?0:1,{[0](){return null},[1](){return render_m({...u,hidden:!0,style:{display:"none"}},e,a,l)}})}return render_m(o,e,a,l)}function render_m(r,t={},e,a){var y;let{as:s=e,children:n,refName:l="ref",...o}=g(r,["unmount","static"]),f=r.ref!==void 0?{[l]:r.ref}:{},i=typeof n=="function"?n(t):n;"className"in o&&o.className&&typeof o.className=="function"&&(o.className=o.className(t));let u={};if(t){let d=!1,c=[];for(let[p,F]of Object.entries(t))typeof F=="boolean"&&(d=!0),F===!0&&c.push(p);d&&(u["data-headlessui-state"]=c.join(" "))}if(s===react.Fragment&&Object.keys(render_P(o)).length>0){if(!(0,react.isValidElement)(i)||Array.isArray(i)&&i.length>1)throw new Error(['Passing props on "Fragment"!',"",`The current component <${a} /> is rendering a "Fragment".`,"However we need to passthrough the following props:",Object.keys(o).map(p=>`  - ${p}`).join(`
`),"","You can apply a few solutions:",['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".',"Render a single element as the child so that we can forward the props onto that element."].map(p=>`  - ${p}`).join(`
`)].join(`
`));let d=class_names_e((y=i.props)==null?void 0:y.className,o.className),c=d?{className:d}:{};return (0,react.cloneElement)(i,Object.assign({},h(i.props,render_P(g(o,["ref"]))),u,f,O(i.ref,f.ref),c))}return (0,react.createElement)(s,Object.assign({},g(o,["ref"]),s!==react.Fragment&&f,s!==react.Fragment&&u),i)}function O(...r){return{ref:r.every(t=>t==null)?void 0:t=>{for(let e of r)e!=null&&(typeof e=="function"?e(t):e.current=t)}}}function h(...r){var a;if(r.length===0)return{};if(r.length===1)return r[0];let t={},e={};for(let s of r)for(let n in s)n.startsWith("on")&&typeof s[n]=="function"?((a=e[n])!=null||(e[n]=[]),e[n].push(s[n])):t[n]=s[n];if(t.disabled||t["aria-disabled"])return Object.assign(t,Object.fromEntries(Object.keys(e).map(s=>[s,void 0])));for(let s in e)Object.assign(t,{[s](n,...l){let o=e[s];for(let f of o){if((n instanceof Event||(n==null?void 0:n.nativeEvent)instanceof Event)&&n.defaultPrevented)return;f(n,...l)}}});return t}function L(r){var t;return Object.assign((0,react.forwardRef)(r),{displayName:(t=r.displayName)!=null?t:r.name})}function render_P(r){let t=Object.assign({},r);for(let e in t)t[e]===void 0&&delete t[e];return t}function g(r,t=[]){let e=Object.assign({},r);for(let a of t)a in e&&delete e[a];return e}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/internal/open-closed.js
let n=(0,react.createContext)(null);n.displayName="OpenClosedContext";var open_closed_d=(e=>(e[e.Open=1]="Open",e[e.Closed=2]="Closed",e[e.Closing=4]="Closing",e[e.Opening=8]="Opening",e))(open_closed_d||{});function C(){return (0,react.useContext)(n)}function open_closed_c({value:o,children:r}){return react.createElement(n.Provider,{value:o},r)}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/utils/env.js
var i=Object.defineProperty;var d=(t,e,n)=>e in t?i(t,e,{enumerable:!0,configurable:!0,writable:!0,value:n}):t[e]=n;var r=(t,e,n)=>(d(t,typeof e!="symbol"?e+"":e,n),n);class o{constructor(){r(this,"current",this.detect());r(this,"handoffState","pending");r(this,"currentId",0)}set(e){this.current!==e&&(this.handoffState="pending",this.currentId=0,this.current=e)}reset(){this.set(this.detect())}nextId(){return++this.currentId}get isServer(){return this.current==="server"}get isClient(){return this.current==="client"}detect(){return typeof window=="undefined"||typeof document=="undefined"?"server":"client"}handoff(){this.handoffState==="pending"&&(this.handoffState="complete")}get isHandoffComplete(){return this.handoffState==="complete"}}let env_s=new o;

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-iso-morphic-effect.js
let use_iso_morphic_effect_l=(e,f)=>{env_s.isServer?(0,react.useEffect)(e,f):(0,react.useLayoutEffect)(e,f)};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-is-mounted.js
function f(){let e=(0,react.useRef)(!1);return use_iso_morphic_effect_l(()=>(e.current=!0,()=>{e.current=!1}),[]),e}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-latest-value.js
function use_latest_value_s(e){let r=(0,react.useRef)(e);return use_iso_morphic_effect_l(()=>{r.current=e},[e]),r}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-server-handoff-complete.js
function use_server_handoff_complete_l(){let[e,f]=(0,react.useState)(env_s.isHandoffComplete);return e&&env_s.isHandoffComplete===!1&&f(!1),(0,react.useEffect)(()=>{e!==!0&&f(!0)},[e]),(0,react.useEffect)(()=>env_s.handoff(),[]),e}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-event.js
let use_event_o=function(t){let e=use_latest_value_s(t);return react.useCallback((...r)=>e.current(...r),[e])};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-sync-refs.js
let u=Symbol();function T(t,n=!0){return Object.assign(t,{[u]:n})}function use_sync_refs_y(...t){let n=(0,react.useRef)(t);(0,react.useEffect)(()=>{n.current=t},[t]);let c=use_event_o(e=>{for(let o of n.current)o!=null&&(typeof o=="function"?o(e):o.current=e)});return t.every(e=>e==null||(e==null?void 0:e[u]))?void 0:c}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/utils/once.js
function once_l(r){let e={called:!1};return(...t)=>{if(!e.called)return e.called=!0,r(...t)}}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/utils/micro-task.js
function micro_task_t(e){typeof queueMicrotask=="function"?queueMicrotask(e):Promise.resolve().then(e).catch(o=>setTimeout(()=>{throw o}))}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/utils/disposables.js
function disposables_o(){let n=[],r={addEventListener(e,t,s,a){return e.addEventListener(t,s,a),r.add(()=>e.removeEventListener(t,s,a))},requestAnimationFrame(...e){let t=requestAnimationFrame(...e);return r.add(()=>cancelAnimationFrame(t))},nextFrame(...e){return r.requestAnimationFrame(()=>r.requestAnimationFrame(...e))},setTimeout(...e){let t=setTimeout(...e);return r.add(()=>clearTimeout(t))},microTask(...e){let t={current:!0};return micro_task_t(()=>{t.current&&e[0]()}),r.add(()=>{t.current=!1})},style(e,t,s){let a=e.style.getPropertyValue(t);return Object.assign(e.style,{[t]:s}),this.add(()=>{Object.assign(e.style,{[t]:a})})},group(e){let t=disposables_o();return e(t),this.add(()=>t.dispose())},add(e){return n.push(e),()=>{let t=n.indexOf(e);if(t>=0)for(let s of n.splice(t,1))s()}},dispose(){for(let e of n.splice(0))e()}};return r}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/components/transitions/utils/transition.js
function transition_d(t,...e){t&&e.length>0&&t.classList.add(...e)}function v(t,...e){t&&e.length>0&&t.classList.remove(...e)}function F(t,e){let n=disposables_o();if(!t)return n.dispose;let{transitionDuration:m,transitionDelay:o}=getComputedStyle(t),[u,p]=[m,o].map(a=>{let[r=0]=a.split(",").filter(Boolean).map(i=>i.includes("ms")?parseFloat(i):parseFloat(i)*1e3).sort((i,f)=>f-i);return r}),l=u+p;if(l!==0){n.group(r=>{r.setTimeout(()=>{e(),r.dispose()},l),r.addEventListener(t,"transitionrun",i=>{i.target===i.currentTarget&&r.dispose()})});let a=n.addEventListener(t,"transitionend",r=>{r.target===r.currentTarget&&(e(),a())})}else e();return n.add(()=>e()),n.dispose}function y(t,e,n,m){let o=n?"enter":"leave",u=disposables_o(),p=m!==void 0?once_l(m):()=>{};o==="enter"&&(t.removeAttribute("hidden"),t.style.display="");let l=match_u(o,{enter:()=>e.enter,leave:()=>e.leave}),a=match_u(o,{enter:()=>e.enterTo,leave:()=>e.leaveTo}),r=match_u(o,{enter:()=>e.enterFrom,leave:()=>e.leaveFrom});return v(t,...e.enter,...e.enterTo,...e.enterFrom,...e.leave,...e.leaveFrom,...e.leaveTo,...e.entered),transition_d(t,...l,...r),u.nextFrame(()=>{v(t,...r),transition_d(t,...a),F(t,()=>(v(t,...l),transition_d(t,...e.entered),p()))}),u.dispose}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-disposables.js
function use_disposables_p(){let[e]=(0,react.useState)(disposables_o);return (0,react.useEffect)(()=>()=>e.dispose(),[e]),e}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-transition.js
function D({container:i,direction:t,classes:o,onStart:s,onStop:u}){let a=f(),c=use_disposables_p(),r=use_latest_value_s(t);use_iso_morphic_effect_l(()=>{let e=disposables_o();c.add(e.dispose);let n=i.current;if(n&&r.current!=="idle"&&a.current)return e.dispose(),s.current(r.current),e.add(y(n,o.current,r.current==="enter",()=>{e.dispose(),u.current(r.current)})),e.dispose},[t])}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-flags.js
function use_flags_b(g=0){let[t,l]=(0,react.useState)(g),u=(0,react.useCallback)(e=>l(a=>a|e),[t]),n=(0,react.useCallback)(e=>Boolean(t&e),[t]),o=(0,react.useCallback)(e=>l(a=>a&~e),[l]),s=(0,react.useCallback)(e=>l(a=>a^e),[l]);return{flags:t,addFlag:u,hasFlag:n,removeFlag:o,toggleFlag:s}}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/components/transitions/transition.js
function S(n=""){return n.split(" ").filter(t=>t.trim().length>1)}let A=(0,react.createContext)(null);A.displayName="TransitionContext";var Ee=(r=>(r.Visible="visible",r.Hidden="hidden",r))(Ee||{});function be(){let n=(0,react.useContext)(A);if(n===null)throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");return n}function Se(){let n=(0,react.useContext)(I);if(n===null)throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");return n}let I=(0,react.createContext)(null);I.displayName="NestingContext";function _(n){return"children"in n?_(n.children):n.current.filter(({el:t})=>t.current!==null).filter(({state:t})=>t==="visible").length>0}function ne(n,t){let r=use_latest_value_s(n),o=(0,react.useRef)([]),y=f(),N=use_disposables_p(),p=use_event_o((s,e=render_w.Hidden)=>{let a=o.current.findIndex(({el:i})=>i===s);a!==-1&&(match_u(e,{[render_w.Unmount](){o.current.splice(a,1)},[render_w.Hidden](){o.current[a].state="hidden"}}),N.microTask(()=>{var i;!_(o)&&y.current&&((i=r.current)==null||i.call(r))}))}),x=use_event_o(s=>{let e=o.current.find(({el:a})=>a===s);return e?e.state!=="visible"&&(e.state="visible"):o.current.push({el:s,state:"visible"}),()=>p(s,render_w.Unmount)}),m=(0,react.useRef)([]),c=(0,react.useRef)(Promise.resolve()),u=(0,react.useRef)({enter:[],leave:[],idle:[]}),h=use_event_o((s,e,a)=>{m.current.splice(0),t&&(t.chains.current[e]=t.chains.current[e].filter(([i])=>i!==s)),t==null||t.chains.current[e].push([s,new Promise(i=>{m.current.push(i)})]),t==null||t.chains.current[e].push([s,new Promise(i=>{Promise.all(u.current[e].map(([l,T])=>T)).then(()=>i())})]),e==="enter"?c.current=c.current.then(()=>t==null?void 0:t.wait.current).then(()=>a(e)):a(e)}),v=use_event_o((s,e,a)=>{Promise.all(u.current[e].splice(0).map(([i,l])=>l)).then(()=>{var i;(i=m.current.shift())==null||i()}).then(()=>a(e))});return (0,react.useMemo)(()=>({children:o,register:x,unregister:p,onStart:h,onStop:v,wait:c,chains:u}),[x,p,o,h,v,u,c])}function xe(){}let Pe=["beforeEnter","afterEnter","beforeLeave","afterLeave"];function re(n){var r;let t={};for(let o of Pe)t[o]=(r=n[o])!=null?r:xe;return t}function Re(n){let t=(0,react.useRef)(re(n));return (0,react.useEffect)(()=>{t.current=re(n)},[n]),t}let ye="div",ie=j.RenderStrategy;function Ne(n,t){let{beforeEnter:r,afterEnter:o,beforeLeave:y,afterLeave:N,enter:p,enterFrom:x,enterTo:m,entered:c,leave:u,leaveFrom:h,leaveTo:v,...s}=n,e=(0,react.useRef)(null),a=use_sync_refs_y(e,t),i=s.unmount?render_w.Unmount:render_w.Hidden,{show:l,appear:T,initial:se}=be(),[g,M]=(0,react.useState)(l?"visible":"hidden"),z=Se(),{register:F,unregister:L}=z,U=(0,react.useRef)(null);(0,react.useEffect)(()=>F(e),[F,e]),(0,react.useEffect)(()=>{if(i===render_w.Hidden&&e.current){if(l&&g!=="visible"){M("visible");return}return match_u(g,{["hidden"]:()=>L(e),["visible"]:()=>F(e)})}},[g,e,F,L,l,i]);let j=use_latest_value_s({enter:S(p),enterFrom:S(x),enterTo:S(m),entered:S(c),leave:S(u),leaveFrom:S(h),leaveTo:S(v)}),w=Re({beforeEnter:r,afterEnter:o,beforeLeave:y,afterLeave:N}),k=use_server_handoff_complete_l();(0,react.useEffect)(()=>{if(k&&g==="visible"&&e.current===null)throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?")},[e,g,k]);let G=se&&!T,ae=(()=>!k||G||U.current===l?"idle":l?"enter":"leave")(),H=use_flags_b(0),le=use_event_o(C=>match_u(C,{enter:()=>{H.addFlag(open_closed_d.Opening),w.current.beforeEnter()},leave:()=>{H.addFlag(open_closed_d.Closing),w.current.beforeLeave()},idle:()=>{}})),ue=use_event_o(C=>match_u(C,{enter:()=>{H.removeFlag(open_closed_d.Opening),w.current.afterEnter()},leave:()=>{H.removeFlag(open_closed_d.Closing),w.current.afterLeave()},idle:()=>{}})),O=ne(()=>{M("hidden"),L(e)},z);D({container:e,classes:j,direction:ae,onStart:use_latest_value_s(C=>{O.onStart(e,C,le)}),onStop:use_latest_value_s(C=>{O.onStop(e,C,ue),C==="leave"&&!_(O)&&(M("hidden"),L(e))})}),(0,react.useEffect)(()=>{G&&(i===render_w.Hidden?U.current=null:U.current=l)},[l,G,g]);let B=s,Te={ref:a};return T&&l&&env_s.isServer&&(B={...B,className:class_names_e(s.className,...j.current.enter,...j.current.enterFrom)}),react.createElement(I.Provider,{value:O},react.createElement(open_closed_c,{value:match_u(g,{["visible"]:open_closed_d.Open,["hidden"]:open_closed_d.Closed})|H.flags},render_D({ourProps:Te,theirProps:B,defaultTag:ye,features:ie,visible:g==="visible",name:"Transition.Child"})))}function He(n,t){let{show:r,appear:o=!1,unmount:y,...N}=n,p=(0,react.useRef)(null),x=use_sync_refs_y(p,t);use_server_handoff_complete_l();let m=C();if(r===void 0&&m!==null&&(r=(m&open_closed_d.Open)===open_closed_d.Open),![!0,!1].includes(r))throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");let[c,u]=(0,react.useState)(r?"visible":"hidden"),h=ne(()=>{u("hidden")}),[v,s]=(0,react.useState)(!0),e=(0,react.useRef)([r]);use_iso_morphic_effect_l(()=>{v!==!1&&e.current[e.current.length-1]!==r&&(e.current.push(r),s(!1))},[e,r]);let a=(0,react.useMemo)(()=>({show:r,appear:o,initial:v}),[r,o,v]);(0,react.useEffect)(()=>{if(r)u("visible");else if(!_(h))u("hidden");else{let l=p.current;if(!l)return;let T=l.getBoundingClientRect();T.x===0&&T.y===0&&T.width===0&&T.height===0&&u("hidden")}},[r,h]);let i={unmount:y};return react.createElement(I.Provider,{value:h},react.createElement(A.Provider,{value:a},render_D({ourProps:{...i,as:react.Fragment,children:react.createElement(oe,{ref:x,...i,...N})},theirProps:{},defaultTag:react.Fragment,features:ie,visible:c==="visible",name:"Transition"})))}function De(n,t){let r=(0,react.useContext)(A)!==null,o=C()!==null;return react.createElement(react.Fragment,null,!r&&o?react.createElement(q,{ref:t,...n}):react.createElement(oe,{ref:t,...n}))}let q=L(He),oe=L(Ne),Fe=L(De),tt=Object.assign(q,{Child:Fe,Root:q});

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/components/keyboard.js
var keyboard_o=(r=>(r.Space=" ",r.Enter="Enter",r.Escape="Escape",r.Backspace="Backspace",r.Delete="Delete",r.ArrowLeft="ArrowLeft",r.ArrowUp="ArrowUp",r.ArrowRight="ArrowRight",r.ArrowDown="ArrowDown",r.Home="Home",r.End="End",r.PageUp="PageUp",r.PageDown="PageDown",r.Tab="Tab",r))(keyboard_o||{});

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/utils/bugs.js
function bugs_r(n){let e=n.parentElement,l=null;for(;e&&!(e instanceof HTMLFieldSetElement);)e instanceof HTMLLegendElement&&(l=e),e=e.parentElement;let t=(e==null?void 0:e.getAttribute("disabled"))==="";return t&&bugs_i(l)?!1:t}function bugs_i(n){if(!n)return!1;let e=n.previousElementSibling;for(;e!==null;){if(e instanceof HTMLLegendElement)return!1;e=e.previousElementSibling}return!0}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-id.js
var use_id_o;let use_id_I=(use_id_o=react.useId)!=null?use_id_o:function(){let n=use_server_handoff_complete_l(),[e,u]=react.useState(n?()=>env_s.nextId():null);return use_iso_morphic_effect_l(()=>{e===null&&u(env_s.nextId())},[e]),e!=null?""+e:void 0};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/internal/hidden.js
let a="div";var hidden_p=(e=>(e[e.None=1]="None",e[e.Focusable=2]="Focusable",e[e.Hidden=4]="Hidden",e))(hidden_p||{});function s(t,o){let{features:n=1,...e}=t,d={ref:o,"aria-hidden":(n&2)===2?!0:void 0,style:{position:"fixed",top:1,left:1,width:1,height:0,padding:0,margin:-1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap",borderWidth:"0",...(n&4)===4&&(n&2)!==2&&{display:"none"}}};return render_D({ourProps:d,theirProps:e,slot:{},defaultTag:a,name:"Hidden"})}let hidden_c=L(s);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/utils/owner.js
function owner_e(r){return env_s.isServer?null:r instanceof Node?r.ownerDocument:r!=null&&r.hasOwnProperty("current")&&r.current instanceof Node?r.current.ownerDocument:document}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/utils/focus-management.js
let focus_management_f=["[contentEditable=true]","[tabindex]","a[href]","area[href]","button:not([disabled])","iframe","input:not([disabled])","select:not([disabled])","textarea:not([disabled])"].map(e=>`${e}:not([tabindex='-1'])`).join(",");var focus_management_L=(r=>(r[r.First=1]="First",r[r.Previous=2]="Previous",r[r.Next=4]="Next",r[r.Last=8]="Last",r[r.WrapAround=16]="WrapAround",r[r.NoScroll=32]="NoScroll",r))(focus_management_L||{}),N=(o=>(o[o.Error=0]="Error",o[o.Overflow=1]="Overflow",o[o.Success=2]="Success",o[o.Underflow=3]="Underflow",o))(N||{}),focus_management_T=(n=>(n[n.Previous=-1]="Previous",n[n.Next=1]="Next",n))(focus_management_T||{});function E(e=document.body){return e==null?[]:Array.from(e.querySelectorAll(focus_management_f)).sort((t,n)=>Math.sign((t.tabIndex||Number.MAX_SAFE_INTEGER)-(n.tabIndex||Number.MAX_SAFE_INTEGER)))}var focus_management_F=(n=>(n[n.Strict=0]="Strict",n[n.Loose=1]="Loose",n))(focus_management_F||{});function focus_management_h(e,t=0){var n;return e===((n=owner_e(e))==null?void 0:n.body)?!1:match_u(t,{[0](){return e.matches(focus_management_f)},[1](){let l=e;for(;l!==null;){if(l.matches(focus_management_f))return!0;l=l.parentElement}return!1}})}function focus_management_g(e){let t=m(e);b().nextFrame(()=>{t&&!focus_management_h(t.activeElement,0)&&focus_management_S(e)})}function focus_management_S(e){e==null||e.focus({preventScroll:!0})}let H=["textarea","input"].join(",");function w(e){var t,n;return(n=(t=e==null?void 0:e.matches)==null?void 0:t.call(e,H))!=null?n:!1}function focus_management_A(e,t=n=>n){return e.slice().sort((n,l)=>{let o=t(n),i=t(l);if(o===null||i===null)return 0;let r=o.compareDocumentPosition(i);return r&Node.DOCUMENT_POSITION_FOLLOWING?-1:r&Node.DOCUMENT_POSITION_PRECEDING?1:0})}function focus_management_v(e,t){return focus_management_I(E(),t,{relativeTo:e})}function focus_management_I(e,t,{sorted:n=!0,relativeTo:l=null,skipElements:o=[]}={}){let i=Array.isArray(e)?e.length>0?e[0].ownerDocument:document:e.ownerDocument,r=Array.isArray(e)?n?focus_management_A(e):e:E(e);o.length>0&&r.length>1&&(r=r.filter(s=>!o.includes(s))),l=l!=null?l:i.activeElement;let d=(()=>{if(t&5)return 1;if(t&10)return-1;throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last")})(),x=(()=>{if(t&1)return 0;if(t&2)return Math.max(0,r.indexOf(l))-1;if(t&4)return Math.max(0,r.indexOf(l))+1;if(t&8)return r.length-1;throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last")})(),p=t&32?{preventScroll:!0}:{},c=0,a=r.length,u;do{if(c>=a||c+a<=0)return 0;let s=x+c;if(t&16)s=(s+a)%a;else{if(s<0)return 3;if(s>=a)return 1}u=r[s],u==null||u.focus(p),c+=d}while(u!==i.activeElement);return t&6&&w(u)&&u.select(),u.hasAttribute("tabindex")||u.setAttribute("tabindex","0"),2}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-window-event.js
function use_window_event_s(e,r,n){let o=use_latest_value_s(r);(0,react.useEffect)(()=>{function t(i){o.current(i)}return window.addEventListener(e,t,n),()=>window.removeEventListener(e,t,n)},[e,n])}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-tab-direction.js
var use_tab_direction_s=(r=>(r[r.Forwards=0]="Forwards",r[r.Backwards=1]="Backwards",r))(use_tab_direction_s||{});function use_tab_direction_n(){let e=(0,react.useRef)(0);return use_window_event_s("keydown",o=>{o.key==="Tab"&&(e.current=o.shiftKey?1:0)},!0),e}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-owner.js
function use_owner_n(...e){return (0,react.useMemo)(()=>owner_e(...e),[...e])}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-event-listener.js
function use_event_listener_E(n,e,a,t){let i=use_latest_value_s(a);(0,react.useEffect)(()=>{n=n!=null?n:window;function r(o){i.current(o)}return n.addEventListener(e,r,t),()=>n.removeEventListener(e,r,t)},[n,e,t])}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-watch.js
function use_watch_m(u,t){let e=(0,react.useRef)([]),r=use_event_o(u);(0,react.useEffect)(()=>{let o=[...e.current];for(let[n,a]of t.entries())if(e.current[n]!==a){let l=r(t,o);return e.current=t,l}},[r,...t])}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/components/focus-trap/focus-trap.js
function P(t){if(!t)return new Set;if(typeof t=="function")return new Set(t());let n=new Set;for(let e of t.current)e.current instanceof HTMLElement&&n.add(e.current);return n}let J="div";var focus_trap_h=(r=>(r[r.None=1]="None",r[r.InitialFocus=2]="InitialFocus",r[r.TabLock=4]="TabLock",r[r.FocusLock=8]="FocusLock",r[r.RestoreFocus=16]="RestoreFocus",r[r.All=30]="All",r))(focus_trap_h||{});function X(t,n){let e=(0,react.useRef)(null),o=use_sync_refs_y(e,n),{initialFocus:u,containers:i,features:r=30,...l}=t;use_server_handoff_complete_l()||(r=1);let m=use_owner_n(e);Q({ownerDocument:m},Boolean(r&16));let c=Y({ownerDocument:m,container:e,initialFocus:u},Boolean(r&2));Z({ownerDocument:m,container:e,containers:i,previousActiveElement:c},Boolean(r&8));let v=use_tab_direction_n(),R=use_event_o(s=>{let T=e.current;if(!T)return;(B=>B())(()=>{match_u(v.current,{[use_tab_direction_s.Forwards]:()=>{focus_management_I(T,focus_management_L.First,{skipElements:[s.relatedTarget]})},[use_tab_direction_s.Backwards]:()=>{focus_management_I(T,focus_management_L.Last,{skipElements:[s.relatedTarget]})}})})}),_=use_disposables_p(),H=(0,react.useRef)(!1),j={ref:o,onKeyDown(s){s.key=="Tab"&&(H.current=!0,_.requestAnimationFrame(()=>{H.current=!1}))},onBlur(s){let T=P(i);e.current instanceof HTMLElement&&T.add(e.current);let E=s.relatedTarget;E instanceof HTMLElement&&E.dataset.headlessuiFocusGuard!=="true"&&(focus_trap_S(T,E)||(H.current?focus_management_I(e.current,match_u(v.current,{[use_tab_direction_s.Forwards]:()=>focus_management_L.Next,[use_tab_direction_s.Backwards]:()=>focus_management_L.Previous})|focus_management_L.WrapAround,{relativeTo:s.target}):s.target instanceof HTMLElement&&focus_management_S(s.target)))}};return react.createElement(react.Fragment,null,Boolean(r&4)&&react.createElement(hidden_c,{as:"button",type:"button","data-headlessui-focus-guard":!0,onFocus:R,features:hidden_p.Focusable}),render_D({ourProps:j,theirProps:l,defaultTag:J,name:"FocusTrap"}),Boolean(r&4)&&react.createElement(hidden_c,{as:"button",type:"button","data-headlessui-focus-guard":!0,onFocus:R,features:hidden_p.Focusable}))}let z=L(X),focus_trap_ye=Object.assign(z,{features:focus_trap_h}),focus_trap_a=[];if(typeof window!="undefined"&&typeof document!="undefined"){let t=function(n){n.target instanceof HTMLElement&&n.target!==document.body&&focus_trap_a[0]!==n.target&&(focus_trap_a.unshift(n.target),focus_trap_a=focus_trap_a.filter(e=>e!=null&&e.isConnected),focus_trap_a.splice(10))};var handle=t;window.addEventListener("click",t,{capture:!0}),window.addEventListener("mousedown",t,{capture:!0}),window.addEventListener("focus",t,{capture:!0}),document.body.addEventListener("click",t,{capture:!0}),document.body.addEventListener("mousedown",t,{capture:!0}),document.body.addEventListener("focus",t,{capture:!0})}function focus_trap_D(t=!0){let n=(0,react.useRef)(focus_trap_a.slice());return use_watch_m(([e],[o])=>{o===!0&&e===!1&&micro_task_t(()=>{n.current.splice(0)}),o===!1&&e===!0&&(n.current=focus_trap_a.slice())},[t,focus_trap_a,n]),use_event_o(()=>{var e;return(e=n.current.find(o=>o!=null&&o.isConnected))!=null?e:null})}function Q({ownerDocument:t},n){let e=focus_trap_D(n);use_watch_m(()=>{n||(t==null?void 0:t.activeElement)===(t==null?void 0:t.body)&&focus_management_S(e())},[n]);let o=(0,react.useRef)(!1);(0,react.useEffect)(()=>(o.current=!1,()=>{o.current=!0,micro_task_t(()=>{o.current&&focus_management_S(e())})}),[])}function Y({ownerDocument:t,container:n,initialFocus:e},o){let u=(0,react.useRef)(null),i=f();return use_watch_m(()=>{if(!o)return;let r=n.current;r&&micro_task_t(()=>{if(!i.current)return;let l=t==null?void 0:t.activeElement;if(e!=null&&e.current){if((e==null?void 0:e.current)===l){u.current=l;return}}else if(r.contains(l)){u.current=l;return}e!=null&&e.current?focus_management_S(e.current):focus_management_I(r,focus_management_L.First)===N.Error&&console.warn("There are no focusable elements inside the <FocusTrap />"),u.current=t==null?void 0:t.activeElement})},[o]),u}function Z({ownerDocument:t,container:n,containers:e,previousActiveElement:o},u){let i=f();use_event_listener_E(t==null?void 0:t.defaultView,"focus",r=>{if(!u||!i.current)return;let l=P(e);n.current instanceof HTMLElement&&l.add(n.current);let m=o.current;if(!m)return;let c=r.target;c&&c instanceof HTMLElement?focus_trap_S(l,c)?(o.current=c,focus_management_S(c)):(r.preventDefault(),r.stopPropagation(),focus_management_S(m)):focus_management_S(o.current)},!0)}function focus_trap_S(t,n){for(let e of t)if(e.contains(n))return!0;return!1}

// EXTERNAL MODULE: ./node_modules/.pnpm/react-dom@18.2.0_react@18.2.0/node_modules/react-dom/index.js
var react_dom = __webpack_require__(10422);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/internal/portal-force-root.js
let e=(0,react.createContext)(!1);function portal_force_root_l(){return (0,react.useContext)(e)}function portal_force_root_P(o){return react.createElement(e.Provider,{value:o.force},o.children)}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/components/portal/portal.js
function portal_H(u){let a=portal_force_root_l(),o=(0,react.useContext)(c),e=use_owner_n(u),[l,n]=(0,react.useState)(()=>{if(!a&&o!==null||env_s.isServer)return null;let t=e==null?void 0:e.getElementById("headlessui-portal-root");if(t)return t;if(e===null)return null;let r=e.createElement("div");return r.setAttribute("id","headlessui-portal-root"),e.body.appendChild(r)});return (0,react.useEffect)(()=>{l!==null&&(e!=null&&e.body.contains(l)||e==null||e.body.appendChild(l))},[l,e]),(0,react.useEffect)(()=>{a||o!==null&&n(o.current)},[o,n,a]),l}let portal_O=react.Fragment;function portal_(u,a){let o=u,e=(0,react.useRef)(null),l=use_sync_refs_y(T(p=>{e.current=p}),a),n=use_owner_n(e),t=portal_H(e),[r]=(0,react.useState)(()=>{var p;return env_s.isServer?null:(p=n==null?void 0:n.createElement("div"))!=null?p:null}),y=use_server_handoff_complete_l(),f=(0,react.useRef)(!1);return use_iso_morphic_effect_l(()=>{if(f.current=!1,!(!t||!r))return t.contains(r)||(r.setAttribute("data-headlessui-portal",""),t.appendChild(r)),()=>{f.current=!0,micro_task_t(()=>{var p;f.current&&(!t||!r||(r instanceof Node&&t.contains(r)&&t.removeChild(r),t.childNodes.length<=0&&((p=t.parentElement)==null||p.removeChild(t))))})}},[t,r]),y?!t||!r?null:(0,react_dom.createPortal)(render_D({ourProps:{ref:l},theirProps:o,defaultTag:portal_O,name:"Portal"}),r):null}let portal_F=react.Fragment,c=(0,react.createContext)(null);function U(u,a){let{target:o,...e}=u,n={ref:use_sync_refs_y(a)};return react.createElement(c.Provider,{value:o},render_D({ourProps:n,theirProps:e,defaultTag:portal_F,name:"Popover.Group"}))}let portal_S=L(portal_),portal_j=L(U),portal_te=Object.assign(portal_S,{Group:portal_j});

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/components/description/description.js
let description_d=(0,react.createContext)(null);function description_f(){let r=(0,react.useContext)(description_d);if(r===null){let t=new Error("You used a <Description /> component, but it is not inside a relevant parent.");throw Error.captureStackTrace&&Error.captureStackTrace(t,description_f),t}return r}function M(){let[r,t]=(0,react.useState)([]);return[r.length>0?r.join(" "):void 0,(0,react.useMemo)(()=>function(e){let i=use_event_o(s=>(t(o=>[...o,s]),()=>t(o=>{let p=o.slice(),c=p.indexOf(s);return c!==-1&&p.splice(c,1),p}))),n=(0,react.useMemo)(()=>({register:i,slot:e.slot,name:e.name,props:e.props}),[i,e.slot,e.name,e.props]);return react.createElement(description_d.Provider,{value:n},e.children)},[t])]}let description_S="p";function description_h(r,t){let a=use_id_I(),{id:e=`headlessui-description-${a}`,...i}=r,n=description_f(),s=use_sync_refs_y(t);use_iso_morphic_effect_l(()=>n.register(e),[e,n.register]);let o={ref:s,...n.props,id:e};return render_D({ourProps:o,theirProps:i,slot:n.slot||{},defaultTag:description_S,name:n.name||"Description"})}let description_y=L(description_h),description_b=Object.assign(description_y,{});

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/internal/stack-context.js
let stack_context_a=(0,react.createContext)(()=>{});stack_context_a.displayName="StackContext";var stack_context_s=(e=>(e[e.Add=0]="Add",e[e.Remove=1]="Remove",e))(stack_context_s||{});function x(){return (0,react.useContext)(stack_context_a)}function stack_context_M({children:i,onUpdate:r,type:e,element:n,enabled:u}){let l=x(),o=use_event_o((...t)=>{r==null||r(...t),l(...t)});return use_iso_morphic_effect_l(()=>{let t=u===void 0||u===!0;return t&&o(0,e,n),()=>{t&&o(1,e,n)}},[o,e,n,u]),react.createElement(stack_context_a.Provider,{value:o},i)}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-document-event.js
function use_document_event_d(e,r,n){let o=use_latest_value_s(r);(0,react.useEffect)(()=>{function t(u){o.current(u)}return document.addEventListener(e,t,n),()=>document.removeEventListener(e,t,n)},[e,n])}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-outside-click.js
function use_outside_click_L(m,E,c=!0){let i=(0,react.useRef)(!1);(0,react.useEffect)(()=>{requestAnimationFrame(()=>{i.current=c})},[c]);function f(e,o){if(!i.current||e.defaultPrevented)return;let l=function r(t){return typeof t=="function"?r(t()):Array.isArray(t)||t instanceof Set?t:[t]}(m),n=o(e);if(n!==null&&n.getRootNode().contains(n)){for(let r of l){if(r===null)continue;let t=r instanceof HTMLElement?r:r.current;if(t!=null&&t.contains(n)||e.composed&&e.composedPath().includes(t))return}return!focus_management_h(n,focus_management_F.Loose)&&n.tabIndex!==-1&&e.preventDefault(),E(e,n)}}let u=(0,react.useRef)(null);use_document_event_d("mousedown",e=>{var o,l;i.current&&(u.current=((l=(o=e.composedPath)==null?void 0:o.call(e))==null?void 0:l[0])||e.target)},!0),use_document_event_d("click",e=>{u.current&&(f(e,()=>u.current),u.current=null)},!0),use_document_event_d("blur",e=>f(e,()=>window.document.activeElement instanceof HTMLIFrameElement?window.document.activeElement:null),!0)}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/use-sync-external-store-shim/useSyncExternalStoreShimClient.js
function useSyncExternalStoreShimClient_i(e,t){return e===t&&(e!==0||1/e===1/t)||e!==e&&t!==t}const useSyncExternalStoreShimClient_d=typeof Object.is=="function"?Object.is:useSyncExternalStoreShimClient_i,{useState:useSyncExternalStoreShimClient_u,useEffect:useSyncExternalStoreShimClient_h,useLayoutEffect:useSyncExternalStoreShimClient_f,useDebugValue:p}=react_namespaceObject;let useSyncExternalStoreShimClient_S=(/* unused pure expression or super */ null && (!1)),useSyncExternalStoreShimClient_=(/* unused pure expression or super */ null && (!1));function useSyncExternalStoreShimClient_y(e,t,c){const a=t(),[{inst:n},o]=useSyncExternalStoreShimClient_u({inst:{value:a,getSnapshot:t}});return useSyncExternalStoreShimClient_f(()=>{n.value=a,n.getSnapshot=t,useSyncExternalStoreShimClient_r(n)&&o({inst:n})},[e,a,t]),useSyncExternalStoreShimClient_h(()=>(useSyncExternalStoreShimClient_r(n)&&o({inst:n}),e(()=>{useSyncExternalStoreShimClient_r(n)&&o({inst:n})})),[e]),p(a),a}function useSyncExternalStoreShimClient_r(e){const t=e.getSnapshot,c=e.value;try{const a=t();return!useSyncExternalStoreShimClient_d(c,a)}catch{return!0}}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/use-sync-external-store-shim/useSyncExternalStoreShimServer.js
function t(r,e,n){return e()}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/use-sync-external-store-shim/index.js
const use_sync_external_store_shim_r=typeof window!="undefined"&&typeof window.document!="undefined"&&typeof window.document.createElement!="undefined",use_sync_external_store_shim_s=!use_sync_external_store_shim_r,use_sync_external_store_shim_c=use_sync_external_store_shim_s?t:useSyncExternalStoreShimClient_y,use_sync_external_store_shim_a= true?(n=>n.useSyncExternalStore)(react_namespaceObject):use_sync_external_store_shim_c;

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-store.js
function use_store_S(t){return use_sync_external_store_shim_a(t.subscribe,t.getSnapshot,t.getSnapshot)}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/utils/store.js
function store_a(o,r){let t=o(),n=new Set;return{getSnapshot(){return t},subscribe(e){return n.add(e),()=>n.delete(e)},dispatch(e,...s){let i=r[e].call(t,...s);i&&(t=i,n.forEach(c=>c()))}}}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/document-overflow/adjust-scrollbar-padding.js
function adjust_scrollbar_padding_c(){let o;return{before({doc:e}){var l;let n=e.documentElement;o=((l=e.defaultView)!=null?l:window).innerWidth-n.clientWidth},after({doc:e,d:n}){let t=e.documentElement,l=t.clientWidth-t.offsetWidth,r=o-l;n.style(t,"paddingRight",`${r}px`)}}}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/utils/platform.js
function platform_t(){return/iPhone/gi.test(window.navigator.platform)||/Mac/gi.test(window.navigator.platform)&&window.navigator.maxTouchPoints>0}function platform_i(){return/Android/gi.test(window.navigator.userAgent)}function platform_n(){return platform_t()||platform_i()}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/document-overflow/handle-ios-locking.js
function handle_ios_locking_p(){if(!platform_t())return{};let o;return{before(){o=window.pageYOffset},after({doc:r,d:l,meta:s}){function i(e){return s.containers.flatMap(t=>t()).some(t=>t.contains(e))}l.style(r.body,"marginTop",`-${o}px`),window.scrollTo(0,0);let n=null;l.addEventListener(r,"click",e=>{if(e.target instanceof HTMLElement)try{let t=e.target.closest("a");if(!t)return;let{hash:c}=new URL(t.href),a=r.querySelector(c);a&&!i(a)&&(n=a)}catch{}},!0),l.addEventListener(r,"touchmove",e=>{e.target instanceof HTMLElement&&!i(e.target)&&e.preventDefault()},{passive:!1}),l.add(()=>{window.scrollTo(0,window.pageYOffset+o),n&&n.isConnected&&(n.scrollIntoView({block:"nearest"}),n=null)})}}}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/document-overflow/prevent-scroll.js
function l(){return{before({doc:e,d:o}){o.style(e.documentElement,"overflow","hidden")}}}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/document-overflow/overflow-store.js
function overflow_store_m(e){let n={};for(let t of e)Object.assign(n,t(n));return n}let overflow_store_a=store_a(()=>new Map,{PUSH(e,n){var o;let t=(o=this.get(e))!=null?o:{doc:e,count:0,d:disposables_o(),meta:new Set};return t.count++,t.meta.add(n),this.set(e,t),this},POP(e,n){let t=this.get(e);return t&&(t.count--,t.meta.delete(n)),this},SCROLL_PREVENT({doc:e,d:n,meta:t}){let o={doc:e,d:n,meta:overflow_store_m(t)},c=[handle_ios_locking_p(),adjust_scrollbar_padding_c(),l()];c.forEach(({before:r})=>r==null?void 0:r(o)),c.forEach(({after:r})=>r==null?void 0:r(o))},SCROLL_ALLOW({d:e}){e.dispose()},TEARDOWN({doc:e}){this.delete(e)}});overflow_store_a.subscribe(()=>{let e=overflow_store_a.getSnapshot(),n=new Map;for(let[t]of e)n.set(t,t.documentElement.style.overflow);for(let t of e.values()){let o=n.get(t.doc)==="hidden",c=t.count!==0;(c&&!o||!c&&o)&&overflow_store_a.dispatch(t.count>0?"SCROLL_PREVENT":"SCROLL_ALLOW",t),t.count===0&&overflow_store_a.dispatch("TEARDOWN",t)}});

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/document-overflow/use-document-overflow.js
function use_document_overflow_p(e,r,n){let f=use_store_S(overflow_store_a),o=e?f.get(e):void 0,i=o?o.count>0:!1;return use_iso_morphic_effect_l(()=>{if(!(!e||!r))return overflow_store_a.dispatch("PUSH",e,n),()=>overflow_store_a.dispatch("POP",e,n)},[r,e]),i}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-inert.js
let use_inert_u=new Map,use_inert_t=new Map;function use_inert_h(r,l=!0){use_iso_morphic_effect_l(()=>{var o;if(!l)return;let e=typeof r=="function"?r():r.current;if(!e)return;function a(){var d;if(!e)return;let i=(d=use_inert_t.get(e))!=null?d:1;if(i===1?use_inert_t.delete(e):use_inert_t.set(e,i-1),i!==1)return;let n=use_inert_u.get(e);n&&(n["aria-hidden"]===null?e.removeAttribute("aria-hidden"):e.setAttribute("aria-hidden",n["aria-hidden"]),e.inert=n.inert,use_inert_u.delete(e))}let f=(o=use_inert_t.get(e))!=null?o:0;return use_inert_t.set(e,f+1),f!==0||(use_inert_u.set(e,{"aria-hidden":e.getAttribute("aria-hidden"),inert:e.inert}),e.setAttribute("aria-hidden","true"),e.inert=!0),a},[r,l])}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/components/dialog/dialog.js
var dialog_Se=(o=>(o[o.Open=0]="Open",o[o.Closed=1]="Closed",o))(dialog_Se||{}),dialog_Fe=(e=>(e[e.SetTitleId=0]="SetTitleId",e))(dialog_Fe||{});let ke={[0](t,e){return t.titleId===e.id?t:{...t,titleId:e.id}}},dialog_M=(0,react.createContext)(null);dialog_M.displayName="DialogContext";function dialog_S(t){let e=(0,react.useContext)(dialog_M);if(e===null){let o=new Error(`<${t} /> is missing a parent <Dialog /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(o,dialog_S),o}return e}function dialog_xe(t,e,o=()=>[document.body]){use_document_overflow_p(t,e,s=>{var n;return{containers:[...(n=s.containers)!=null?n:[],o]}})}function _e(t,e){return match_u(e.type,ke,t,e)}let Me="div",dialog_He=j.RenderStrategy|j.Static;function Ie(t,e){let o=use_id_I(),{id:s=`headlessui-dialog-${o}`,open:n,onClose:l,initialFocus:d,__demoMode:c=!1,...D}=t,[P,F]=(0,react.useState)(0),i=C();n===void 0&&i!==null&&(n=(i&open_closed_d.Open)===open_closed_d.Open);let m=(0,react.useRef)(null),Q=use_sync_refs_y(m,e),y=(0,react.useRef)(null),p=use_owner_n(m),U=t.hasOwnProperty("open")||i!==null,N=t.hasOwnProperty("onClose");if(!U&&!N)throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");if(!U)throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");if(!N)throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");if(typeof n!="boolean")throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${n}`);if(typeof l!="function")throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${l}`);let u=n?0:1,[E,Z]=(0,react.useReducer)(_e,{titleId:null,descriptionId:null,panelRef:(0,react.createRef)()}),A=use_event_o(()=>l(!1)),Y=use_event_o(r=>Z({type:0,id:r})),k=use_server_handoff_complete_l()?c?!1:u===0:!1,x=P>1,$=(0,react.useContext)(dialog_M)!==null,ee=x?"parent":"leaf",W=i!==null?(i&open_closed_d.Closing)===open_closed_d.Closing:!1,te=(()=>$||W?!1:k)(),oe=(0,react.useCallback)(()=>{var r,f;return(f=Array.from((r=p==null?void 0:p.querySelectorAll("body > *"))!=null?r:[]).find(a=>a.id==="headlessui-portal-root"?!1:a.contains(y.current)&&a instanceof HTMLElement))!=null?f:null},[y]);use_inert_h(oe,te);let re=(()=>x?!0:k)(),ne=(0,react.useCallback)(()=>{var r,f;return(f=Array.from((r=p==null?void 0:p.querySelectorAll("[data-headlessui-portal]"))!=null?r:[]).find(a=>a.contains(y.current)&&a instanceof HTMLElement))!=null?f:null},[y]);use_inert_h(ne,re);let H=use_event_o(()=>{var f,a;return[...Array.from((f=p==null?void 0:p.querySelectorAll("html > *, body > *, [data-headlessui-portal]"))!=null?f:[]).filter(T=>!(T===document.body||T===document.head||!(T instanceof HTMLElement)||T.contains(y.current)||E.panelRef.current&&T.contains(E.panelRef.current))),(a=E.panelRef.current)!=null?a:m.current]}),le=(()=>!(!k||x))();use_outside_click_L(()=>H(),A,le);let ae=(()=>!(x||u!==0))();use_event_listener_E(p==null?void 0:p.defaultView,"keydown",r=>{ae&&(r.defaultPrevented||r.key===keyboard_o.Escape&&(r.preventDefault(),r.stopPropagation(),A()))});let ie=(()=>!(W||u!==0||$))();dialog_xe(p,ie,H),(0,react.useEffect)(()=>{if(u!==0||!m.current)return;let r=new ResizeObserver(f=>{for(let a of f){let T=a.target.getBoundingClientRect();T.x===0&&T.y===0&&T.width===0&&T.height===0&&A()}});return r.observe(m.current),()=>r.disconnect()},[u,m,A]);let[se,pe]=M(),de=(0,react.useMemo)(()=>[{dialogState:u,close:A,setTitleId:Y},E],[u,E,A,Y]),J=(0,react.useMemo)(()=>({open:u===0}),[u]),ue={ref:Q,id:s,role:"dialog","aria-modal":u===0?!0:void 0,"aria-labelledby":E.titleId,"aria-describedby":se};return react.createElement(stack_context_M,{type:"Dialog",enabled:u===0,element:m,onUpdate:use_event_o((r,f)=>{f==="Dialog"&&match_u(r,{[stack_context_s.Add]:()=>F(a=>a+1),[stack_context_s.Remove]:()=>F(a=>a-1)})})},react.createElement(portal_force_root_P,{force:!0},react.createElement(portal_te,null,react.createElement(dialog_M.Provider,{value:de},react.createElement(portal_te.Group,{target:m},react.createElement(portal_force_root_P,{force:!1},react.createElement(pe,{slot:J,name:"Dialog.Description"},react.createElement(focus_trap_ye,{initialFocus:d,containers:H,features:k?match_u(ee,{parent:focus_trap_ye.features.RestoreFocus,leaf:focus_trap_ye.features.All&~focus_trap_ye.features.FocusLock}):focus_trap_ye.features.None},render_D({ourProps:ue,theirProps:D,slot:J,defaultTag:Me,features:dialog_He,visible:u===0,name:"Dialog"})))))))),react.createElement(hidden_c,{features:hidden_p.Hidden,ref:y}))}let we="div";function Be(t,e){let o=use_id_I(),{id:s=`headlessui-dialog-overlay-${o}`,...n}=t,[{dialogState:l,close:d}]=dialog_S("Dialog.Overlay"),c=use_sync_refs_y(e),D=use_event_o(i=>{if(i.target===i.currentTarget){if(bugs_r(i.currentTarget))return i.preventDefault();i.preventDefault(),i.stopPropagation(),d()}}),P=(0,react.useMemo)(()=>({open:l===0}),[l]);return render_D({ourProps:{ref:c,id:s,"aria-hidden":!0,onClick:D},theirProps:n,slot:P,defaultTag:we,name:"Dialog.Overlay"})}let Ge="div";function Ue(t,e){let o=use_id_I(),{id:s=`headlessui-dialog-backdrop-${o}`,...n}=t,[{dialogState:l},d]=dialog_S("Dialog.Backdrop"),c=use_sync_refs_y(e);(0,react.useEffect)(()=>{if(d.panelRef.current===null)throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.")},[d.panelRef]);let D=(0,react.useMemo)(()=>({open:l===0}),[l]);return react.createElement(portal_force_root_P,{force:!0},react.createElement(portal_te,null,render_D({ourProps:{ref:c,id:s,"aria-hidden":!0},theirProps:n,slot:D,defaultTag:Ge,name:"Dialog.Backdrop"})))}let dialog_Ne="div";function Ye(t,e){let o=use_id_I(),{id:s=`headlessui-dialog-panel-${o}`,...n}=t,[{dialogState:l},d]=dialog_S("Dialog.Panel"),c=use_sync_refs_y(e,d.panelRef),D=(0,react.useMemo)(()=>({open:l===0}),[l]),P=use_event_o(i=>{i.stopPropagation()});return render_D({ourProps:{ref:c,id:s,onClick:P},theirProps:n,slot:D,defaultTag:dialog_Ne,name:"Dialog.Panel"})}let $e="h2";function We(t,e){let o=use_id_I(),{id:s=`headlessui-dialog-title-${o}`,...n}=t,[{dialogState:l,setTitleId:d}]=dialog_S("Dialog.Title"),c=use_sync_refs_y(e);(0,react.useEffect)(()=>(d(s),()=>d(null)),[s,d]);let D=(0,react.useMemo)(()=>({open:l===0}),[l]);return render_D({ourProps:{ref:c,id:s},theirProps:n,slot:D,defaultTag:$e,name:"Dialog.Title"})}let Je=L(Ie),Xe=L(Ue),je=L(Ye),Ke=L(Be),Ve=L(We),St=Object.assign(Je,{Backdrop:Xe,Panel:je,Overlay:Ke,Title:Ve,Description:description_b});

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-computed.js
function use_computed_i(e,o){let[u,t]=(0,react.useState)(e),r=use_latest_value_s(e);return use_iso_morphic_effect_l(()=>t(r.current),[r,t,...o]),u}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/utils/calculate-active-index.js
function calculate_active_index_f(r){throw new Error("Unexpected object: "+r)}var calculate_active_index_a=(e=>(e[e.First=0]="First",e[e.Previous=1]="Previous",e[e.Next=2]="Next",e[e.Last=3]="Last",e[e.Specific=4]="Specific",e[e.Nothing=5]="Nothing",e))(calculate_active_index_a||{});function calculate_active_index_x(r,n){let t=n.resolveItems();if(t.length<=0)return null;let l=n.resolveActiveIndex(),s=l!=null?l:-1,d=(()=>{switch(r.focus){case 0:return t.findIndex(e=>!n.resolveDisabled(e));case 1:{let e=t.slice().reverse().findIndex((i,c,u)=>s!==-1&&u.length-c-1>=s?!1:!n.resolveDisabled(i));return e===-1?e:t.length-1-e}case 2:return t.findIndex((e,i)=>i<=s?!1:!n.resolveDisabled(e));case 3:{let e=t.slice().reverse().findIndex(i=>!n.resolveDisabled(i));return e===-1?e:t.length-1-e}case 4:return t.findIndex(e=>n.resolveId(e)===r.id);case 5:return null;default:calculate_active_index_f(r)}})();return d===-1?l:d}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-resolve-button-type.js
function use_resolve_button_type_i(t){var n;if(t.type)return t.type;let e=(n=t.as)!=null?n:"button";if(typeof e=="string"&&e.toLowerCase()==="button")return"button"}function use_resolve_button_type_s(t,e){let[n,u]=(0,react.useState)(()=>use_resolve_button_type_i(t));return use_iso_morphic_effect_l(()=>{u(use_resolve_button_type_i(t))},[t.type,t.as]),use_iso_morphic_effect_l(()=>{n||e.current&&e.current instanceof HTMLButtonElement&&!e.current.hasAttribute("type")&&u("button")},[n,e]),n}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/utils/form.js
function form_e(n={},r=null,t=[]){for(let[i,o]of Object.entries(n))form_f(t,form_s(r,i),o);return t}function form_s(n,r){return n?n+"["+r+"]":r}function form_f(n,r,t){if(Array.isArray(t))for(let[i,o]of t.entries())form_f(n,form_s(r,i.toString()),o);else t instanceof Date?n.push([r,t.toISOString()]):typeof t=="boolean"?n.push([r,t?"1":"0"]):typeof t=="string"?n.push([r,t]):typeof t=="number"?n.push([r,`${t}`]):t==null?n.push([r,""]):form_e(t,r,n)}function form_p(n){var t;let r=(t=n==null?void 0:n.form)!=null?t:n.closest("form");if(r){for(let i of r.elements)if(i.tagName==="INPUT"&&i.type==="submit"||i.tagName==="BUTTON"&&i.type==="submit"||i.nodeName==="INPUT"&&i.type==="image"){i.click();return}}}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-controllable.js
function use_controllable_T(l,r,c){let[i,s]=(0,react.useState)(c),e=l!==void 0,t=(0,react.useRef)(e),u=(0,react.useRef)(!1),d=(0,react.useRef)(!1);return e&&!t.current&&!u.current?(u.current=!0,t.current=e,console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")):!e&&t.current&&!d.current&&(d.current=!0,t.current=e,console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")),[e?l:i,use_event_o(n=>(e||s(n),r==null?void 0:r(n)))]}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-tracked-pointer.js
function use_tracked_pointer_t(e){return[e.screenX,e.screenY]}function use_tracked_pointer_u(){let e=(0,react.useRef)([-1,-1]);return{wasMoved(r){let n=use_tracked_pointer_t(r);return e.current[0]===n[0]&&e.current[1]===n[1]?!1:(e.current=n,!0)},update(r){e.current=use_tracked_pointer_t(r)}}}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/components/listbox/listbox.js
var listbox_e=(o=>(o[o.Open=0]="Open",o[o.Closed=1]="Closed",o))(listbox_e||{}),listbox_Ue=(o=>(o[o.Single=0]="Single",o[o.Multi=1]="Multi",o))(listbox_Ue||{}),listbox_Be=(o=>(o[o.Pointer=0]="Pointer",o[o.Other=1]="Other",o))(listbox_Be||{}),listbox_He=(i=>(i[i.OpenListbox=0]="OpenListbox",i[i.CloseListbox=1]="CloseListbox",i[i.GoToOption=2]="GoToOption",i[i.Search=3]="Search",i[i.ClearSearch=4]="ClearSearch",i[i.RegisterOption=5]="RegisterOption",i[i.UnregisterOption=6]="UnregisterOption",i[i.RegisterLabel=7]="RegisterLabel",i))(listbox_He||{});function $(e,r=o=>o){let o=e.activeOptionIndex!==null?e.options[e.activeOptionIndex]:null,n=focus_management_A(r(e.options.slice()),t=>t.dataRef.current.domRef.current),a=o?n.indexOf(o):null;return a===-1&&(a=null),{options:n,activeOptionIndex:a}}let listbox_Ge={[1](e){return e.dataRef.current.disabled||e.listboxState===1?e:{...e,activeOptionIndex:null,listboxState:1}},[0](e){if(e.dataRef.current.disabled||e.listboxState===0)return e;let r=e.activeOptionIndex,{isSelected:o}=e.dataRef.current,n=e.options.findIndex(a=>o(a.dataRef.current.value));return n!==-1&&(r=n),{...e,listboxState:0,activeOptionIndex:r}},[2](e,r){var a;if(e.dataRef.current.disabled||e.listboxState===1)return e;let o=$(e),n=calculate_active_index_x(r,{resolveItems:()=>o.options,resolveActiveIndex:()=>o.activeOptionIndex,resolveId:t=>t.id,resolveDisabled:t=>t.dataRef.current.disabled});return{...e,...o,searchQuery:"",activeOptionIndex:n,activationTrigger:(a=r.trigger)!=null?a:1}},[3]:(e,r)=>{if(e.dataRef.current.disabled||e.listboxState===1)return e;let n=e.searchQuery!==""?0:1,a=e.searchQuery+r.value.toLowerCase(),u=(e.activeOptionIndex!==null?e.options.slice(e.activeOptionIndex+n).concat(e.options.slice(0,e.activeOptionIndex+n)):e.options).find(i=>{var b;return!i.dataRef.current.disabled&&((b=i.dataRef.current.textValue)==null?void 0:b.startsWith(a))}),c=u?e.options.indexOf(u):-1;return c===-1||c===e.activeOptionIndex?{...e,searchQuery:a}:{...e,searchQuery:a,activeOptionIndex:c,activationTrigger:1}},[4](e){return e.dataRef.current.disabled||e.listboxState===1||e.searchQuery===""?e:{...e,searchQuery:""}},[5]:(e,r)=>{let o={id:r.id,dataRef:r.dataRef},n=$(e,a=>[...a,o]);return e.activeOptionIndex===null&&e.dataRef.current.isSelected(r.dataRef.current.value)&&(n.activeOptionIndex=n.options.indexOf(o)),{...e,...n}},[6]:(e,r)=>{let o=$(e,n=>{let a=n.findIndex(t=>t.id===r.id);return a!==-1&&n.splice(a,1),n});return{...e,...o,activationTrigger:1}},[7]:(e,r)=>({...e,labelId:r.id})},listbox_z=(0,react.createContext)(null);listbox_z.displayName="ListboxActionsContext";function listbox_U(e){let r=(0,react.useContext)(listbox_z);if(r===null){let o=new Error(`<${e} /> is missing a parent <Listbox /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(o,listbox_U),o}return r}let listbox_J=(0,react.createContext)(null);listbox_J.displayName="ListboxDataContext";function B(e){let r=(0,react.useContext)(listbox_J);if(r===null){let o=new Error(`<${e} /> is missing a parent <Listbox /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(o,B),o}return r}function listbox_Ne(e,r){return match_u(r.type,listbox_Ge,e,r)}let listbox_je=react.Fragment;function listbox_Ve(e,r){let{value:o,defaultValue:n,name:a,onChange:t,by:u=(s,f)=>s===f,disabled:c=!1,horizontal:i=!1,multiple:b=!1,...A}=e;const m=i?"horizontal":"vertical";let P=use_sync_refs_y(r),[g=b?[]:void 0,v]=use_controllable_T(o,t,n),[S,p]=(0,react.useReducer)(listbox_Ne,{dataRef:(0,react.createRef)(),listboxState:1,options:[],searchQuery:"",labelId:null,activeOptionIndex:null,activationTrigger:1}),l=(0,react.useRef)({static:!1,hold:!1}),x=(0,react.useRef)(null),E=(0,react.useRef)(null),W=(0,react.useRef)(null),C=use_event_o(typeof u=="string"?(s,f)=>{let O=u;return(s==null?void 0:s[O])===(f==null?void 0:f[O])}:u),L=(0,react.useCallback)(s=>match_u(d.mode,{[1]:()=>g.some(f=>C(f,s)),[0]:()=>C(g,s)}),[g]),d=(0,react.useMemo)(()=>({...S,value:g,disabled:c,mode:b?1:0,orientation:m,compare:C,isSelected:L,optionsPropsRef:l,labelRef:x,buttonRef:E,optionsRef:W}),[g,c,b,S]);use_iso_morphic_effect_l(()=>{S.dataRef.current=d},[d]),use_outside_click_L([d.buttonRef,d.optionsRef],(s,f)=>{var O;p({type:1}),focus_management_h(f,focus_management_F.Loose)||(s.preventDefault(),(O=d.buttonRef.current)==null||O.focus())},d.listboxState===0);let H=(0,react.useMemo)(()=>({open:d.listboxState===0,disabled:c,value:g}),[d,c,g]),ne=use_event_o(s=>{let f=d.options.find(O=>O.id===s);f&&F(f.dataRef.current.value)}),ie=use_event_o(()=>{if(d.activeOptionIndex!==null){let{dataRef:s,id:f}=d.options[d.activeOptionIndex];F(s.current.value),p({type:2,focus:calculate_active_index_a.Specific,id:f})}}),re=use_event_o(()=>p({type:0})),ae=use_event_o(()=>p({type:1})),le=use_event_o((s,f,O)=>s===calculate_active_index_a.Specific?p({type:2,focus:calculate_active_index_a.Specific,id:f,trigger:O}):p({type:2,focus:s,trigger:O})),se=use_event_o((s,f)=>(p({type:5,id:s,dataRef:f}),()=>p({type:6,id:s}))),pe=use_event_o(s=>(p({type:7,id:s}),()=>p({type:7,id:null}))),F=use_event_o(s=>match_u(d.mode,{[0](){return v==null?void 0:v(s)},[1](){let f=d.value.slice(),O=f.findIndex(M=>C(M,s));return O===-1?f.push(s):f.splice(O,1),v==null?void 0:v(f)}})),ue=use_event_o(s=>p({type:3,value:s})),de=use_event_o(()=>p({type:4})),ce=(0,react.useMemo)(()=>({onChange:F,registerOption:se,registerLabel:pe,goToOption:le,closeListbox:ae,openListbox:re,selectActiveOption:ie,selectOption:ne,search:ue,clearSearch:de}),[]),fe={ref:P},G=(0,react.useRef)(null),Te=use_disposables_p();return (0,react.useEffect)(()=>{G.current&&n!==void 0&&Te.addEventListener(G.current,"reset",()=>{F(n)})},[G,F]),react.createElement(listbox_z.Provider,{value:ce},react.createElement(listbox_J.Provider,{value:d},react.createElement(open_closed_c,{value:match_u(d.listboxState,{[0]:open_closed_d.Open,[1]:open_closed_d.Closed})},a!=null&&g!=null&&form_e({[a]:g}).map(([s,f],O)=>react.createElement(hidden_c,{features:hidden_p.Hidden,ref:O===0?M=>{var q;G.current=(q=M==null?void 0:M.closest("form"))!=null?q:null}:void 0,...render_P({key:s,as:"input",type:"hidden",hidden:!0,readOnly:!0,name:s,value:f})})),render_D({ourProps:fe,theirProps:A,slot:H,defaultTag:listbox_je,name:"Listbox"}))))}let listbox_Ke="button";function Qe(e,r){var S;let o=use_id_I(),{id:n=`headlessui-listbox-button-${o}`,...a}=e,t=B("Listbox.Button"),u=listbox_U("Listbox.Button"),c=use_sync_refs_y(t.buttonRef,r),i=use_disposables_p(),b=use_event_o(p=>{switch(p.key){case keyboard_o.Space:case keyboard_o.Enter:case keyboard_o.ArrowDown:p.preventDefault(),u.openListbox(),i.nextFrame(()=>{t.value||u.goToOption(calculate_active_index_a.First)});break;case keyboard_o.ArrowUp:p.preventDefault(),u.openListbox(),i.nextFrame(()=>{t.value||u.goToOption(calculate_active_index_a.Last)});break}}),A=use_event_o(p=>{switch(p.key){case keyboard_o.Space:p.preventDefault();break}}),m=use_event_o(p=>{if(bugs_r(p.currentTarget))return p.preventDefault();t.listboxState===0?(u.closeListbox(),i.nextFrame(()=>{var l;return(l=t.buttonRef.current)==null?void 0:l.focus({preventScroll:!0})})):(p.preventDefault(),u.openListbox())}),P=use_computed_i(()=>{if(t.labelId)return[t.labelId,n].join(" ")},[t.labelId,n]),g=(0,react.useMemo)(()=>({open:t.listboxState===0,disabled:t.disabled,value:t.value}),[t]),v={ref:c,id:n,type:use_resolve_button_type_s(e,t.buttonRef),"aria-haspopup":"listbox","aria-controls":(S=t.optionsRef.current)==null?void 0:S.id,"aria-expanded":t.disabled?void 0:t.listboxState===0,"aria-labelledby":P,disabled:t.disabled,onKeyDown:b,onKeyUp:A,onClick:m};return render_D({ourProps:v,theirProps:a,slot:g,defaultTag:listbox_Ke,name:"Listbox.Button"})}let listbox_We="label";function listbox_Xe(e,r){let o=use_id_I(),{id:n=`headlessui-listbox-label-${o}`,...a}=e,t=B("Listbox.Label"),u=listbox_U("Listbox.Label"),c=use_sync_refs_y(t.labelRef,r);use_iso_morphic_effect_l(()=>u.registerLabel(n),[n]);let i=use_event_o(()=>{var m;return(m=t.buttonRef.current)==null?void 0:m.focus({preventScroll:!0})}),b=(0,react.useMemo)(()=>({open:t.listboxState===0,disabled:t.disabled}),[t]);return render_D({ourProps:{ref:c,id:n,onClick:i},theirProps:a,slot:b,defaultTag:listbox_We,name:"Listbox.Label"})}let listbox_$e="ul",ze=j.RenderStrategy|j.Static;function listbox_Je(e,r){var p;let o=use_id_I(),{id:n=`headlessui-listbox-options-${o}`,...a}=e,t=B("Listbox.Options"),u=listbox_U("Listbox.Options"),c=use_sync_refs_y(t.optionsRef,r),i=use_disposables_p(),b=use_disposables_p(),A=C(),m=(()=>A!==null?(A&open_closed_d.Open)===open_closed_d.Open:t.listboxState===0)();(0,react.useEffect)(()=>{var x;let l=t.optionsRef.current;l&&t.listboxState===0&&l!==((x=owner_e(l))==null?void 0:x.activeElement)&&l.focus({preventScroll:!0})},[t.listboxState,t.optionsRef]);let P=use_event_o(l=>{switch(b.dispose(),l.key){case keyboard_o.Space:if(t.searchQuery!=="")return l.preventDefault(),l.stopPropagation(),u.search(l.key);case keyboard_o.Enter:if(l.preventDefault(),l.stopPropagation(),t.activeOptionIndex!==null){let{dataRef:x}=t.options[t.activeOptionIndex];u.onChange(x.current.value)}t.mode===0&&(u.closeListbox(),disposables_o().nextFrame(()=>{var x;return(x=t.buttonRef.current)==null?void 0:x.focus({preventScroll:!0})}));break;case match_u(t.orientation,{vertical:keyboard_o.ArrowDown,horizontal:keyboard_o.ArrowRight}):return l.preventDefault(),l.stopPropagation(),u.goToOption(calculate_active_index_a.Next);case match_u(t.orientation,{vertical:keyboard_o.ArrowUp,horizontal:keyboard_o.ArrowLeft}):return l.preventDefault(),l.stopPropagation(),u.goToOption(calculate_active_index_a.Previous);case keyboard_o.Home:case keyboard_o.PageUp:return l.preventDefault(),l.stopPropagation(),u.goToOption(calculate_active_index_a.First);case keyboard_o.End:case keyboard_o.PageDown:return l.preventDefault(),l.stopPropagation(),u.goToOption(calculate_active_index_a.Last);case keyboard_o.Escape:return l.preventDefault(),l.stopPropagation(),u.closeListbox(),i.nextFrame(()=>{var x;return(x=t.buttonRef.current)==null?void 0:x.focus({preventScroll:!0})});case keyboard_o.Tab:l.preventDefault(),l.stopPropagation();break;default:l.key.length===1&&(u.search(l.key),b.setTimeout(()=>u.clearSearch(),350));break}}),g=use_computed_i(()=>{var l,x,E;return(E=(l=t.labelRef.current)==null?void 0:l.id)!=null?E:(x=t.buttonRef.current)==null?void 0:x.id},[t.labelRef.current,t.buttonRef.current]),v=(0,react.useMemo)(()=>({open:t.listboxState===0}),[t]),S={"aria-activedescendant":t.activeOptionIndex===null||(p=t.options[t.activeOptionIndex])==null?void 0:p.id,"aria-multiselectable":t.mode===1?!0:void 0,"aria-labelledby":g,"aria-orientation":t.orientation,id:n,onKeyDown:P,role:"listbox",tabIndex:0,ref:c};return render_D({ourProps:S,theirProps:a,slot:v,defaultTag:listbox_$e,features:ze,visible:m,name:"Listbox.Options"})}let qe="li";function listbox_Ye(e,r){let o=use_id_I(),{id:n=`headlessui-listbox-option-${o}`,disabled:a=!1,value:t,...u}=e,c=B("Listbox.Option"),i=listbox_U("Listbox.Option"),b=c.activeOptionIndex!==null?c.options[c.activeOptionIndex].id===n:!1,A=c.isSelected(t),m=(0,react.useRef)(null),P=use_latest_value_s({disabled:a,value:t,domRef:m,get textValue(){var L,d;return(d=(L=m.current)==null?void 0:L.textContent)==null?void 0:d.toLowerCase()}}),g=use_sync_refs_y(r,m);use_iso_morphic_effect_l(()=>{if(c.listboxState!==0||!b||c.activationTrigger===0)return;let L=disposables_o();return L.requestAnimationFrame(()=>{var d,H;(H=(d=m.current)==null?void 0:d.scrollIntoView)==null||H.call(d,{block:"nearest"})}),L.dispose},[m,b,c.listboxState,c.activationTrigger,c.activeOptionIndex]),use_iso_morphic_effect_l(()=>i.registerOption(n,P),[P,n]);let v=use_event_o(L=>{if(a)return L.preventDefault();i.onChange(t),c.mode===0&&(i.closeListbox(),disposables_o().nextFrame(()=>{var d;return(d=c.buttonRef.current)==null?void 0:d.focus({preventScroll:!0})}))}),S=use_event_o(()=>{if(a)return i.goToOption(calculate_active_index_a.Nothing);i.goToOption(calculate_active_index_a.Specific,n)}),p=use_tracked_pointer_u(),l=use_event_o(L=>p.update(L)),x=use_event_o(L=>{p.wasMoved(L)&&(a||b||i.goToOption(calculate_active_index_a.Specific,n,0))}),E=use_event_o(L=>{p.wasMoved(L)&&(a||b&&i.goToOption(calculate_active_index_a.Nothing))}),W=(0,react.useMemo)(()=>({active:b,selected:A,disabled:a}),[b,A,a]);return render_D({ourProps:{id:n,ref:g,role:"option",tabIndex:a===!0?void 0:-1,"aria-disabled":a===!0?!0:void 0,"aria-selected":A,disabled:void 0,onClick:v,onFocus:S,onPointerEnter:l,onMouseEnter:l,onPointerMove:x,onMouseMove:x,onPointerLeave:E,onMouseLeave:E},theirProps:u,slot:W,defaultTag:qe,name:"Listbox.Option"})}let Ze=L(listbox_Ve),et=L(Qe),listbox_tt=L(listbox_Xe),ot=L(listbox_Je),nt=L(listbox_Ye),Bt=Object.assign(Ze,{Button:et,Label:listbox_tt,Options:ot,Option:nt});

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/hooks/use-tree-walker.js
function use_tree_walker_F({container:e,accept:t,walk:r,enabled:c=!0}){let o=(0,react.useRef)(t),l=(0,react.useRef)(r);(0,react.useEffect)(()=>{o.current=t,l.current=r},[t,r]),use_iso_morphic_effect_l(()=>{if(!e||!c)return;let n=owner_e(e);if(!n)return;let f=o.current,p=l.current,d=Object.assign(i=>f(i),{acceptNode:f}),u=n.createTreeWalker(e,NodeFilter.SHOW_ELEMENT,d,!1);for(;u.nextNode();)p(u.currentNode)},[e,c,o,l])}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.13_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/components/combobox/combobox.js
var combobox_Be=(e=>(e[e.Open=0]="Open",e[e.Closed=1]="Closed",e))(combobox_Be||{}),combobox_ke=(e=>(e[e.Single=0]="Single",e[e.Multi=1]="Multi",e))(combobox_ke||{}),combobox_we=(e=>(e[e.Pointer=0]="Pointer",e[e.Other=1]="Other",e))(combobox_we||{}),combobox_Ue=(n=>(n[n.OpenCombobox=0]="OpenCombobox",n[n.CloseCombobox=1]="CloseCombobox",n[n.GoToOption=2]="GoToOption",n[n.RegisterOption=3]="RegisterOption",n[n.UnregisterOption=4]="UnregisterOption",n[n.RegisterLabel=5]="RegisterLabel",n))(combobox_Ue||{});function combobox_re(t,l=e=>e){let e=t.activeOptionIndex!==null?t.options[t.activeOptionIndex]:null,r=focus_management_A(l(t.options.slice()),s=>s.dataRef.current.domRef.current),i=e?r.indexOf(e):null;return i===-1&&(i=null),{options:r,activeOptionIndex:i}}let combobox_He={[1](t){var l;return(l=t.dataRef.current)!=null&&l.disabled||t.comboboxState===1?t:{...t,activeOptionIndex:null,comboboxState:1}},[0](t){var e;if((e=t.dataRef.current)!=null&&e.disabled||t.comboboxState===0)return t;let l=t.activeOptionIndex;if(t.dataRef.current){let{isSelected:r}=t.dataRef.current,i=t.options.findIndex(s=>r(s.dataRef.current.value));i!==-1&&(l=i)}return{...t,comboboxState:0,activeOptionIndex:l}},[2](t,l){var i,s,n,d;if((i=t.dataRef.current)!=null&&i.disabled||(s=t.dataRef.current)!=null&&s.optionsRef.current&&!((n=t.dataRef.current)!=null&&n.optionsPropsRef.current.static)&&t.comboboxState===1)return t;let e=combobox_re(t);if(e.activeOptionIndex===null){let o=e.options.findIndex(u=>!u.dataRef.current.disabled);o!==-1&&(e.activeOptionIndex=o)}let r=calculate_active_index_x(l,{resolveItems:()=>e.options,resolveActiveIndex:()=>e.activeOptionIndex,resolveId:o=>o.id,resolveDisabled:o=>o.dataRef.current.disabled});return{...t,...e,activeOptionIndex:r,activationTrigger:(d=l.trigger)!=null?d:1}},[3]:(t,l)=>{var s,n;let e={id:l.id,dataRef:l.dataRef},r=combobox_re(t,d=>[...d,e]);t.activeOptionIndex===null&&(s=t.dataRef.current)!=null&&s.isSelected(l.dataRef.current.value)&&(r.activeOptionIndex=r.options.indexOf(e));let i={...t,...r,activationTrigger:1};return(n=t.dataRef.current)!=null&&n.__demoMode&&t.dataRef.current.value===void 0&&(i.activeOptionIndex=0),i},[4]:(t,l)=>{let e=combobox_re(t,r=>{let i=r.findIndex(s=>s.id===l.id);return i!==-1&&r.splice(i,1),r});return{...t,...e,activationTrigger:1}},[5]:(t,l)=>({...t,labelId:l.id})},ae=(0,react.createContext)(null);ae.displayName="ComboboxActionsContext";function combobox_$(t){let l=(0,react.useContext)(ae);if(l===null){let e=new Error(`<${t} /> is missing a parent <Combobox /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(e,combobox_$),e}return l}let le=(0,react.createContext)(null);le.displayName="ComboboxDataContext";function combobox_H(t){let l=(0,react.useContext)(le);if(l===null){let e=new Error(`<${t} /> is missing a parent <Combobox /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(e,combobox_H),e}return l}function combobox_Ne(t,l){return match_u(l.type,combobox_He,t,l)}let combobox_Ge=react.Fragment;function combobox_Xe(t,l){let{value:e,defaultValue:r,onChange:i,name:s,by:n=(p,T)=>p===T,disabled:d=!1,__demoMode:o=!1,nullable:u=!1,multiple:P=!1,...f}=t,[O=P?[]:void 0,m]=use_controllable_T(e,i,r),[g,c]=(0,react.useReducer)(combobox_Ne,{dataRef:(0,react.createRef)(),comboboxState:o?0:1,options:[],activeOptionIndex:null,activationTrigger:1,labelId:null}),C=(0,react.useRef)(!1),N=(0,react.useRef)({static:!1,hold:!1}),F=(0,react.useRef)(null),_=(0,react.useRef)(null),h=(0,react.useRef)(null),B=(0,react.useRef)(null),V=use_event_o(typeof n=="string"?(p,T)=>{let v=n;return(p==null?void 0:p[v])===(T==null?void 0:T[v])}:n),G=(0,react.useCallback)(p=>match_u(b.mode,{[1]:()=>O.some(T=>V(T,p)),[0]:()=>V(O,p)}),[O]),b=(0,react.useMemo)(()=>({...g,optionsPropsRef:N,labelRef:F,inputRef:_,buttonRef:h,optionsRef:B,value:O,defaultValue:r,disabled:d,mode:P?1:0,get activeOptionIndex(){if(C.current&&g.activeOptionIndex===null&&g.options.length>0){let p=g.options.findIndex(T=>!T.dataRef.current.disabled);if(p!==-1)return p}return g.activeOptionIndex},compare:V,isSelected:G,nullable:u,__demoMode:o}),[O,r,d,P,u,o,g]),L=(0,react.useRef)(b.activeOptionIndex!==null?b.options[b.activeOptionIndex]:null);(0,react.useEffect)(()=>{let p=b.activeOptionIndex!==null?b.options[b.activeOptionIndex]:null;L.current!==p&&(L.current=p)}),use_iso_morphic_effect_l(()=>{g.dataRef.current=b},[b]),use_outside_click_L([b.buttonRef,b.inputRef,b.optionsRef],()=>oe.closeCombobox(),b.comboboxState===0);let y=(0,react.useMemo)(()=>({open:b.comboboxState===0,disabled:d,activeIndex:b.activeOptionIndex,activeOption:b.activeOptionIndex===null?null:b.options[b.activeOptionIndex].dataRef.current.value,value:O}),[b,d,O]),a=use_event_o(p=>{let T=b.options.find(v=>v.id===p);T&&j(T.dataRef.current.value)}),I=use_event_o(()=>{if(b.activeOptionIndex!==null){let{dataRef:p,id:T}=b.options[b.activeOptionIndex];j(p.current.value),oe.goToOption(calculate_active_index_a.Specific,T)}}),S=use_event_o(()=>{c({type:0}),C.current=!0}),X=use_event_o(()=>{c({type:1}),C.current=!1}),q=use_event_o((p,T,v)=>(C.current=!1,p===calculate_active_index_a.Specific?c({type:2,focus:calculate_active_index_a.Specific,id:T,trigger:v}):c({type:2,focus:p,trigger:v}))),Q=use_event_o((p,T)=>(c({type:3,id:p,dataRef:T}),()=>{var v;((v=L.current)==null?void 0:v.id)===p&&(C.current=!0),c({type:4,id:p})})),Y=use_event_o(p=>(c({type:5,id:p}),()=>c({type:5,id:null}))),j=use_event_o(p=>match_u(b.mode,{[0](){return m==null?void 0:m(p)},[1](){let T=b.value.slice(),v=T.findIndex(J=>V(J,p));return v===-1?T.push(p):T.splice(v,1),m==null?void 0:m(T)}})),oe=(0,react.useMemo)(()=>({onChange:j,registerOption:Q,registerLabel:Y,goToOption:q,closeCombobox:X,openCombobox:S,selectActiveOption:I,selectOption:a}),[]),ce=l===null?{}:{ref:l},Z=(0,react.useRef)(null),Te=use_disposables_p();return (0,react.useEffect)(()=>{Z.current&&r!==void 0&&Te.addEventListener(Z.current,"reset",()=>{j(r)})},[Z,j]),react.createElement(ae.Provider,{value:oe},react.createElement(le.Provider,{value:b},react.createElement(open_closed_c,{value:match_u(b.comboboxState,{[0]:open_closed_d.Open,[1]:open_closed_d.Closed})},s!=null&&O!=null&&form_e({[s]:O}).map(([p,T],v)=>react.createElement(hidden_c,{features:hidden_p.Hidden,ref:v===0?J=>{var ie;Z.current=(ie=J==null?void 0:J.closest("form"))!=null?ie:null}:void 0,...render_P({key:p,as:"input",type:"hidden",hidden:!0,readOnly:!0,name:p,value:T})})),render_D({ourProps:ce,theirProps:f,slot:y,defaultTag:combobox_Ge,name:"Combobox"}))))}let combobox_je="input";function combobox_Je(t,l){var G,b,L,y;let e=use_id_I(),{id:r=`headlessui-combobox-input-${e}`,onChange:i,displayValue:s,type:n="text",...d}=t,o=combobox_H("Combobox.Input"),u=combobox_$("Combobox.Input"),P=use_sync_refs_y(o.inputRef,l),f=(0,react.useRef)(!1),O=use_disposables_p(),m=function(){var a;return typeof s=="function"&&o.value!==void 0?(a=s(o.value))!=null?a:"":typeof o.value=="string"?o.value:""}();use_watch_m(([a,I],[S,X])=>{f.current||o.inputRef.current&&(X===0&&I===1||a!==S)&&(o.inputRef.current.value=a)},[m,o.comboboxState]),use_watch_m(([a],[I])=>{if(a===0&&I===1){let S=o.inputRef.current;if(!S)return;let X=S.value,{selectionStart:q,selectionEnd:Q,selectionDirection:Y}=S;S.value="",S.value=X,Y!==null?S.setSelectionRange(q,Q,Y):S.setSelectionRange(q,Q)}},[o.comboboxState]);let g=(0,react.useRef)(!1),c=use_event_o(()=>{g.current=!0}),C=use_event_o(()=>{setTimeout(()=>{g.current=!1})}),N=use_event_o(a=>{switch(f.current=!0,a.key){case keyboard_o.Backspace:case keyboard_o.Delete:if(o.mode!==0||!o.nullable)return;let I=a.currentTarget;O.requestAnimationFrame(()=>{I.value===""&&(u.onChange(null),o.optionsRef.current&&(o.optionsRef.current.scrollTop=0),u.goToOption(calculate_active_index_a.Nothing))});break;case keyboard_o.Enter:if(f.current=!1,o.comboboxState!==0||g.current)return;if(a.preventDefault(),a.stopPropagation(),o.activeOptionIndex===null){u.closeCombobox();return}u.selectActiveOption(),o.mode===0&&u.closeCombobox();break;case keyboard_o.ArrowDown:return f.current=!1,a.preventDefault(),a.stopPropagation(),match_u(o.comboboxState,{[0]:()=>{u.goToOption(calculate_active_index_a.Next)},[1]:()=>{u.openCombobox()}});case keyboard_o.ArrowUp:return f.current=!1,a.preventDefault(),a.stopPropagation(),match_u(o.comboboxState,{[0]:()=>{u.goToOption(calculate_active_index_a.Previous)},[1]:()=>{u.openCombobox(),O.nextFrame(()=>{o.value||u.goToOption(calculate_active_index_a.Last)})}});case keyboard_o.Home:if(a.shiftKey)break;return f.current=!1,a.preventDefault(),a.stopPropagation(),u.goToOption(calculate_active_index_a.First);case keyboard_o.PageUp:return f.current=!1,a.preventDefault(),a.stopPropagation(),u.goToOption(calculate_active_index_a.First);case keyboard_o.End:if(a.shiftKey)break;return f.current=!1,a.preventDefault(),a.stopPropagation(),u.goToOption(calculate_active_index_a.Last);case keyboard_o.PageDown:return f.current=!1,a.preventDefault(),a.stopPropagation(),u.goToOption(calculate_active_index_a.Last);case keyboard_o.Escape:return f.current=!1,o.comboboxState!==0?void 0:(a.preventDefault(),o.optionsRef.current&&!o.optionsPropsRef.current.static&&a.stopPropagation(),u.closeCombobox());case keyboard_o.Tab:if(f.current=!1,o.comboboxState!==0)return;o.mode===0&&u.selectActiveOption(),u.closeCombobox();break}}),F=use_event_o(a=>{u.openCombobox(),i==null||i(a)}),_=use_event_o(()=>{f.current=!1}),h=use_computed_i(()=>{if(o.labelId)return[o.labelId].join(" ")},[o.labelId]),B=(0,react.useMemo)(()=>({open:o.comboboxState===0,disabled:o.disabled}),[o]),V={ref:P,id:r,role:"combobox",type:n,"aria-controls":(G=o.optionsRef.current)==null?void 0:G.id,"aria-expanded":o.disabled?void 0:o.comboboxState===0,"aria-activedescendant":o.activeOptionIndex===null||(b=o.options[o.activeOptionIndex])==null?void 0:b.id,"aria-labelledby":h,"aria-autocomplete":"list",defaultValue:(y=(L=t.defaultValue)!=null?L:o.defaultValue!==void 0?s==null?void 0:s(o.defaultValue):null)!=null?y:o.defaultValue,disabled:o.disabled,onCompositionStart:c,onCompositionEnd:C,onKeyDown:N,onChange:F,onBlur:_};return render_D({ourProps:V,theirProps:d,slot:B,defaultTag:combobox_je,name:"Combobox.Input"})}let combobox_Ke="button";function combobox_We(t,l){var g;let e=combobox_H("Combobox.Button"),r=combobox_$("Combobox.Button"),i=use_sync_refs_y(e.buttonRef,l),s=use_id_I(),{id:n=`headlessui-combobox-button-${s}`,...d}=t,o=use_disposables_p(),u=use_event_o(c=>{switch(c.key){case keyboard_o.ArrowDown:return c.preventDefault(),c.stopPropagation(),e.comboboxState===1&&r.openCombobox(),o.nextFrame(()=>{var C;return(C=e.inputRef.current)==null?void 0:C.focus({preventScroll:!0})});case keyboard_o.ArrowUp:return c.preventDefault(),c.stopPropagation(),e.comboboxState===1&&(r.openCombobox(),o.nextFrame(()=>{e.value||r.goToOption(calculate_active_index_a.Last)})),o.nextFrame(()=>{var C;return(C=e.inputRef.current)==null?void 0:C.focus({preventScroll:!0})});case keyboard_o.Escape:return e.comboboxState!==0?void 0:(c.preventDefault(),e.optionsRef.current&&!e.optionsPropsRef.current.static&&c.stopPropagation(),r.closeCombobox(),o.nextFrame(()=>{var C;return(C=e.inputRef.current)==null?void 0:C.focus({preventScroll:!0})}));default:return}}),P=use_event_o(c=>{if(bugs_r(c.currentTarget))return c.preventDefault();e.comboboxState===0?r.closeCombobox():(c.preventDefault(),r.openCombobox()),o.nextFrame(()=>{var C;return(C=e.inputRef.current)==null?void 0:C.focus({preventScroll:!0})})}),f=use_computed_i(()=>{if(e.labelId)return[e.labelId,n].join(" ")},[e.labelId,n]),O=(0,react.useMemo)(()=>({open:e.comboboxState===0,disabled:e.disabled,value:e.value}),[e]),m={ref:i,id:n,type:use_resolve_button_type_s(t,e.buttonRef),tabIndex:-1,"aria-haspopup":"listbox","aria-controls":(g=e.optionsRef.current)==null?void 0:g.id,"aria-expanded":e.disabled?void 0:e.comboboxState===0,"aria-labelledby":f,disabled:e.disabled,onClick:P,onKeyDown:u};return render_D({ourProps:m,theirProps:d,slot:O,defaultTag:combobox_Ke,name:"Combobox.Button"})}let combobox_$e="label";function combobox_qe(t,l){let e=use_id_I(),{id:r=`headlessui-combobox-label-${e}`,...i}=t,s=combobox_H("Combobox.Label"),n=combobox_$("Combobox.Label"),d=use_sync_refs_y(s.labelRef,l);use_iso_morphic_effect_l(()=>n.registerLabel(r),[r]);let o=use_event_o(()=>{var f;return(f=s.inputRef.current)==null?void 0:f.focus({preventScroll:!0})}),u=(0,react.useMemo)(()=>({open:s.comboboxState===0,disabled:s.disabled}),[s]);return render_D({ourProps:{ref:d,id:r,onClick:o},theirProps:i,slot:u,defaultTag:combobox_$e,name:"Combobox.Label"})}let combobox_Qe="ul",combobox_Ye=j.RenderStrategy|j.Static;function combobox_Ze(t,l){let e=use_id_I(),{id:r=`headlessui-combobox-options-${e}`,hold:i=!1,...s}=t,n=combobox_H("Combobox.Options"),d=use_sync_refs_y(n.optionsRef,l),o=C(),u=(()=>o!==null?(o&open_closed_d.Open)===open_closed_d.Open:n.comboboxState===0)();use_iso_morphic_effect_l(()=>{var m;n.optionsPropsRef.current.static=(m=t.static)!=null?m:!1},[n.optionsPropsRef,t.static]),use_iso_morphic_effect_l(()=>{n.optionsPropsRef.current.hold=i},[n.optionsPropsRef,i]),use_tree_walker_F({container:n.optionsRef.current,enabled:n.comboboxState===0,accept(m){return m.getAttribute("role")==="option"?NodeFilter.FILTER_REJECT:m.hasAttribute("role")?NodeFilter.FILTER_SKIP:NodeFilter.FILTER_ACCEPT},walk(m){m.setAttribute("role","none")}});let P=use_computed_i(()=>{var m,g;return(g=n.labelId)!=null?g:(m=n.buttonRef.current)==null?void 0:m.id},[n.labelId,n.buttonRef.current]),f=(0,react.useMemo)(()=>({open:n.comboboxState===0}),[n]),O={"aria-labelledby":P,role:"listbox","aria-multiselectable":n.mode===1?!0:void 0,id:r,ref:d};return render_D({ourProps:O,theirProps:s,slot:f,defaultTag:combobox_Qe,features:combobox_Ye,visible:u,name:"Combobox.Options"})}let combobox_ze="li";function eo(t,l){var b,L;let e=use_id_I(),{id:r=`headlessui-combobox-option-${e}`,disabled:i=!1,value:s,...n}=t,d=combobox_H("Combobox.Option"),o=combobox_$("Combobox.Option"),u=d.activeOptionIndex!==null?d.options[d.activeOptionIndex].id===r:!1,P=d.isSelected(s),f=(0,react.useRef)(null),O=use_latest_value_s({disabled:i,value:s,domRef:f,textValue:(L=(b=f.current)==null?void 0:b.textContent)==null?void 0:L.toLowerCase()}),m=use_sync_refs_y(l,f),g=use_event_o(()=>o.selectOption(r));use_iso_morphic_effect_l(()=>o.registerOption(r,O),[O,r]);let c=(0,react.useRef)(!d.__demoMode);use_iso_morphic_effect_l(()=>{if(!d.__demoMode)return;let y=disposables_o();return y.requestAnimationFrame(()=>{c.current=!0}),y.dispose},[]),use_iso_morphic_effect_l(()=>{if(d.comboboxState!==0||!u||!c.current||d.activationTrigger===0)return;let y=disposables_o();return y.requestAnimationFrame(()=>{var a,I;(I=(a=f.current)==null?void 0:a.scrollIntoView)==null||I.call(a,{block:"nearest"})}),y.dispose},[f,u,d.comboboxState,d.activationTrigger,d.activeOptionIndex]);let C=use_event_o(y=>{if(i)return y.preventDefault();g(),d.mode===0&&o.closeCombobox(),platform_n()||requestAnimationFrame(()=>{var a;return(a=d.inputRef.current)==null?void 0:a.focus()})}),N=use_event_o(()=>{if(i)return o.goToOption(calculate_active_index_a.Nothing);o.goToOption(calculate_active_index_a.Specific,r)}),F=use_tracked_pointer_u(),_=use_event_o(y=>F.update(y)),h=use_event_o(y=>{F.wasMoved(y)&&(i||u||o.goToOption(calculate_active_index_a.Specific,r,0))}),B=use_event_o(y=>{F.wasMoved(y)&&(i||u&&(d.optionsPropsRef.current.hold||o.goToOption(calculate_active_index_a.Nothing)))}),V=(0,react.useMemo)(()=>({active:u,selected:P,disabled:i}),[u,P,i]);return render_D({ourProps:{id:r,ref:m,role:"option",tabIndex:i===!0?void 0:-1,"aria-disabled":i===!0?!0:void 0,"aria-selected":P,disabled:void 0,onClick:C,onFocus:N,onPointerEnter:_,onMouseEnter:_,onPointerMove:h,onMouseMove:h,onPointerLeave:B,onMouseLeave:B},theirProps:n,slot:V,defaultTag:combobox_ze,name:"Combobox.Option"})}let oo=L(combobox_Xe),to=L(combobox_We),no=L(combobox_Je),ro=L(combobox_qe),ao=L(combobox_Ze),lo=L(eo),Ko=Object.assign(oo,{Input:no,Button:to,Label:ro,Options:ao,Option:lo});

// EXTERNAL MODULE: ./node_modules/.pnpm/@heroicons+react@2.0.16_react@18.2.0/node_modules/@heroicons/react/24/outline/InformationCircleIcon.js
var InformationCircleIcon = __webpack_require__(52111);
// EXTERNAL MODULE: ./node_modules/.pnpm/@heroicons+react@2.0.16_react@18.2.0/node_modules/@heroicons/react/24/outline/CheckCircleIcon.js
var CheckCircleIcon = __webpack_require__(42966);
// EXTERNAL MODULE: ./node_modules/.pnpm/@heroicons+react@2.0.16_react@18.2.0/node_modules/@heroicons/react/24/outline/ExclamationTriangleIcon.js
var ExclamationTriangleIcon = __webpack_require__(30429);
// EXTERNAL MODULE: ./node_modules/.pnpm/@heroicons+react@2.0.16_react@18.2.0/node_modules/@heroicons/react/20/solid/XMarkIcon.js
var XMarkIcon = __webpack_require__(83720);
// EXTERNAL MODULE: ./node_modules/.pnpm/@heroicons+react@2.0.16_react@18.2.0/node_modules/@heroicons/react/20/solid/ChevronLeftIcon.js
var ChevronLeftIcon = __webpack_require__(9602);
// EXTERNAL MODULE: ./node_modules/.pnpm/@heroicons+react@2.0.16_react@18.2.0/node_modules/@heroicons/react/20/solid/EllipsisHorizontalIcon.js
var EllipsisHorizontalIcon = __webpack_require__(84039);
// EXTERNAL MODULE: ./node_modules/.pnpm/@heroicons+react@2.0.16_react@18.2.0/node_modules/@heroicons/react/20/solid/ChevronRightIcon.js
var solid_ChevronRightIcon = __webpack_require__(43240);
// EXTERNAL MODULE: ./node_modules/.pnpm/@heroicons+react@2.0.16_react@18.2.0/node_modules/@heroicons/react/20/solid/ChevronUpDownIcon.js
var ChevronUpDownIcon = __webpack_require__(37878);
// EXTERNAL MODULE: ./node_modules/.pnpm/@heroicons+react@2.0.16_react@18.2.0/node_modules/@heroicons/react/20/solid/CheckIcon.js
var CheckIcon = __webpack_require__(23014);
// EXTERNAL MODULE: ./node_modules/.pnpm/dayjs@1.11.7/node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(74637);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/.pnpm/dayjs@1.11.7/node_modules/dayjs/plugin/relativeTime.js
var relativeTime = __webpack_require__(54498);
var relativeTime_default = /*#__PURE__*/__webpack_require__.n(relativeTime);
// EXTERNAL MODULE: ./node_modules/.pnpm/dayjs@1.11.7/node_modules/dayjs/plugin/duration.js
var duration = __webpack_require__(23005);
var duration_default = /*#__PURE__*/__webpack_require__.n(duration);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@metatrustlabs+web-utils@0.1.1/node_modules/@metatrustlabs/web-utils/dist/web-utils.esm.js
/* provided dependency */ var process = __webpack_require__(14224);




dayjs_min_default().extend((relativeTime_default()));
dayjs_min_default().extend((duration_default()));
var DEFAULT_DATE_TIME_FORMAT = process.env.DATE_TIME_FORMAT || process.env.NEXT_PUBLIC_DATE_TIME_FORMAT || "YYYY-MM-DD HH:mm";
function formatDate(date, format) {
  if (format === void 0) {
    format = DEFAULT_DATE_TIME_FORMAT;
  }
  return dayjs(date).format(format);
}
var relativeToNow = function relativeToNow(date) {
  return dayjs(date).toNow();
};
var relativeFromNow = function relativeFromNow(date) {
  return dayjs(date).fromNow();
};
var parseDate = function parseDate(date) {
  return dayjs(date).toDate();
};
var formatDurationMillis = function formatDurationMillis(duration) {
  var dur = Math.max(1000, duration); // 不足1s显示1s
  return dayjs.duration(dur, "milliseconds").format("D[d] H[h] m[m] s[s]").replace(/\b0[dhms]\b/g, "");
};
var formatDurationBetween = function formatDurationBetween(startTime, endTime) {
  var diffMillis = dayjs(endTime).diff(dayjs(startTime), "milliseconds");
  return formatDurationMillis(diffMillis);
};
var formatMarkdownLink = function formatMarkdownLink(mdStr, baseUrl, sub_path) {
  // const linkReg = /(?<!!)\[(.*?)\]\((.*?)\)/gi;
  var linkReg = /\[(.*?)\]\((.*?)\)/gi; // (?<!!) 不做图片格式的字符串过滤
  if (!sub_path) return mdStr.replace(linkReg, "[$1](" + baseUrl + "/blob/master/$2)");
  return mdStr.replace(linkReg, "[$1](" + baseUrl + "/blob/master/" + sub_path + "/$2)");
};
function web_utils_esm_formatFileSize(size) {
  if (size < 1024) {
    return size + " bytes";
  } else if (size >= 1024 && size < 1048576) {
    return (size / 1024).toFixed(1) + " KB";
  } else {
    return (size / 1048576).toFixed(1) + " MB";
  }
}


//# sourceMappingURL=web-utils.esm.js.map

// EXTERNAL MODULE: ./node_modules/.pnpm/@floating-ui+react-dom@2.0.1_react-dom@18.2.0_react@18.2.0/node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.esm.js
var floating_ui_react_dom_esm = __webpack_require__(37340);
// EXTERNAL MODULE: ./node_modules/.pnpm/@floating-ui+core@1.3.1/node_modules/@floating-ui/core/dist/floating-ui.core.browser.min.mjs
var floating_ui_core_browser_min = __webpack_require__(42660);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@floating-ui+react@0.24.6_react-dom@18.2.0_react@18.2.0/node_modules/@floating-ui/react/dist/floating-ui.react.esm.js








function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var index = typeof document !== 'undefined' ? react.useLayoutEffect : react.useEffect;

let serverHandoffComplete = false;
let count = 0;
const genId = () => "floating-ui-" + count++;
function useFloatingId() {
  const [id, setId] = react.useState(() => serverHandoffComplete ? genId() : undefined);
  index(() => {
    if (id == null) {
      setId(genId());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  react.useEffect(() => {
    if (!serverHandoffComplete) {
      serverHandoffComplete = true;
    }
  }, []);
  return id;
}

// `toString()` prevents bundlers from trying to `import { useId } from 'react'`
const useReactId = react_namespaceObject[/*#__PURE__*/'useId'.toString()];

/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/useId
 */
const useId = useReactId || useFloatingId;

/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */
const FloatingArrow = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function FloatingArrow(_ref, ref) {
  let {
    context: {
      placement,
      elements: {
        floating
      },
      middlewareData: {
        arrow
      }
    },
    width = 14,
    height = 7,
    tipRadius = 0,
    strokeWidth = 0,
    staticOffset,
    stroke,
    d,
    style: {
      transform,
      ...restStyle
    } = {},
    ...rest
  } = _ref;
  if (false) {}
  const clipPathId = useId();
  if (!floating) {
    return null;
  }

  // Strokes must be double the border width, this ensures the stroke's width
  // works as you'd expect.
  strokeWidth *= 2;
  const halfStrokeWidth = strokeWidth / 2;
  const svgX = width / 2 * (tipRadius / -8 + 1);
  const svgY = height / 2 * tipRadius / 4;
  const [side, alignment] = placement.split('-');
  const isRTL = platform.isRTL(floating);
  const isCustomShape = !!d;
  const isVerticalSide = side === 'top' || side === 'bottom';
  const yOffsetProp = staticOffset && alignment === 'end' ? 'bottom' : 'top';
  let xOffsetProp = staticOffset && alignment === 'end' ? 'right' : 'left';
  if (staticOffset && isRTL) {
    xOffsetProp = alignment === 'end' ? 'left' : 'right';
  }
  const arrowX = (arrow == null ? void 0 : arrow.x) != null ? staticOffset || arrow.x : '';
  const arrowY = (arrow == null ? void 0 : arrow.y) != null ? staticOffset || arrow.y : '';
  const dValue = d || 'M0,0' + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + ' Z';
  const rotation = {
    top: isCustomShape ? 'rotate(180deg)' : '',
    left: isCustomShape ? 'rotate(90deg)' : 'rotate(-90deg)',
    bottom: isCustomShape ? '' : 'rotate(180deg)',
    right: isCustomShape ? 'rotate(-90deg)' : 'rotate(90deg)'
  }[side];
  return /*#__PURE__*/React.createElement("svg", _extends({}, rest, {
    "aria-hidden": true,
    ref: ref,
    width: isCustomShape ? width : width + strokeWidth,
    height: width,
    viewBox: "0 0 " + width + " " + (height > width ? height : width),
    style: {
      position: 'absolute',
      pointerEvents: 'none',
      [xOffsetProp]: arrowX,
      [yOffsetProp]: arrowY,
      [side]: isVerticalSide || isCustomShape ? '100%' : "calc(100% - " + strokeWidth / 2 + "px)",
      transform: "" + rotation + (transform != null ? transform : ''),
      ...restStyle
    }
  }), strokeWidth > 0 && /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#" + clipPathId + ")",
    fill: "none",
    stroke: stroke
    // Account for the stroke on the fill path rendered below.
    ,
    strokeWidth: strokeWidth + (d ? 0 : 1),
    d: dValue
  }), /*#__PURE__*/React.createElement("path", {
    stroke: strokeWidth && !d ? rest.fill : 'none',
    d: dValue
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: clipPathId
  }, /*#__PURE__*/React.createElement("rect", {
    x: -halfStrokeWidth,
    y: halfStrokeWidth * (isCustomShape ? -1 : 1),
    width: width + strokeWidth,
    height: width
  })));
})));

function createPubSub() {
  const map = new Map();
  return {
    emit(event, data) {
      var _map$get;
      (_map$get = map.get(event)) == null ? void 0 : _map$get.forEach(handler => handler(data));
    },
    on(event, listener) {
      map.set(event, [...(map.get(event) || []), listener]);
    },
    off(event, listener) {
      var _map$get2;
      map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter(l => l !== listener)) || []);
    }
  };
}

const FloatingNodeContext = /*#__PURE__*/react.createContext(null);
const FloatingTreeContext = /*#__PURE__*/react.createContext(null);
const useFloatingParentNodeId = () => {
  var _React$useContext;
  return ((_React$useContext = react.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
const useFloatingTree = () => react.useContext(FloatingTreeContext);

/**
 * Registers a node into the floating tree, returning its id.
 */
function useFloatingNodeId(customParentId) {
  const id = useId();
  const tree = useFloatingTree();
  const reactParentId = useFloatingParentNodeId();
  const parentId = customParentId || reactParentId;
  index(() => {
    const node = {
      id,
      parentId
    };
    tree == null ? void 0 : tree.addNode(node);
    return () => {
      tree == null ? void 0 : tree.removeNode(node);
    };
  }, [tree, id, parentId]);
  return id;
}

/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */
function FloatingNode(_ref) {
  let {
    children,
    id
  } = _ref;
  const parentId = useFloatingParentNodeId();
  return /*#__PURE__*/React.createElement(FloatingNodeContext.Provider, {
    value: React.useMemo(() => ({
      id,
      parentId
    }), [id, parentId])
  }, children);
}

/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM (i.e. portalled to a common node, rather than their
 * respective parent).
 * @see https://floating-ui.com/docs/FloatingTree
 */
function FloatingTree(_ref2) {
  let {
    children
  } = _ref2;
  const nodesRef = React.useRef([]);
  const addNode = React.useCallback(node => {
    nodesRef.current = [...nodesRef.current, node];
  }, []);
  const removeNode = React.useCallback(node => {
    nodesRef.current = nodesRef.current.filter(n => n !== node);
  }, []);
  const events = React.useState(() => createPubSub())[0];
  return /*#__PURE__*/React.createElement(FloatingTreeContext.Provider, {
    value: React.useMemo(() => ({
      nodesRef,
      addNode,
      removeNode,
      events
    }), [nodesRef, addNode, removeNode, events])
  }, children);
}

function getDocument(node) {
  return (node == null ? void 0 : node.ownerDocument) || document;
}

// Avoid Chrome DevTools blue warning.
function getPlatform() {
  const uaData = navigator.userAgentData;
  if (uaData != null && uaData.platform) {
    return uaData.platform;
  }
  return navigator.platform;
}
function getUserAgent() {
  const uaData = navigator.userAgentData;
  if (uaData && Array.isArray(uaData.brands)) {
    return uaData.brands.map(_ref => {
      let {
        brand,
        version
      } = _ref;
      return brand + "/" + version;
    }).join(' ');
  }
  return navigator.userAgent;
}

function getWindow(value) {
  return getDocument(value).defaultView || window;
}
function isElement(value) {
  return value ? value instanceof getWindow(value).Element : false;
}
function isHTMLElement(value) {
  return value ? value instanceof getWindow(value).HTMLElement : false;
}
function isShadowRoot(node) {
  // Browsers without `ShadowRoot` support
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }
  const OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function isVirtualClick(event) {
  if (event.mozInputSource === 0 && event.isTrusted) {
    return true;
  }
  const androidRe = /Android/i;
  if ((androidRe.test(getPlatform()) || androidRe.test(getUserAgent())) && event.pointerType) {
    return event.type === 'click' && event.buttons === 1;
  }
  return event.detail === 0 && !event.pointerType;
}
function isVirtualPointerEvent(event) {
  return event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType !== 'mouse' ||
  // iOS VoiceOver returns 0.333• for width/height.
  event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0;
}
function isSafari() {
  // Chrome DevTools does not complain about navigator.vendor
  return /apple/i.test(navigator.vendor);
}
function isMac() {
  return getPlatform().toLowerCase().startsWith('mac') && !navigator.maxTouchPoints;
}
function isMouseLikePointerType(pointerType, strict) {
  // On some Linux machines with Chromium, mouse inputs return a `pointerType`
  // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
  const values = ['mouse', 'pen'];
  if (!strict) {
    values.push('', undefined);
  }
  return values.includes(pointerType);
}
function isReactEvent(event) {
  return 'nativeEvent' in event;
}
function isHidden(el) {
  if (!el) return false;
  return el.offsetParent === null;
}

function contains(parent, child) {
  if (!parent || !child) {
    return false;
  }
  const rootNode = child.getRootNode && child.getRootNode();

  // First, attempt with faster native method
  if (parent.contains(child)) {
    return true;
  }

  // then fallback to custom implementation with Shadow DOM support
  if (rootNode && isShadowRoot(rootNode)) {
    let next = child;
    while (next) {
      if (parent === next) {
        return true;
      }
      // @ts-ignore
      next = next.parentNode || next.host;
    }
  }

  // Give up, the result is false
  return false;
}

function createAttribute(name) {
  return "data-floating-ui-" + name;
}

function useLatestRef(value) {
  const ref = (0,react.useRef)(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}

const safePolygonIdentifier = /*#__PURE__*/createAttribute('safe-polygon');
function getDelay(value, prop, pointerType) {
  if (pointerType && !isMouseLikePointerType(pointerType)) {
    return 0;
  }
  if (typeof value === 'number') {
    return value;
  }
  return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */
function useHover(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    dataRef,
    events,
    elements: {
      domReference,
      floating
    },
    refs
  } = context;
  const {
    enabled = true,
    delay = 0,
    handleClose = null,
    mouseOnly = false,
    restMs = 0,
    move = true
  } = props;
  const tree = useFloatingTree();
  const parentId = useFloatingParentNodeId();
  const handleCloseRef = useLatestRef(handleClose);
  const delayRef = useLatestRef(delay);
  const pointerTypeRef = react.useRef();
  const timeoutRef = react.useRef();
  const handlerRef = react.useRef();
  const restTimeoutRef = react.useRef();
  const blockMouseMoveRef = react.useRef(true);
  const performedPointerEventsMutationRef = react.useRef(false);
  const unbindMouseMoveRef = react.useRef(() => {});
  const isHoverOpen = react.useCallback(() => {
    var _dataRef$current$open;
    const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
    return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
  }, [dataRef]);

  // When dismissing before opening, clear the delay timeouts to cancel it
  // from showing.
  react.useEffect(() => {
    if (!enabled) {
      return;
    }
    function onDismiss() {
      clearTimeout(timeoutRef.current);
      clearTimeout(restTimeoutRef.current);
      blockMouseMoveRef.current = true;
    }
    events.on('dismiss', onDismiss);
    return () => {
      events.off('dismiss', onDismiss);
    };
  }, [enabled, events]);
  react.useEffect(() => {
    if (!enabled || !handleCloseRef.current || !open) {
      return;
    }
    function onLeave(event) {
      if (isHoverOpen()) {
        onOpenChange(false, event);
      }
    }
    const html = getDocument(floating).documentElement;
    html.addEventListener('mouseleave', onLeave);
    return () => {
      html.removeEventListener('mouseleave', onLeave);
    };
  }, [floating, open, onOpenChange, enabled, handleCloseRef, dataRef, isHoverOpen]);
  const closeWithDelay = react.useCallback(function (event, runElseBranch) {
    if (runElseBranch === void 0) {
      runElseBranch = true;
    }
    const closeDelay = getDelay(delayRef.current, 'close', pointerTypeRef.current);
    if (closeDelay && !handlerRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => onOpenChange(false, event), closeDelay);
    } else if (runElseBranch) {
      clearTimeout(timeoutRef.current);
      onOpenChange(false, event);
    }
  }, [delayRef, onOpenChange]);
  const cleanupMouseMoveHandler = react.useCallback(() => {
    unbindMouseMoveRef.current();
    handlerRef.current = undefined;
  }, []);
  const clearPointerEvents = react.useCallback(() => {
    if (performedPointerEventsMutationRef.current) {
      const body = getDocument(refs.floating.current).body;
      body.style.pointerEvents = '';
      body.removeAttribute(safePolygonIdentifier);
      performedPointerEventsMutationRef.current = false;
    }
  }, [refs]);

  // Registering the mouse events on the reference directly to bypass React's
  // delegation system. If the cursor was on a disabled element and then entered
  // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
  react.useEffect(() => {
    if (!enabled) {
      return;
    }
    function isClickLikeOpenEvent() {
      return dataRef.current.openEvent ? ['click', 'mousedown'].includes(dataRef.current.openEvent.type) : false;
    }
    function onMouseEnter(event) {
      clearTimeout(timeoutRef.current);
      blockMouseMoveRef.current = false;
      if (mouseOnly && !isMouseLikePointerType(pointerTypeRef.current) || restMs > 0 && getDelay(delayRef.current, 'open') === 0) {
        return;
      }
      const openDelay = getDelay(delayRef.current, 'open', pointerTypeRef.current);
      if (openDelay) {
        timeoutRef.current = setTimeout(() => {
          onOpenChange(true, event);
        }, openDelay);
      } else {
        onOpenChange(true, event);
      }
    }
    function onMouseLeave(event) {
      if (isClickLikeOpenEvent()) {
        return;
      }
      unbindMouseMoveRef.current();
      const doc = getDocument(floating);
      clearTimeout(restTimeoutRef.current);
      if (handleCloseRef.current) {
        // Prevent clearing `onScrollMouseLeave` timeout.
        if (!open) {
          clearTimeout(timeoutRef.current);
        }
        handlerRef.current = handleCloseRef.current({
          ...context,
          tree,
          x: event.clientX,
          y: event.clientY,
          onClose() {
            clearPointerEvents();
            cleanupMouseMoveHandler();
            // Should the event expose that it was closed by `safePolygon`?
            closeWithDelay(event);
          }
        });
        const handler = handlerRef.current;
        doc.addEventListener('mousemove', handler);
        unbindMouseMoveRef.current = () => {
          doc.removeEventListener('mousemove', handler);
        };
        return;
      }

      // Allow interactivity without `safePolygon` on touch devices. With a
      // pointer, a short close delay is an alternative, so it should work
      // consistently.
      const shouldClose = pointerTypeRef.current === 'touch' ? !contains(floating, event.relatedTarget) : true;
      if (shouldClose) {
        closeWithDelay(event);
      }
    }

    // Ensure the floating element closes after scrolling even if the pointer
    // did not move.
    // https://github.com/floating-ui/floating-ui/discussions/1692
    function onScrollMouseLeave(event) {
      if (isClickLikeOpenEvent()) {
        return;
      }
      handleCloseRef.current == null ? void 0 : handleCloseRef.current({
        ...context,
        tree,
        x: event.clientX,
        y: event.clientY,
        onClose() {
          clearPointerEvents();
          cleanupMouseMoveHandler();
          closeWithDelay(event);
        }
      })(event);
    }
    if (isElement(domReference)) {
      const ref = domReference;
      open && ref.addEventListener('mouseleave', onScrollMouseLeave);
      floating == null ? void 0 : floating.addEventListener('mouseleave', onScrollMouseLeave);
      move && ref.addEventListener('mousemove', onMouseEnter, {
        once: true
      });
      ref.addEventListener('mouseenter', onMouseEnter);
      ref.addEventListener('mouseleave', onMouseLeave);
      return () => {
        open && ref.removeEventListener('mouseleave', onScrollMouseLeave);
        floating == null ? void 0 : floating.removeEventListener('mouseleave', onScrollMouseLeave);
        move && ref.removeEventListener('mousemove', onMouseEnter);
        ref.removeEventListener('mouseenter', onMouseEnter);
        ref.removeEventListener('mouseleave', onMouseLeave);
      };
    }
  }, [domReference, floating, enabled, context, mouseOnly, restMs, move, closeWithDelay, cleanupMouseMoveHandler, clearPointerEvents, onOpenChange, open, tree, delayRef, handleCloseRef, dataRef]);

  // Block pointer-events of every element other than the reference and floating
  // while the floating element is open and has a `handleClose` handler. Also
  // handles nested floating elements.
  // https://github.com/floating-ui/floating-ui/issues/1722
  index(() => {
    var _handleCloseRef$curre;
    if (!enabled) {
      return;
    }
    if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
      const body = getDocument(floating).body;
      body.setAttribute(safePolygonIdentifier, '');
      body.style.pointerEvents = 'none';
      performedPointerEventsMutationRef.current = true;
      if (isElement(domReference) && floating) {
        var _tree$nodesRef$curren, _tree$nodesRef$curren2;
        const ref = domReference;
        const parentFloating = tree == null ? void 0 : (_tree$nodesRef$curren = tree.nodesRef.current.find(node => node.id === parentId)) == null ? void 0 : (_tree$nodesRef$curren2 = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren2.elements.floating;
        if (parentFloating) {
          parentFloating.style.pointerEvents = '';
        }
        ref.style.pointerEvents = 'auto';
        floating.style.pointerEvents = 'auto';
        return () => {
          ref.style.pointerEvents = '';
          floating.style.pointerEvents = '';
        };
      }
    }
  }, [enabled, open, parentId, floating, domReference, tree, handleCloseRef, dataRef, isHoverOpen]);
  index(() => {
    if (!open) {
      pointerTypeRef.current = undefined;
      cleanupMouseMoveHandler();
      clearPointerEvents();
    }
  }, [open, cleanupMouseMoveHandler, clearPointerEvents]);
  react.useEffect(() => {
    return () => {
      cleanupMouseMoveHandler();
      clearTimeout(timeoutRef.current);
      clearTimeout(restTimeoutRef.current);
      clearPointerEvents();
    };
  }, [enabled, cleanupMouseMoveHandler, clearPointerEvents]);
  return react.useMemo(() => {
    if (!enabled) {
      return {};
    }
    function setPointerRef(event) {
      pointerTypeRef.current = event.pointerType;
    }
    return {
      reference: {
        onPointerDown: setPointerRef,
        onPointerEnter: setPointerRef,
        onMouseMove(event) {
          if (open || restMs === 0) {
            return;
          }
          clearTimeout(restTimeoutRef.current);
          restTimeoutRef.current = setTimeout(() => {
            if (!blockMouseMoveRef.current) {
              onOpenChange(true, event.nativeEvent);
            }
          }, restMs);
        }
      },
      floating: {
        onMouseEnter() {
          clearTimeout(timeoutRef.current);
        },
        onMouseLeave(event) {
          events.emit('dismiss', {
            type: 'mouseLeave',
            data: {
              returnFocus: false
            }
          });
          closeWithDelay(event.nativeEvent, false);
        }
      }
    };
  }, [events, enabled, restMs, open, onOpenChange, closeWithDelay]);
}

const FloatingDelayGroupContext = /*#__PURE__*/react.createContext({
  delay: 0,
  initialDelay: 0,
  timeoutMs: 0,
  currentId: null,
  setCurrentId: () => {},
  setState: () => {},
  isInstantPhase: false
});
const useDelayGroupContext = () => React.useContext(FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */
const FloatingDelayGroup = _ref => {
  let {
    children,
    delay,
    timeoutMs = 0
  } = _ref;
  const [state, setState] = React.useReducer((prev, next) => ({
    ...prev,
    ...next
  }), {
    delay,
    timeoutMs,
    initialDelay: delay,
    currentId: null,
    isInstantPhase: false
  });
  const initialCurrentIdRef = React.useRef(null);
  const setCurrentId = React.useCallback(currentId => {
    setState({
      currentId
    });
  }, []);
  index(() => {
    if (state.currentId) {
      if (initialCurrentIdRef.current === null) {
        initialCurrentIdRef.current = state.currentId;
      } else {
        setState({
          isInstantPhase: true
        });
      }
    } else {
      setState({
        isInstantPhase: false
      });
      initialCurrentIdRef.current = null;
    }
  }, [state.currentId]);
  return /*#__PURE__*/React.createElement(FloatingDelayGroupContext.Provider, {
    value: React.useMemo(() => ({
      ...state,
      setState,
      setCurrentId
    }), [state, setState, setCurrentId])
  }, children);
};
const useDelayGroup = (_ref2, _ref3) => {
  let {
    open,
    onOpenChange
  } = _ref2;
  let {
    id
  } = _ref3;
  const {
    currentId,
    setCurrentId,
    initialDelay,
    setState,
    timeoutMs
  } = useDelayGroupContext();
  index(() => {
    if (currentId) {
      setState({
        delay: {
          open: 1,
          close: getDelay(initialDelay, 'close')
        }
      });
      if (currentId !== id) {
        onOpenChange(false);
      }
    }
  }, [id, onOpenChange, setState, currentId, initialDelay]);
  index(() => {
    function unset() {
      onOpenChange(false);
      setState({
        delay: initialDelay,
        currentId: null
      });
    }
    if (!open && currentId === id) {
      if (timeoutMs) {
        const timeout = window.setTimeout(unset, timeoutMs);
        return () => {
          clearTimeout(timeout);
        };
      } else {
        unset();
      }
    }
  }, [open, setState, currentId, id, onOpenChange, initialDelay, timeoutMs]);
  index(() => {
    if (open) {
      setCurrentId(id);
    }
  }, [open, setCurrentId, id]);
};

/**
 * Find the real active element. Traverses into shadowRoots.
 */
function activeElement(doc) {
  let activeElement = doc.activeElement;
  while (((_activeElement = activeElement) == null ? void 0 : (_activeElement$shadow = _activeElement.shadowRoot) == null ? void 0 : _activeElement$shadow.activeElement) != null) {
    var _activeElement, _activeElement$shadow;
    activeElement = activeElement.shadowRoot.activeElement;
  }
  return activeElement;
}

let rafId = 0;
function enqueueFocus(el, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    preventScroll = false,
    cancelPrevious = true,
    sync = false
  } = options;
  cancelPrevious && cancelAnimationFrame(rafId);
  const exec = () => el == null ? void 0 : el.focus({
    preventScroll
  });
  if (sync) {
    exec();
  } else {
    rafId = requestAnimationFrame(exec);
  }
}

function getAncestors(nodes, id) {
  var _nodes$find;
  let allAncestors = [];
  let currentParentId = (_nodes$find = nodes.find(node => node.id === id)) == null ? void 0 : _nodes$find.parentId;
  while (currentParentId) {
    const currentNode = nodes.find(node => node.id === currentParentId);
    currentParentId = currentNode == null ? void 0 : currentNode.parentId;
    if (currentNode) {
      allAncestors = allAncestors.concat(currentNode);
    }
  }
  return allAncestors;
}

function getChildren(nodes, id) {
  let allChildren = nodes.filter(node => {
    var _node$context;
    return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
  });
  let currentChildren = allChildren;
  while (currentChildren.length) {
    currentChildren = nodes.filter(node => {
      var _currentChildren;
      return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some(n => {
        var _node$context2;
        return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
      });
    });
    allChildren = allChildren.concat(currentChildren);
  }
  return allChildren;
}

function getTarget(event) {
  if ('composedPath' in event) {
    return event.composedPath()[0];
  }

  // TS thinks `event` is of type never as it assumes all browsers support
  // `composedPath()`, but browsers without shadow DOM don't.
  return event.target;
}

const TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled])," + "[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function isTypeableElement(element) {
  return isHTMLElement(element) && element.matches(TYPEABLE_SELECTOR);
}

function stopEvent(event) {
  event.preventDefault();
  event.stopPropagation();
}

const getTabbableOptions = () => ({
  getShadowRoot: true,
  displayCheck:
  // JSDOM does not support the `tabbable` library. To solve this we can
  // check if `ResizeObserver` is a real function (not polyfilled), which
  // determines if the current environment is JSDOM-like.
  typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
});
function getTabbableIn(container, direction) {
  const allTabbable = tabbable(container, getTabbableOptions());
  if (direction === 'prev') {
    allTabbable.reverse();
  }
  const activeIndex = allTabbable.indexOf(activeElement(getDocument(container)));
  const nextTabbableElements = allTabbable.slice(activeIndex + 1);
  return nextTabbableElements[0];
}
function getNextTabbable() {
  return getTabbableIn(document.body, 'next');
}
function getPreviousTabbable() {
  return getTabbableIn(document.body, 'prev');
}
function isOutsideEvent(event, container) {
  const containerElement = container || event.currentTarget;
  const relatedTarget = event.relatedTarget;
  return !relatedTarget || !contains(containerElement, relatedTarget);
}
function disableFocusInside(container) {
  const tabbableElements = tabbable(container, getTabbableOptions());
  tabbableElements.forEach(element => {
    element.dataset.tabindex = element.getAttribute('tabindex') || '';
    element.setAttribute('tabindex', '-1');
  });
}
function enableFocusInside(container) {
  const elements = container.querySelectorAll('[data-tabindex]');
  elements.forEach(element => {
    const tabindex = element.dataset.tabindex;
    delete element.dataset.tabindex;
    if (tabindex) {
      element.setAttribute('tabindex', tabindex);
    } else {
      element.removeAttribute('tabindex');
    }
  });
}

// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx

const HIDDEN_STYLES = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'fixed',
  whiteSpace: 'nowrap',
  width: '1px',
  top: 0,
  left: 0
};
let timeoutId;
function setActiveElementOnTab(event) {
  if (event.key === 'Tab') {
    event.target;
    clearTimeout(timeoutId);
  }
}
const FocusGuard = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function FocusGuard(props, ref) {
  const [role, setRole] = React.useState();
  index(() => {
    if (isSafari()) {
      // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
      // on VoiceOver does trigger the onFocus event, so we can use the focus
      // trap element. On Safari, only buttons trigger the onFocus event.
      // NB: "group" role in the Sandbox no longer appears to work, must be a
      // button role.
      setRole('button');
    }
    document.addEventListener('keydown', setActiveElementOnTab);
    return () => {
      document.removeEventListener('keydown', setActiveElementOnTab);
    };
  }, []);
  const restProps = {
    ref,
    tabIndex: 0,
    // Role is only for VoiceOver
    role,
    'aria-hidden': role ? undefined : true,
    [createAttribute('focus-guard')]: '',
    style: HIDDEN_STYLES
  };
  return /*#__PURE__*/React.createElement("span", _extends({}, props, restProps));
})));

const PortalContext = /*#__PURE__*/(/* unused pure expression or super */ null && (React.createContext(null)));
function useFloatingPortalNode(_temp) {
  let {
    id,
    root
  } = _temp === void 0 ? {} : _temp;
  const [portalNode, setPortalNode] = React.useState(null);
  const uniqueId = useId();
  const portalContext = usePortalContext();
  const data = React.useMemo(() => ({
    id,
    root,
    portalContext,
    uniqueId
  }), [id, root, portalContext, uniqueId]);
  const dataRef = React.useRef();
  index(() => {
    return () => {
      portalNode == null ? void 0 : portalNode.remove();
    };
  }, [portalNode, data]);
  index(() => {
    if (dataRef.current === data) return;
    dataRef.current = data;
    const {
      id,
      root,
      portalContext,
      uniqueId
    } = data;
    const existingIdRoot = id ? document.getElementById(id) : null;
    const attr = createAttribute('portal');
    if (existingIdRoot) {
      const subRoot = document.createElement('div');
      subRoot.id = uniqueId;
      subRoot.setAttribute(attr, '');
      existingIdRoot.appendChild(subRoot);
      setPortalNode(subRoot);
    } else {
      let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
      if (container && !isElement(container)) container = container.current;
      container = container || document.body;
      let idWrapper = null;
      if (id) {
        idWrapper = document.createElement('div');
        idWrapper.id = id;
        container.appendChild(idWrapper);
      }
      const subRoot = document.createElement('div');
      subRoot.id = uniqueId;
      subRoot.setAttribute(attr, '');
      container = idWrapper || container;
      container.appendChild(subRoot);
      setPortalNode(subRoot);
    }
  }, [data]);
  return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * @see https://floating-ui.com/docs/FloatingPortal
 */
function FloatingPortal(_ref) {
  let {
    children,
    id,
    root = null,
    preserveTabOrder = true
  } = _ref;
  const portalNode = useFloatingPortalNode({
    id,
    root
  });
  const [focusManagerState, setFocusManagerState] = React.useState(null);
  const beforeOutsideRef = React.useRef(null);
  const afterOutsideRef = React.useRef(null);
  const beforeInsideRef = React.useRef(null);
  const afterInsideRef = React.useRef(null);
  const shouldRenderGuards =
  // The FocusManager and therefore floating element are currently open/
  // rendered.
  !!focusManagerState &&
  // Guards are only for non-modal focus management.
  !focusManagerState.modal &&
  // Don't render if unmount is transitioning.
  focusManagerState.open && preserveTabOrder && !!(root || portalNode);

  // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
  React.useEffect(() => {
    if (!portalNode || !preserveTabOrder || focusManagerState != null && focusManagerState.modal) {
      return;
    }

    // Make sure elements inside the portal element are tabbable only when the
    // portal has already been focused, either by tabbing into a focus trap
    // element outside or using the mouse.
    function onFocus(event) {
      if (portalNode && isOutsideEvent(event)) {
        const focusing = event.type === 'focusin';
        const manageFocus = focusing ? enableFocusInside : disableFocusInside;
        manageFocus(portalNode);
      }
    }
    // Listen to the event on the capture phase so they run before the focus
    // trap elements onFocus prop is called.
    portalNode.addEventListener('focusin', onFocus, true);
    portalNode.addEventListener('focusout', onFocus, true);
    return () => {
      portalNode.removeEventListener('focusin', onFocus, true);
      portalNode.removeEventListener('focusout', onFocus, true);
    };
  }, [portalNode, preserveTabOrder, focusManagerState == null ? void 0 : focusManagerState.modal]);
  return /*#__PURE__*/React.createElement(PortalContext.Provider, {
    value: React.useMemo(() => ({
      preserveTabOrder,
      beforeOutsideRef,
      afterOutsideRef,
      beforeInsideRef,
      afterInsideRef,
      portalNode,
      setFocusManagerState
    }), [preserveTabOrder, portalNode])
  }, shouldRenderGuards && portalNode && /*#__PURE__*/React.createElement(FocusGuard, {
    "data-type": "outside",
    ref: beforeOutsideRef,
    onFocus: event => {
      if (isOutsideEvent(event, portalNode)) {
        var _beforeInsideRef$curr;
        (_beforeInsideRef$curr = beforeInsideRef.current) == null ? void 0 : _beforeInsideRef$curr.focus();
      } else {
        const prevTabbable = getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
        prevTabbable == null ? void 0 : prevTabbable.focus();
      }
    }
  }), shouldRenderGuards && portalNode && /*#__PURE__*/React.createElement("span", {
    "aria-owns": portalNode.id,
    style: HIDDEN_STYLES
  }), portalNode && /*#__PURE__*/createPortal(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/React.createElement(FocusGuard, {
    "data-type": "outside",
    ref: afterOutsideRef,
    onFocus: event => {
      if (isOutsideEvent(event, portalNode)) {
        var _afterInsideRef$curre;
        (_afterInsideRef$curre = afterInsideRef.current) == null ? void 0 : _afterInsideRef$curre.focus();
      } else {
        const nextTabbable = getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
        nextTabbable == null ? void 0 : nextTabbable.focus();
        (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null ? void 0 : focusManagerState.onOpenChange(false, event.nativeEvent));
      }
    }
  }));
}
const usePortalContext = () => React.useContext(PortalContext);

const VisuallyHiddenDismiss = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VisuallyHiddenDismiss(props, ref) {
  return /*#__PURE__*/React.createElement("button", _extends({}, props, {
    type: "button",
    ref: ref,
    tabIndex: -1,
    style: HIDDEN_STYLES
  }));
})));
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */
function FloatingFocusManager(props) {
  const {
    context,
    children,
    order = ['content'],
    guards: _guards = true,
    initialFocus = 0,
    returnFocus = true,
    modal = true,
    visuallyHiddenDismiss = false,
    closeOnFocusOut = true
  } = props;
  const {
    open,
    refs,
    nodeId,
    onOpenChange,
    events,
    dataRef,
    elements: {
      domReference,
      floating
    }
  } = context;

  // Force the guards to be rendered if the `inert` attribute is not supported.
  const guards = supportsInert() ? _guards : true;
  const orderRef = useLatestRef(order);
  const initialFocusRef = useLatestRef(initialFocus);
  const returnFocusRef = useLatestRef(returnFocus);
  const tree = useFloatingTree();
  const portalContext = usePortalContext();

  // Controlled by `useListNavigation`.
  const ignoreInitialFocus = typeof initialFocus === 'number' && initialFocus < 0;
  const startDismissButtonRef = React.useRef(null);
  const endDismissButtonRef = React.useRef(null);
  const preventReturnFocusRef = React.useRef(false);
  const previouslyFocusedElementRef = React.useRef(null);
  const isPointerDownRef = React.useRef(false);
  const isInsidePortal = portalContext != null;

  // If the reference is a combobox and is typeable (e.g. input/textarea),
  // there are different focus semantics. The guards should not be rendered, but
  // aria-hidden should be applied to all nodes still. Further, the visually
  // hidden dismiss button should only appear at the end of the list, not the
  // start.
  const isTypeableCombobox = domReference && domReference.getAttribute('role') === 'combobox' && isTypeableElement(domReference);
  const getTabbableContent = React.useCallback(function (container) {
    if (container === void 0) {
      container = floating;
    }
    return container ? tabbable(container, getTabbableOptions()) : [];
  }, [floating]);
  const getTabbableElements = React.useCallback(container => {
    const content = getTabbableContent(container);
    return orderRef.current.map(type => {
      if (domReference && type === 'reference') {
        return domReference;
      }
      if (floating && type === 'floating') {
        return floating;
      }
      return content;
    }).filter(Boolean).flat();
  }, [domReference, floating, orderRef, getTabbableContent]);
  React.useEffect(() => {
    if (!modal) {
      return;
    }
    function onKeyDown(event) {
      if (event.key === 'Tab') {
        // The focus guards have nothing to focus, so we need to stop the event.
        if (contains(floating, activeElement(getDocument(floating))) && getTabbableContent().length === 0 && !isTypeableCombobox) {
          stopEvent(event);
        }
        const els = getTabbableElements();
        const target = getTarget(event);
        if (orderRef.current[0] === 'reference' && target === domReference) {
          stopEvent(event);
          if (event.shiftKey) {
            enqueueFocus(els[els.length - 1]);
          } else {
            enqueueFocus(els[1]);
          }
        }
        if (orderRef.current[1] === 'floating' && target === floating && event.shiftKey) {
          stopEvent(event);
          enqueueFocus(els[0]);
        }
      }
    }
    const doc = getDocument(floating);
    doc.addEventListener('keydown', onKeyDown);
    return () => {
      doc.removeEventListener('keydown', onKeyDown);
    };
  }, [domReference, floating, modal, orderRef, refs, isTypeableCombobox, getTabbableContent, getTabbableElements]);
  React.useEffect(() => {
    if (!closeOnFocusOut) {
      return;
    }

    // In Safari, buttons lose focus when pressing them.
    function handlePointerDown() {
      isPointerDownRef.current = true;
      setTimeout(() => {
        isPointerDownRef.current = false;
      });
    }
    function handleFocusOutside(event) {
      const relatedTarget = event.relatedTarget;
      queueMicrotask(() => {
        const movedToUnrelatedNode = !(contains(domReference, relatedTarget) || contains(floating, relatedTarget) || contains(relatedTarget, floating) || contains(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute(createAttribute('focus-guard')) || tree && (getChildren(tree.nodesRef.current, nodeId).find(node => {
          var _node$context, _node$context2;
          return contains((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || contains((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
        }) || getAncestors(tree.nodesRef.current, nodeId).find(node => {
          var _node$context3, _node$context4;
          return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
        })));

        // Focus did not move inside the floating tree, and there are no tabbable
        // portal guards to handle closing.
        if (relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current &&
        // Fix React 18 Strict Mode returnFocus due to double rendering.
        relatedTarget !== previouslyFocusedElementRef.current) {
          preventReturnFocusRef.current = true;
          onOpenChange(false, event);
        }
      });
    }
    if (floating && isHTMLElement(domReference)) {
      domReference.addEventListener('focusout', handleFocusOutside);
      domReference.addEventListener('pointerdown', handlePointerDown);
      !modal && floating.addEventListener('focusout', handleFocusOutside);
      return () => {
        domReference.removeEventListener('focusout', handleFocusOutside);
        domReference.removeEventListener('pointerdown', handlePointerDown);
        !modal && floating.removeEventListener('focusout', handleFocusOutside);
      };
    }
  }, [domReference, floating, modal, nodeId, tree, portalContext, onOpenChange, closeOnFocusOut]);
  React.useEffect(() => {
    var _portalContext$portal;
    // Don't hide portals nested within the parent portal.
    const portalNodes = Array.from((portalContext == null ? void 0 : (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + createAttribute('portal') + "]")) || []);
    if (floating && modal) {
      const insideNodes = [floating, ...portalNodes, startDismissButtonRef.current, endDismissButtonRef.current].filter(x => x != null);
      const suppressorFn = guards ? hideOthers : suppressOthers;
      const cleanup = suppressorFn(orderRef.current.includes('reference') || isTypeableCombobox ? insideNodes.concat(domReference || []) : insideNodes, undefined, createAttribute('inert'));
      return () => {
        cleanup();
      };
    }
  }, [domReference, floating, modal, orderRef, portalContext, isTypeableCombobox, guards]);
  index(() => {
    if (!floating) return;
    const doc = getDocument(floating);
    const previouslyFocusedElement = activeElement(doc);

    // Wait for any layout effect state setters to execute to set `tabIndex`.
    queueMicrotask(() => {
      const focusableElements = getTabbableElements(floating);
      const initialFocusValue = initialFocusRef.current;
      const elToFocus = (typeof initialFocusValue === 'number' ? focusableElements[initialFocusValue] : initialFocusValue.current) || floating;
      const focusAlreadyInsideFloatingEl = contains(floating, previouslyFocusedElement);
      if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) {
        enqueueFocus(elToFocus, {
          preventScroll: elToFocus === floating
        });
      }
    });
  }, [open, floating, ignoreInitialFocus, getTabbableElements, initialFocusRef]);
  index(() => {
    if (!floating) return;
    let preventReturnFocusScroll = false;
    const doc = getDocument(floating);
    const previouslyFocusedElement = activeElement(doc);
    const contextData = dataRef.current;
    previouslyFocusedElementRef.current = previouslyFocusedElement;

    // Dismissing via outside press should always ignore `returnFocus` to
    // prevent unwanted scrolling.
    function onDismiss(payload) {
      if (payload.type === 'escapeKey' && refs.domReference.current) {
        previouslyFocusedElementRef.current = refs.domReference.current;
      }
      if (['referencePress', 'escapeKey'].includes(payload.type)) {
        return;
      }
      const returnFocus = payload.data.returnFocus;
      if (typeof returnFocus === 'object') {
        preventReturnFocusRef.current = false;
        preventReturnFocusScroll = returnFocus.preventScroll;
      } else {
        preventReturnFocusRef.current = !returnFocus;
      }
    }
    events.on('dismiss', onDismiss);
    return () => {
      events.off('dismiss', onDismiss);
      const activeEl = activeElement(doc);
      const shouldFocusReference = contains(floating, activeEl) || tree && getChildren(tree.nodesRef.current, nodeId).some(node => {
        var _node$context5;
        return contains((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.floating, activeEl);
      }) || contextData.openEvent && ['click', 'mousedown'].includes(contextData.openEvent.type);
      if (shouldFocusReference && refs.domReference.current) {
        previouslyFocusedElementRef.current = refs.domReference.current;
      }
      if (
      // eslint-disable-next-line react-hooks/exhaustive-deps
      returnFocusRef.current && isHTMLElement(previouslyFocusedElementRef.current) && !preventReturnFocusRef.current) {
        enqueueFocus(previouslyFocusedElementRef.current, {
          // When dismissing nested floating elements, by the time the rAF has
          // executed, the menus will all have been unmounted. When they try
          // to get focused, the calls get ignored — leaving the root
          // reference focused as desired.
          cancelPrevious: false,
          preventScroll: preventReturnFocusScroll
        });
      }
    };
  }, [floating, returnFocusRef, dataRef, refs, events, tree, nodeId]);

  // Synchronize the `context` & `modal` value to the FloatingPortal context.
  // It will decide whether or not it needs to render its own guards.
  index(() => {
    if (!portalContext) return;
    portalContext.setFocusManagerState({
      ...context,
      modal,
      closeOnFocusOut,
      open
    });
    return () => {
      portalContext.setFocusManagerState(null);
    };
  }, [portalContext, modal, open, closeOnFocusOut, context]);
  index(() => {
    if (floating && typeof MutationObserver === 'function') {
      const handleMutation = () => {
        const tabIndex = floating.getAttribute('tabindex');
        if (orderRef.current.includes('floating') || activeElement(getDocument(floating)) !== refs.domReference.current && getTabbableContent().length === 0) {
          if (tabIndex !== '0') {
            floating.setAttribute('tabindex', '0');
          }
        } else if (tabIndex !== '-1') {
          floating.setAttribute('tabindex', '-1');
        }
      };
      handleMutation();
      const observer = new MutationObserver(handleMutation);
      observer.observe(floating, {
        childList: true,
        subtree: true,
        attributes: true
      });
      return () => {
        observer.disconnect();
      };
    }
  }, [floating, refs, orderRef, getTabbableContent]);
  function renderDismissButton(location) {
    return visuallyHiddenDismiss && modal ? /*#__PURE__*/React.createElement(VisuallyHiddenDismiss, {
      ref: location === 'start' ? startDismissButtonRef : endDismissButtonRef,
      onClick: event => onOpenChange(false, event.nativeEvent)
    }, typeof visuallyHiddenDismiss === 'string' ? visuallyHiddenDismiss : 'Dismiss') : null;
  }
  const shouldRenderGuards = guards && !isTypeableCombobox && (isInsidePortal || modal);
  return /*#__PURE__*/React.createElement(React.Fragment, null, shouldRenderGuards && /*#__PURE__*/React.createElement(FocusGuard, {
    "data-type": "inside",
    ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
    onFocus: event => {
      if (modal) {
        const els = getTabbableElements();
        enqueueFocus(order[0] === 'reference' ? els[0] : els[els.length - 1]);
      } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
        preventReturnFocusRef.current = false;
        if (isOutsideEvent(event, portalContext.portalNode)) {
          const nextTabbable = getNextTabbable() || domReference;
          nextTabbable == null ? void 0 : nextTabbable.focus();
        } else {
          var _portalContext$before;
          (_portalContext$before = portalContext.beforeOutsideRef.current) == null ? void 0 : _portalContext$before.focus();
        }
      }
    }
  }), !isTypeableCombobox && renderDismissButton('start'), children, renderDismissButton('end'), shouldRenderGuards && /*#__PURE__*/React.createElement(FocusGuard, {
    "data-type": "inside",
    ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
    onFocus: event => {
      if (modal) {
        enqueueFocus(getTabbableElements()[0]);
      } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
        if (closeOnFocusOut) {
          preventReturnFocusRef.current = true;
        }
        if (isOutsideEvent(event, portalContext.portalNode)) {
          const prevTabbable = getPreviousTabbable() || domReference;
          prevTabbable == null ? void 0 : prevTabbable.focus();
        } else {
          var _portalContext$afterO;
          (_portalContext$afterO = portalContext.afterOutsideRef.current) == null ? void 0 : _portalContext$afterO.focus();
        }
      }
    }
  }));
}

function sortByDocumentPosition(a, b) {
  const position = a.compareDocumentPosition(b);
  if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
    return -1;
  }
  if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) {
    return 1;
  }
  return 0;
}
function areMapsEqual(map1, map2) {
  if (map1.size !== map2.size) {
    return false;
  }
  for (const [key, value] of map1.entries()) {
    if (value !== map2.get(key)) {
      return false;
    }
  }
  return true;
}
const FloatingListContext = /*#__PURE__*/react.createContext({
  register: () => {},
  unregister: () => {},
  map: /*#__PURE__*/new Map(),
  elementsRef: {
    current: []
  }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */
function FloatingList(_ref) {
  let {
    children,
    elementsRef,
    labelsRef
  } = _ref;
  const [map, setMap] = React.useState(() => new Map());
  const register = React.useCallback(node => {
    setMap(prevMap => new Map(prevMap).set(node, null));
  }, []);
  const unregister = React.useCallback(node => {
    setMap(prevMap => {
      const map = new Map(prevMap);
      map.delete(node);
      return map;
    });
  }, []);
  index(() => {
    const newMap = new Map(map);
    const nodes = Array.from(newMap.keys()).sort(sortByDocumentPosition);
    nodes.forEach((node, index) => {
      newMap.set(node, index);
    });
    if (!areMapsEqual(map, newMap)) {
      setMap(newMap);
    }
  }, [map]);
  return /*#__PURE__*/React.createElement(FloatingListContext.Provider, {
    value: React.useMemo(() => ({
      register,
      unregister,
      map,
      elementsRef,
      labelsRef
    }), [register, unregister, map, elementsRef, labelsRef])
  }, children);
}
function useListItem(_temp) {
  let {
    label
  } = _temp === void 0 ? {} : _temp;
  const [index$1, setIndex] = React.useState(null);
  const componentRef = React.useRef(null);
  const {
    register,
    unregister,
    map,
    elementsRef,
    labelsRef
  } = React.useContext(FloatingListContext);
  const ref = React.useCallback(node => {
    componentRef.current = node;
    if (index$1 !== null) {
      elementsRef.current[index$1] = node;
      if (labelsRef) {
        var _node$textContent;
        const isLabelDefined = label !== undefined;
        labelsRef.current[index$1] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
      }
    }
  }, [index$1, elementsRef, labelsRef, label]);
  index(() => {
    const node = componentRef.current;
    if (node) {
      register(node);
      return () => {
        unregister(node);
      };
    }
  }, [register, unregister]);
  index(() => {
    const index = componentRef.current ? map.get(componentRef.current) : null;
    if (index != null) {
      setIndex(index);
    }
  }, [map]);
  return React.useMemo(() => ({
    ref,
    index: index$1 == null ? -1 : index$1
  }), [index$1, ref]);
}

const identifier = /*#__PURE__*/(/* unused pure expression or super */ null && (createAttribute('scroll-lock')));

/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */
const FloatingOverlay = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function FloatingOverlay(_ref, ref) {
  let {
    lockScroll = false,
    ...rest
  } = _ref;
  index(() => {
    var _window$visualViewpor, _window$visualViewpor2;
    if (!lockScroll) {
      return;
    }
    const alreadyLocked = document.body.hasAttribute(identifier);
    if (alreadyLocked) {
      return;
    }
    document.body.setAttribute(identifier, '');

    // RTL <body> scrollbar
    const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    const paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.
    if (!/iP(hone|ad|od)|iOS/.test(getPlatform())) {
      Object.assign(document.body.style, {
        overflow: 'hidden',
        [paddingProp]: scrollbarWidth + "px"
      });
      return () => {
        document.body.removeAttribute(identifier);
        Object.assign(document.body.style, {
          overflow: '',
          [paddingProp]: ''
        });
      };
    }

    // iOS 12 does not support `visualViewport`.
    const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
    const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
    const scrollX = window.pageXOffset;
    const scrollY = window.pageYOffset;
    Object.assign(document.body.style, {
      position: 'fixed',
      overflow: 'hidden',
      top: -(scrollY - Math.floor(offsetTop)) + "px",
      left: -(scrollX - Math.floor(offsetLeft)) + "px",
      right: '0',
      [paddingProp]: scrollbarWidth + "px"
    });
    return () => {
      Object.assign(document.body.style, {
        position: '',
        overflow: '',
        top: '',
        left: '',
        right: '',
        [paddingProp]: ''
      });
      document.body.removeAttribute(identifier);
      window.scrollTo(scrollX, scrollY);
    };
  }, [lockScroll]);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref
  }, rest, {
    style: {
      position: 'fixed',
      overflow: 'auto',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      ...rest.style
    }
  }));
})));

function isButtonTarget(event) {
  return isHTMLElement(event.target) && event.target.tagName === 'BUTTON';
}
function isSpaceIgnored(element) {
  return isTypeableElement(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */
function useClick(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    dataRef,
    elements: {
      domReference
    }
  } = context;
  const {
    enabled = true,
    event: eventOption = 'click',
    toggle = true,
    ignoreMouse = false,
    keyboardHandlers = true
  } = props;
  const pointerTypeRef = react.useRef();
  const didKeyDownRef = react.useRef(false);
  return react.useMemo(() => {
    if (!enabled) return {};
    return {
      reference: {
        onPointerDown(event) {
          pointerTypeRef.current = event.pointerType;
        },
        onMouseDown(event) {
          // Ignore all buttons except for the "main" button.
          // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
          if (event.button !== 0) {
            return;
          }
          if (isMouseLikePointerType(pointerTypeRef.current, true) && ignoreMouse) {
            return;
          }
          if (eventOption === 'click') {
            return;
          }
          if (open) {
            if (toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === 'mousedown' : true)) {
              onOpenChange(false, event.nativeEvent);
            }
          } else {
            // Prevent stealing focus from the floating element
            event.preventDefault();
            onOpenChange(true, event.nativeEvent);
          }
        },
        onClick(event) {
          if (eventOption === 'mousedown' && pointerTypeRef.current) {
            pointerTypeRef.current = undefined;
            return;
          }
          if (isMouseLikePointerType(pointerTypeRef.current, true) && ignoreMouse) {
            return;
          }
          if (open) {
            if (toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === 'click' : true)) {
              onOpenChange(false, event.nativeEvent);
            }
          } else {
            onOpenChange(true, event.nativeEvent);
          }
        },
        onKeyDown(event) {
          pointerTypeRef.current = undefined;
          if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event)) {
            return;
          }
          if (event.key === ' ' && !isSpaceIgnored(domReference)) {
            // Prevent scrolling
            event.preventDefault();
            didKeyDownRef.current = true;
          }
          if (event.key === 'Enter') {
            if (open) {
              if (toggle) {
                onOpenChange(false, event.nativeEvent);
              }
            } else {
              onOpenChange(true, event.nativeEvent);
            }
          }
        },
        onKeyUp(event) {
          if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event) || isSpaceIgnored(domReference)) {
            return;
          }
          if (event.key === ' ' && didKeyDownRef.current) {
            didKeyDownRef.current = false;
            if (open) {
              if (toggle) {
                onOpenChange(false, event.nativeEvent);
              }
            } else {
              onOpenChange(true, event.nativeEvent);
            }
          }
        }
      }
    };
  }, [enabled, dataRef, eventOption, ignoreMouse, keyboardHandlers, domReference, toggle, open, onOpenChange]);
}

// `toString()` prevents bundlers from trying to `import { useInsertionEffect } from 'react'`
const useInsertionEffect = react_namespaceObject[/*#__PURE__*/'useInsertionEffect'.toString()];
const useSafeInsertionEffect = useInsertionEffect || (fn => fn());
function useEffectEvent(callback) {
  const ref = react.useRef(() => {
    if (false) {}
  });
  useSafeInsertionEffect(() => {
    ref.current = callback;
  });
  return react.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current == null ? void 0 : ref.current(...args);
  }, []);
}

function createVirtualElement(domRef, data) {
  let offsetX = null;
  let offsetY = null;
  let isAutoUpdateEvent = false;
  return {
    contextElement: domRef.current || undefined,
    getBoundingClientRect() {
      var _domRef$current, _data$dataRef$current;
      const domRect = ((_domRef$current = domRef.current) == null ? void 0 : _domRef$current.getBoundingClientRect()) || {
        width: 0,
        height: 0,
        x: 0,
        y: 0
      };
      const isXAxis = data.axis === 'x' || data.axis === 'both';
      const isYAxis = data.axis === 'y' || data.axis === 'both';
      const canTrackCursorOnAutoUpdate = ['mouseenter', 'mousemove'].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || '') && data.pointerType !== 'touch';
      let width = domRect.width;
      let height = domRect.height;
      let x = domRect.x;
      let y = domRect.y;
      if (offsetX == null && data.x && isXAxis) {
        offsetX = domRect.x - data.x;
      }
      if (offsetY == null && data.y && isYAxis) {
        offsetY = domRect.y - data.y;
      }
      x -= offsetX || 0;
      y -= offsetY || 0;
      width = 0;
      height = 0;
      if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
        width = data.axis === 'y' ? domRect.width : 0;
        height = data.axis === 'x' ? domRect.height : 0;
        x = isXAxis && data.x != null ? data.x : x;
        y = isYAxis && data.y != null ? data.y : y;
      } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
        height = data.axis === 'x' ? domRect.height : height;
        width = data.axis === 'y' ? domRect.width : width;
      }
      isAutoUpdateEvent = true;
      return {
        width,
        height,
        x,
        y,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x
      };
    }
  };
}
function isMouseBasedEvent(event) {
  return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */
function useClientPoint(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    refs,
    dataRef,
    elements: {
      floating
    }
  } = context;
  const {
    enabled = true,
    axis = 'both',
    x = null,
    y = null
  } = props;
  const initialRef = React.useRef(false);
  const cleanupListenerRef = React.useRef(null);
  const [pointerType, setPointerType] = React.useState();
  const [reactive, setReactive] = React.useState([]);
  const setReference = useEffectEvent((x, y) => {
    if (initialRef.current) return;

    // Prevent setting if the open event was not a mouse-like one
    // (e.g. focus to open, then hover over the reference element).
    // Only apply if the event exists.
    if (dataRef.current.openEvent && !isMouseBasedEvent(dataRef.current.openEvent)) {
      return;
    }
    refs.setPositionReference(createVirtualElement(refs.domReference, {
      x,
      y,
      axis,
      dataRef,
      pointerType
    }));
  });
  const handleReferenceEnterOrMove = useEffectEvent(event => {
    if (x != null || y != null) return;
    if (!open) {
      setReference(event.clientX, event.clientY);
    } else if (!cleanupListenerRef.current) {
      // If there's no cleanup, there's no listener, but we want to ensure
      // we add the listener if the cursor landed on the floating element and
      // then back on the reference (i.e. it's interactive).
      setReactive([]);
    }
  });

  // If the pointer is a mouse-like pointer, we want to continue following the
  // mouse even if the floating element is transitioning out. On touch
  // devices, this is undesirable because the floating element will move to
  // the dismissal touch point.
  const openCheck = isMouseLikePointerType(pointerType) ? floating : open;
  const addListener = React.useCallback(() => {
    // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
    if (!openCheck || !enabled || x != null || y != null) return;
    const win = getWindow(refs.floating.current);
    function handleMouseMove(event) {
      const target = getTarget(event);
      if (!contains(refs.floating.current, target)) {
        setReference(event.clientX, event.clientY);
      } else {
        win.removeEventListener('mousemove', handleMouseMove);
        cleanupListenerRef.current = null;
      }
    }
    if (!dataRef.current.openEvent || isMouseBasedEvent(dataRef.current.openEvent)) {
      win.addEventListener('mousemove', handleMouseMove);
      const cleanup = () => {
        win.removeEventListener('mousemove', handleMouseMove);
        cleanupListenerRef.current = null;
      };
      cleanupListenerRef.current = cleanup;
      return cleanup;
    }
    refs.setPositionReference(refs.domReference.current);
  }, [dataRef, enabled, openCheck, refs, setReference, x, y]);
  React.useEffect(() => {
    return addListener();
  }, [addListener, reactive]);
  React.useEffect(() => {
    if (enabled && !floating) {
      initialRef.current = false;
    }
  }, [enabled, floating]);
  React.useEffect(() => {
    if (!enabled && open) {
      initialRef.current = true;
    }
  }, [enabled, open]);
  index(() => {
    if (enabled && (x != null || y != null)) {
      initialRef.current = false;
      setReference(x, y);
    }
  }, [enabled, x, y, setReference]);
  return React.useMemo(() => {
    if (!enabled) return {};
    function setPointerTypeRef(_ref) {
      let {
        pointerType
      } = _ref;
      setPointerType(pointerType);
    }
    return {
      reference: {
        onPointerDown: setPointerTypeRef,
        onPointerEnter: setPointerTypeRef,
        onMouseMove: handleReferenceEnterOrMove,
        onMouseEnter: handleReferenceEnterOrMove
      }
    };
  }, [enabled, handleReferenceEnterOrMove]);
}

/**
 * Check whether the event.target is within the provided node. Uses event.composedPath if available for custom element support.
 *
 * @param event The event whose target/composedPath to check
 * @param node The node to check against
 * @returns Whether the event.target/composedPath is within the node.
 */
function isEventTargetWithin(event, node) {
  if (node == null) {
    return false;
  }
  if ('composedPath' in event) {
    return event.composedPath().includes(node);
  }

  // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
  const e = event;
  return e.target != null && node.contains(e.target);
}

const bubbleHandlerKeys = {
  pointerdown: 'onPointerDown',
  mousedown: 'onMouseDown',
  click: 'onClick'
};
const captureHandlerKeys = {
  pointerdown: 'onPointerDownCapture',
  mousedown: 'onMouseDownCapture',
  click: 'onClickCapture'
};
const normalizeBubblesProp = bubbles => {
  var _bubbles$escapeKey, _bubbles$outsidePress;
  return {
    escapeKeyBubbles: typeof bubbles === 'boolean' ? bubbles : (_bubbles$escapeKey = bubbles == null ? void 0 : bubbles.escapeKey) != null ? _bubbles$escapeKey : false,
    outsidePressBubbles: typeof bubbles === 'boolean' ? bubbles : (_bubbles$outsidePress = bubbles == null ? void 0 : bubbles.outsidePress) != null ? _bubbles$outsidePress : true
  };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */
function useDismiss(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    events,
    nodeId,
    elements: {
      reference,
      domReference,
      floating
    },
    dataRef
  } = context;
  const {
    enabled = true,
    escapeKey = true,
    outsidePress: unstable_outsidePress = true,
    outsidePressEvent = 'pointerdown',
    referencePress = false,
    referencePressEvent = 'pointerdown',
    ancestorScroll = false,
    bubbles
  } = props;
  const tree = useFloatingTree();
  const nested = useFloatingParentNodeId() != null;
  const outsidePressFn = useEffectEvent(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : () => false);
  const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
  const insideReactTreeRef = React.useRef(false);
  const {
    escapeKeyBubbles,
    outsidePressBubbles
  } = normalizeBubblesProp(bubbles);
  const closeOnEscapeKeyDown = useEffectEvent(event => {
    if (!open || !enabled || !escapeKey || event.key !== 'Escape') {
      return;
    }
    const children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
    if (!escapeKeyBubbles) {
      event.stopPropagation();
      if (children.length > 0) {
        let shouldDismiss = true;
        children.forEach(child => {
          var _child$context;
          if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
            shouldDismiss = false;
            return;
          }
        });
        if (!shouldDismiss) {
          return;
        }
      }
    }
    events.emit('dismiss', {
      type: 'escapeKey',
      data: {
        returnFocus: {
          preventScroll: false
        }
      }
    });
    onOpenChange(false, isReactEvent(event) ? event.nativeEvent : event);
  });
  const closeOnPressOutside = useEffectEvent(event => {
    // Given developers can stop the propagation of the synthetic event,
    // we can only be confident with a positive value.
    const insideReactTree = insideReactTreeRef.current;
    insideReactTreeRef.current = false;
    if (insideReactTree) {
      return;
    }
    if (typeof outsidePress === 'function' && !outsidePress(event)) {
      return;
    }
    const target = getTarget(event);

    // Check if the click occurred on the scrollbar
    if (isHTMLElement(target) && floating) {
      // In Firefox, `target.scrollWidth > target.clientWidth` for inline
      // elements.
      const canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
      const canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
      let xCond = canScrollY && event.offsetX > target.clientWidth;

      // In some browsers it is possible to change the <body> (or window)
      // scrollbar to the left side, but is very rare and is difficult to
      // check for. Plus, for modal dialogs with backdrops, it is more
      // important that the backdrop is checked but not so much the window.
      if (canScrollY) {
        const isRTL = getWindow(floating).getComputedStyle(target).direction === 'rtl';
        if (isRTL) {
          xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
        }
      }
      if (xCond || canScrollX && event.offsetY > target.clientHeight) {
        return;
      }
    }
    const targetIsInsideChildren = tree && getChildren(tree.nodesRef.current, nodeId).some(node => {
      var _node$context;
      return isEventTargetWithin(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
    });
    if (isEventTargetWithin(event, floating) || isEventTargetWithin(event, domReference) || targetIsInsideChildren) {
      return;
    }
    const children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
    if (children.length > 0) {
      let shouldDismiss = true;
      children.forEach(child => {
        var _child$context2;
        if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
          shouldDismiss = false;
          return;
        }
      });
      if (!shouldDismiss) {
        return;
      }
    }
    events.emit('dismiss', {
      type: 'outsidePress',
      data: {
        returnFocus: nested ? {
          preventScroll: true
        } : isVirtualClick(event) || isVirtualPointerEvent(event)
      }
    });
    onOpenChange(false, event);
  });
  React.useEffect(() => {
    if (!open || !enabled) {
      return;
    }
    dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
    dataRef.current.__outsidePressBubbles = outsidePressBubbles;
    function onScroll(event) {
      onOpenChange(false, event);
    }
    const doc = getDocument(floating);
    escapeKey && doc.addEventListener('keydown', closeOnEscapeKeyDown);
    outsidePress && doc.addEventListener(outsidePressEvent, closeOnPressOutside);
    let ancestors = [];
    if (ancestorScroll) {
      if (isElement(domReference)) {
        ancestors = getOverflowAncestors(domReference);
      }
      if (isElement(floating)) {
        ancestors = ancestors.concat(getOverflowAncestors(floating));
      }
      if (!isElement(reference) && reference && reference.contextElement) {
        ancestors = ancestors.concat(getOverflowAncestors(reference.contextElement));
      }
    }

    // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
    ancestors = ancestors.filter(ancestor => {
      var _doc$defaultView;
      return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
    });
    ancestors.forEach(ancestor => {
      ancestor.addEventListener('scroll', onScroll, {
        passive: true
      });
    });
    return () => {
      escapeKey && doc.removeEventListener('keydown', closeOnEscapeKeyDown);
      outsidePress && doc.removeEventListener(outsidePressEvent, closeOnPressOutside);
      ancestors.forEach(ancestor => {
        ancestor.removeEventListener('scroll', onScroll);
      });
    };
  }, [dataRef, floating, domReference, reference, escapeKey, outsidePress, outsidePressEvent, open, onOpenChange, ancestorScroll, enabled, escapeKeyBubbles, outsidePressBubbles, closeOnEscapeKeyDown, closeOnPressOutside]);
  React.useEffect(() => {
    insideReactTreeRef.current = false;
  }, [outsidePress, outsidePressEvent]);
  return React.useMemo(() => {
    if (!enabled) {
      return {};
    }
    return {
      reference: {
        onKeyDown: closeOnEscapeKeyDown,
        [bubbleHandlerKeys[referencePressEvent]]: event => {
          if (referencePress) {
            events.emit('dismiss', {
              type: 'referencePress',
              data: {
                returnFocus: false
              }
            });
            onOpenChange(false, event.nativeEvent);
          }
        }
      },
      floating: {
        onKeyDown: closeOnEscapeKeyDown,
        [captureHandlerKeys[outsidePressEvent]]: () => {
          insideReactTreeRef.current = true;
        }
      }
    };
  }, [enabled, events, referencePress, outsidePressEvent, referencePressEvent, onOpenChange, closeOnEscapeKeyDown]);
}

/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/react
 */
function useFloating(options) {
  var _options$elements;
  if (options === void 0) {
    options = {};
  }
  const {
    open = false,
    onOpenChange: unstable_onOpenChange,
    nodeId
  } = options;
  const [_domReference, setDomReference] = react.useState(null);
  const domReference = ((_options$elements = options.elements) == null ? void 0 : _options$elements.reference) || _domReference;
  const position = (0,floating_ui_react_dom_esm/* useFloating */.YF)(options);
  const tree = useFloatingTree();
  const onOpenChange = useEffectEvent((open, event) => {
    if (open) {
      dataRef.current.openEvent = event;
    }
    unstable_onOpenChange == null ? void 0 : unstable_onOpenChange(open, event);
  });
  const domReferenceRef = react.useRef(null);
  const dataRef = react.useRef({});
  const events = react.useState(() => createPubSub())[0];
  const floatingId = useId();
  const setPositionReference = react.useCallback(node => {
    const positionReference = isElement(node) ? {
      getBoundingClientRect: () => node.getBoundingClientRect(),
      contextElement: node
    } : node;
    position.refs.setReference(positionReference);
  }, [position.refs]);
  const setReference = react.useCallback(node => {
    if (isElement(node) || node === null) {
      domReferenceRef.current = node;
      setDomReference(node);
    }

    // Backwards-compatibility for passing a virtual element to `reference`
    // after it has set the DOM reference.
    if (isElement(position.refs.reference.current) || position.refs.reference.current === null ||
    // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    node !== null && !isElement(node)) {
      position.refs.setReference(node);
    }
  }, [position.refs]);
  const refs = react.useMemo(() => ({
    ...position.refs,
    setReference,
    setPositionReference,
    domReference: domReferenceRef
  }), [position.refs, setReference, setPositionReference]);
  const elements = react.useMemo(() => ({
    ...position.elements,
    domReference: domReference
  }), [position.elements, domReference]);
  const context = react.useMemo(() => ({
    ...position,
    refs,
    elements,
    dataRef,
    nodeId,
    floatingId,
    events,
    open,
    onOpenChange
  }), [position, nodeId, floatingId, events, open, onOpenChange, refs, elements]);
  index(() => {
    const node = tree == null ? void 0 : tree.nodesRef.current.find(node => node.id === nodeId);
    if (node) {
      node.context = context;
    }
  });
  return react.useMemo(() => ({
    ...position,
    context,
    refs,
    elements
  }), [position, refs, elements, context]);
}

/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */
function useFocus(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    dataRef,
    events,
    refs,
    elements: {
      floating,
      domReference
    }
  } = context;
  const {
    enabled = true,
    keyboardOnly = true
  } = props;
  const pointerTypeRef = React.useRef('');
  const blockFocusRef = React.useRef(false);
  const timeoutRef = React.useRef();
  React.useEffect(() => {
    if (!enabled) {
      return;
    }
    const doc = getDocument(floating);
    const win = doc.defaultView || window;

    // If the reference was focused and the user left the tab/window, and the
    // floating element was not open, the focus should be blocked when they
    // return to the tab/window.
    function onBlur() {
      if (!open && isHTMLElement(domReference) && domReference === activeElement(getDocument(domReference))) {
        blockFocusRef.current = true;
      }
    }
    win.addEventListener('blur', onBlur);
    return () => {
      win.removeEventListener('blur', onBlur);
    };
  }, [floating, domReference, open, enabled]);
  React.useEffect(() => {
    if (!enabled) {
      return;
    }
    function onDismiss(payload) {
      if (payload.type === 'referencePress' || payload.type === 'escapeKey') {
        blockFocusRef.current = true;
      }
    }
    events.on('dismiss', onDismiss);
    return () => {
      events.off('dismiss', onDismiss);
    };
  }, [events, enabled]);
  React.useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);
  return React.useMemo(() => {
    if (!enabled) {
      return {};
    }
    return {
      reference: {
        onPointerDown(_ref) {
          let {
            pointerType
          } = _ref;
          pointerTypeRef.current = pointerType;
          blockFocusRef.current = !!(pointerType && keyboardOnly);
        },
        onMouseLeave() {
          blockFocusRef.current = false;
        },
        onFocus(event) {
          var _dataRef$current$open;
          if (blockFocusRef.current) {
            return;
          }

          // Dismiss with click should ignore the subsequent `focus` trigger,
          // but only if the click originated inside the reference element.
          if (event.type === 'focus' && ((_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type) === 'mousedown' && isEventTargetWithin(dataRef.current.openEvent, domReference)) {
            return;
          }
          onOpenChange(true, event.nativeEvent);
        },
        onBlur(event) {
          blockFocusRef.current = false;
          const relatedTarget = event.relatedTarget;

          // Hit the non-modal focus management portal guard. Focus will be
          // moved into the floating element immediately after.
          const movedToFocusGuard = isElement(relatedTarget) && relatedTarget.hasAttribute(createAttribute('focus-guard')) && relatedTarget.getAttribute('data-type') === 'outside';

          // Wait for the window blur listener to fire.
          timeoutRef.current = setTimeout(() => {
            // When focusing the reference element (e.g. regular click), then
            // clicking into the floating element, prevent it from hiding.
            // Note: it must be focusable, e.g. `tabindex="-1"`.
            if (contains(refs.floating.current, relatedTarget) || contains(domReference, relatedTarget) || movedToFocusGuard) {
              return;
            }
            onOpenChange(false, event.nativeEvent);
          });
        }
      }
    };
  }, [enabled, keyboardOnly, domReference, refs, dataRef, onOpenChange]);
}

function mergeProps(userProps, propsList, elementKey) {
  const map = new Map();
  return {
    ...(elementKey === 'floating' && {
      tabIndex: -1
    }),
    ...userProps,
    ...propsList.map(value => value ? value[elementKey] : null).concat(userProps).reduce((acc, props) => {
      if (!props) {
        return acc;
      }
      Object.entries(props).forEach(_ref => {
        let [key, value] = _ref;
        if (key.indexOf('on') === 0) {
          if (!map.has(key)) {
            map.set(key, []);
          }
          if (typeof value === 'function') {
            var _map$get;
            (_map$get = map.get(key)) == null ? void 0 : _map$get.push(value);
            acc[key] = function () {
              var _map$get2;
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map(fn => fn(...args)).find(val => val !== undefined);
            };
          }
        } else {
          acc[key] = value;
        }
      });
      return acc;
    }, {})
  };
}

/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/react#interaction-hooks
 */
function useInteractions(propsList) {
  if (propsList === void 0) {
    propsList = [];
  }
  // The dependencies are a dynamic array, so we can't use the linter's
  // suggestion to add it to the deps array.
  const deps = propsList;
  const getReferenceProps = react.useCallback(userProps => mergeProps(userProps, propsList, 'reference'),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  deps);
  const getFloatingProps = react.useCallback(userProps => mergeProps(userProps, propsList, 'floating'),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  deps);
  const getItemProps = react.useCallback(userProps => mergeProps(userProps, propsList, 'item'),
  // Granularly check for `item` changes, because the `getItemProps` getter
  // should be as referentially stable as possible since it may be passed as
  // a prop to many components. All `item` key values must therefore be
  // memoized.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  propsList.map(key => key == null ? void 0 : key.item));
  return react.useMemo(() => ({
    getReferenceProps,
    getFloatingProps,
    getItemProps
  }), [getReferenceProps, getFloatingProps, getItemProps]);
}

let isPreventScrollSupported = false;
const ARROW_UP = 'ArrowUp';
const ARROW_DOWN = 'ArrowDown';
const ARROW_LEFT = 'ArrowLeft';
const ARROW_RIGHT = 'ArrowRight';
function isDifferentRow(index, cols, prevRow) {
  return Math.floor(index / cols) !== prevRow;
}
function isIndexOutOfBounds(listRef, index) {
  return index < 0 || index >= listRef.current.length;
}
function findNonDisabledIndex(listRef, _temp) {
  let {
    startingIndex = -1,
    decrement = false,
    disabledIndices,
    amount = 1
  } = _temp === void 0 ? {} : _temp;
  const list = listRef.current;
  let index = startingIndex;
  do {
    var _list$index, _list$index2;
    index = index + (decrement ? -amount : amount);
  } while (index >= 0 && index <= list.length - 1 && (disabledIndices ? disabledIndices.includes(index) : list[index] == null || ((_list$index = list[index]) == null ? void 0 : _list$index.hasAttribute('disabled')) || ((_list$index2 = list[index]) == null ? void 0 : _list$index2.getAttribute('aria-disabled')) === 'true' || isHidden(list[index])));
  return index;
}
function doSwitch(orientation, vertical, horizontal) {
  switch (orientation) {
    case 'vertical':
      return vertical;
    case 'horizontal':
      return horizontal;
    default:
      return vertical || horizontal;
  }
}
function isMainOrientationKey(key, orientation) {
  const vertical = key === ARROW_UP || key === ARROW_DOWN;
  const horizontal = key === ARROW_LEFT || key === ARROW_RIGHT;
  return doSwitch(orientation, vertical, horizontal);
}
function isMainOrientationToEndKey(key, orientation, rtl) {
  const vertical = key === ARROW_DOWN;
  const horizontal = rtl ? key === ARROW_LEFT : key === ARROW_RIGHT;
  return doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key == ' ' || key === '';
}
function isCrossOrientationOpenKey(key, orientation, rtl) {
  const vertical = rtl ? key === ARROW_LEFT : key === ARROW_RIGHT;
  const horizontal = key === ARROW_DOWN;
  return doSwitch(orientation, vertical, horizontal);
}
function isCrossOrientationCloseKey(key, orientation, rtl) {
  const vertical = rtl ? key === ARROW_RIGHT : key === ARROW_LEFT;
  const horizontal = key === ARROW_UP;
  return doSwitch(orientation, vertical, horizontal);
}
function getMinIndex(listRef, disabledIndices) {
  return findNonDisabledIndex(listRef, {
    disabledIndices
  });
}
function getMaxIndex(listRef, disabledIndices) {
  return findNonDisabledIndex(listRef, {
    decrement: true,
    startingIndex: listRef.current.length,
    disabledIndices
  });
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */
function useListNavigation(context, props) {
  const {
    open,
    onOpenChange,
    refs,
    elements: {
      domReference,
      floating
    }
  } = context;
  const {
    listRef,
    activeIndex,
    onNavigate: unstable_onNavigate = () => {},
    enabled = true,
    selectedIndex = null,
    allowEscape = false,
    loop = false,
    nested = false,
    rtl = false,
    virtual = false,
    focusItemOnOpen = 'auto',
    focusItemOnHover = true,
    openOnArrowKeyDown = true,
    disabledIndices = undefined,
    orientation = 'vertical',
    cols = 1,
    scrollItemIntoView = true
  } = props;
  if (false) {}
  const parentId = useFloatingParentNodeId();
  const tree = useFloatingTree();
  const onNavigate = useEffectEvent(unstable_onNavigate);
  const focusItemOnOpenRef = React.useRef(focusItemOnOpen);
  const indexRef = React.useRef(selectedIndex != null ? selectedIndex : -1);
  const keyRef = React.useRef(null);
  const isPointerModalityRef = React.useRef(true);
  const previousOnNavigateRef = React.useRef(onNavigate);
  const previousMountedRef = React.useRef(!!floating);
  const forceSyncFocus = React.useRef(false);
  const forceScrollIntoViewRef = React.useRef(false);
  const disabledIndicesRef = useLatestRef(disabledIndices);
  const latestOpenRef = useLatestRef(open);
  const scrollItemIntoViewRef = useLatestRef(scrollItemIntoView);
  const [activeId, setActiveId] = React.useState();
  const focusItem = useEffectEvent(function (listRef, indexRef, forceScrollIntoView) {
    if (forceScrollIntoView === void 0) {
      forceScrollIntoView = false;
    }
    const item = listRef.current[indexRef.current];
    if (!item) return;
    if (virtual) {
      setActiveId(item.id);
    } else {
      enqueueFocus(item, {
        preventScroll: true,
        // Mac Safari does not move the virtual cursor unless the focus call
        // is sync. However, for the very first focus call, we need to wait
        // for the position to be ready in order to prevent unwanted
        // scrolling. This means the virtual cursor will not move to the first
        // item when first opening the floating element, but will on
        // subsequent calls. `preventScroll` is supported in modern Safari,
        // so we can use that instead.
        // iOS Safari must be async or the first item will not be focused.
        sync: isMac() && isSafari() ? isPreventScrollSupported || forceSyncFocus.current : false
      });
    }
    requestAnimationFrame(() => {
      const scrollIntoViewOptions = scrollItemIntoViewRef.current;
      const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
      if (shouldScrollIntoView) {
        // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
        // by all browsers.
        item.scrollIntoView == null ? void 0 : item.scrollIntoView(typeof scrollIntoViewOptions === 'boolean' ? {
          block: 'nearest',
          inline: 'nearest'
        } : scrollIntoViewOptions);
      }
    });
  });
  index(() => {
    document.createElement('div').focus({
      get preventScroll() {
        isPreventScrollSupported = true;
        return false;
      }
    });
  }, []);

  // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
  // element. Also, reset `activeIndex` upon closing the floating element.
  index(() => {
    if (!enabled) {
      return;
    }
    if (open && floating) {
      if (focusItemOnOpenRef.current && selectedIndex != null) {
        // Regardless of the pointer modality, we want to ensure the selected
        // item comes into view when the floating element is opened.
        forceScrollIntoViewRef.current = true;
        onNavigate(selectedIndex);
      }
    } else if (previousMountedRef.current) {
      // Since the user can specify `onNavigate` conditionally
      // (onNavigate: open ? setActiveIndex : setSelectedIndex),
      // we store and call the previous function.
      indexRef.current = -1;
      previousOnNavigateRef.current(null);
    }
  }, [enabled, open, floating, selectedIndex, onNavigate]);

  // Sync `activeIndex` to be the focused item while the floating element is
  // open.
  index(() => {
    if (!enabled) {
      return;
    }
    if (open && floating) {
      if (activeIndex == null) {
        forceSyncFocus.current = false;
        if (selectedIndex != null) {
          return;
        }

        // Reset while the floating element was open (e.g. the list changed).
        if (previousMountedRef.current) {
          indexRef.current = -1;
          focusItem(listRef, indexRef);
        }

        // Initial sync.
        if (!previousMountedRef.current && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
          let runs = 0;
          const waitForListPopulated = () => {
            if (listRef.current[0] == null) {
              // Avoid letting the browser paint if possible on the first try,
              // otherwise use rAF. Don't try more than twice, since something
              // is wrong otherwise.
              if (runs < 2) {
                const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                scheduler(waitForListPopulated);
              }
              runs++;
            } else {
              indexRef.current = keyRef.current == null || isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? getMinIndex(listRef, disabledIndicesRef.current) : getMaxIndex(listRef, disabledIndicesRef.current);
              keyRef.current = null;
              onNavigate(indexRef.current);
            }
          };
          waitForListPopulated();
        }
      } else if (!isIndexOutOfBounds(listRef, activeIndex)) {
        indexRef.current = activeIndex;
        focusItem(listRef, indexRef, forceScrollIntoViewRef.current);
        forceScrollIntoViewRef.current = false;
      }
    }
  }, [enabled, open, floating, activeIndex, selectedIndex, nested, listRef, orientation, rtl, onNavigate, focusItem, disabledIndicesRef]);

  // Ensure the parent floating element has focus when a nested child closes
  // to allow arrow key navigation to work after the pointer leaves the child.
  index(() => {
    if (!enabled) {
      return;
    }
    if (previousMountedRef.current && !floating && tree) {
      var _nodes$find, _nodes$find$context;
      const nodes = tree.nodesRef.current;
      const parent = (_nodes$find = nodes.find(node => node.id === parentId)) == null ? void 0 : (_nodes$find$context = _nodes$find.context) == null ? void 0 : _nodes$find$context.elements.floating;
      const activeEl = activeElement(getDocument(floating));
      const treeContainsActiveEl = nodes.some(node => node.context && contains(node.context.elements.floating, activeEl));
      if (parent && !treeContainsActiveEl) {
        parent.focus({
          preventScroll: true
        });
      }
    }
  }, [enabled, floating, tree, parentId]);
  index(() => {
    previousOnNavigateRef.current = onNavigate;
    previousMountedRef.current = !!floating;
  });
  index(() => {
    if (!open) {
      keyRef.current = null;
    }
  }, [open]);
  const hasActiveIndex = activeIndex != null;
  const item = React.useMemo(() => {
    function syncCurrentTarget(currentTarget) {
      if (!open) return;
      const index = listRef.current.indexOf(currentTarget);
      if (index !== -1) {
        onNavigate(index);
      }
    }
    const props = {
      onFocus(_ref) {
        let {
          currentTarget
        } = _ref;
        syncCurrentTarget(currentTarget);
      },
      onClick: _ref2 => {
        let {
          currentTarget
        } = _ref2;
        return currentTarget.focus({
          preventScroll: true
        });
      },
      // Safari
      ...(focusItemOnHover && {
        onMouseMove(_ref3) {
          let {
            currentTarget
          } = _ref3;
          syncCurrentTarget(currentTarget);
        },
        onPointerLeave(_ref4) {
          let {
            pointerType
          } = _ref4;
          if (!isPointerModalityRef.current || pointerType === 'touch') {
            return;
          }
          indexRef.current = -1;
          focusItem(listRef, indexRef);
          onNavigate(null);
          if (!virtual) {
            enqueueFocus(refs.floating.current, {
              preventScroll: true
            });
          }
        }
      })
    };
    return props;
  }, [open, refs, focusItem, focusItemOnHover, listRef, onNavigate, virtual]);
  return React.useMemo(() => {
    if (!enabled) {
      return {};
    }
    const disabledIndices = disabledIndicesRef.current;
    function onKeyDown(event) {
      isPointerModalityRef.current = false;
      forceSyncFocus.current = true;

      // If the floating element is animating out, ignore navigation. Otherwise,
      // the `activeIndex` gets set to 0 despite not being open so the next time
      // the user ArrowDowns, the first item won't be focused.
      if (!latestOpenRef.current && event.currentTarget === refs.floating.current) {
        return;
      }
      if (nested && isCrossOrientationCloseKey(event.key, orientation, rtl)) {
        stopEvent(event);
        onOpenChange(false, event.nativeEvent);
        if (isHTMLElement(domReference)) {
          domReference.focus();
        }
        return;
      }
      const currentIndex = indexRef.current;
      const minIndex = getMinIndex(listRef, disabledIndices);
      const maxIndex = getMaxIndex(listRef, disabledIndices);
      if (event.key === 'Home') {
        stopEvent(event);
        indexRef.current = minIndex;
        onNavigate(indexRef.current);
      }
      if (event.key === 'End') {
        stopEvent(event);
        indexRef.current = maxIndex;
        onNavigate(indexRef.current);
      }

      // Grid navigation.
      if (cols > 1) {
        const prevIndex = indexRef.current;
        if (event.key === ARROW_UP) {
          stopEvent(event);
          if (prevIndex === -1) {
            indexRef.current = maxIndex;
          } else {
            indexRef.current = findNonDisabledIndex(listRef, {
              startingIndex: prevIndex,
              amount: cols,
              decrement: true,
              disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || indexRef.current < 0)) {
              const col = prevIndex % cols;
              const maxCol = maxIndex % cols;
              const offset = maxIndex - (maxCol - col);
              if (maxCol === col) {
                indexRef.current = maxIndex;
              } else {
                indexRef.current = maxCol > col ? offset : offset - cols;
              }
            }
          }
          if (isIndexOutOfBounds(listRef, indexRef.current)) {
            indexRef.current = prevIndex;
          }
          onNavigate(indexRef.current);
        }
        if (event.key === ARROW_DOWN) {
          stopEvent(event);
          if (prevIndex === -1) {
            indexRef.current = minIndex;
          } else {
            indexRef.current = findNonDisabledIndex(listRef, {
              startingIndex: prevIndex,
              amount: cols,
              disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) {
              indexRef.current = findNonDisabledIndex(listRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices
              });
            }
          }
          if (isIndexOutOfBounds(listRef, indexRef.current)) {
            indexRef.current = prevIndex;
          }
          onNavigate(indexRef.current);
        }

        // Remains on the same row/column.
        if (orientation === 'both') {
          const prevRow = Math.floor(prevIndex / cols);
          if (event.key === ARROW_RIGHT) {
            stopEvent(event);
            if (prevIndex % cols !== cols - 1) {
              indexRef.current = findNonDisabledIndex(listRef, {
                startingIndex: prevIndex,
                disabledIndices
              });
              if (loop && isDifferentRow(indexRef.current, cols, prevRow)) {
                indexRef.current = findNonDisabledIndex(listRef, {
                  startingIndex: prevIndex - prevIndex % cols - 1,
                  disabledIndices
                });
              }
            } else if (loop) {
              indexRef.current = findNonDisabledIndex(listRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices
              });
            }
            if (isDifferentRow(indexRef.current, cols, prevRow)) {
              indexRef.current = prevIndex;
            }
          }
          if (event.key === ARROW_LEFT) {
            stopEvent(event);
            if (prevIndex % cols !== 0) {
              indexRef.current = findNonDisabledIndex(listRef, {
                startingIndex: prevIndex,
                disabledIndices,
                decrement: true
              });
              if (loop && isDifferentRow(indexRef.current, cols, prevRow)) {
                indexRef.current = findNonDisabledIndex(listRef, {
                  startingIndex: prevIndex + (cols - prevIndex % cols),
                  decrement: true,
                  disabledIndices
                });
              }
            } else if (loop) {
              indexRef.current = findNonDisabledIndex(listRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices
              });
            }
            if (isDifferentRow(indexRef.current, cols, prevRow)) {
              indexRef.current = prevIndex;
            }
          }
          const lastRow = Math.floor(maxIndex / cols) === prevRow;
          if (isIndexOutOfBounds(listRef, indexRef.current)) {
            if (loop && lastRow) {
              indexRef.current = event.key === ARROW_LEFT ? maxIndex : findNonDisabledIndex(listRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices
              });
            } else {
              indexRef.current = prevIndex;
            }
          }
          onNavigate(indexRef.current);
          return;
        }
      }
      if (isMainOrientationKey(event.key, orientation)) {
        stopEvent(event);

        // Reset the index if no item is focused.
        if (open && !virtual && activeElement(event.currentTarget.ownerDocument) === event.currentTarget) {
          indexRef.current = isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
          onNavigate(indexRef.current);
          return;
        }
        if (isMainOrientationToEndKey(event.key, orientation, rtl)) {
          if (loop) {
            indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : findNonDisabledIndex(listRef, {
              startingIndex: currentIndex,
              disabledIndices
            });
          } else {
            indexRef.current = Math.min(maxIndex, findNonDisabledIndex(listRef, {
              startingIndex: currentIndex,
              disabledIndices
            }));
          }
        } else {
          if (loop) {
            indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : findNonDisabledIndex(listRef, {
              startingIndex: currentIndex,
              decrement: true,
              disabledIndices
            });
          } else {
            indexRef.current = Math.max(minIndex, findNonDisabledIndex(listRef, {
              startingIndex: currentIndex,
              decrement: true,
              disabledIndices
            }));
          }
        }
        if (isIndexOutOfBounds(listRef, indexRef.current)) {
          onNavigate(null);
        } else {
          onNavigate(indexRef.current);
        }
      }
    }
    function checkVirtualMouse(event) {
      if (focusItemOnOpen === 'auto' && isVirtualClick(event.nativeEvent)) {
        focusItemOnOpenRef.current = true;
      }
    }
    function checkVirtualPointer(event) {
      // `pointerdown` fires first, reset the state then perform the checks.
      focusItemOnOpenRef.current = focusItemOnOpen;
      if (focusItemOnOpen === 'auto' && isVirtualPointerEvent(event.nativeEvent)) {
        focusItemOnOpenRef.current = true;
      }
    }
    const ariaActiveDescendantProp = virtual && open && hasActiveIndex && {
      'aria-activedescendant': activeId
    };
    return {
      reference: {
        ...ariaActiveDescendantProp,
        onKeyDown(event) {
          isPointerModalityRef.current = false;
          const isArrowKey = event.key.indexOf('Arrow') === 0;
          if (virtual && open) {
            return onKeyDown(event);
          }

          // If a floating element should not open on arrow key down, avoid
          // setting `activeIndex` while it's closed.
          if (!open && !openOnArrowKeyDown && isArrowKey) {
            return;
          }
          const isNavigationKey = isArrowKey || event.key === 'Enter' || event.key.trim() === '';
          const isMainKey = isMainOrientationKey(event.key, orientation);
          const isCrossKey = isCrossOrientationOpenKey(event.key, orientation, rtl);
          if (isNavigationKey) {
            keyRef.current = nested && isMainKey ? null : event.key;
          }
          if (nested) {
            if (isCrossKey) {
              stopEvent(event);
              if (open) {
                indexRef.current = getMinIndex(listRef, disabledIndices);
                onNavigate(indexRef.current);
              } else {
                onOpenChange(true, event.nativeEvent);
              }
            }
            return;
          }
          if (isMainKey) {
            if (selectedIndex != null) {
              indexRef.current = selectedIndex;
            }
            stopEvent(event);
            if (!open && openOnArrowKeyDown) {
              onOpenChange(true, event.nativeEvent);
            } else {
              onKeyDown(event);
            }
            if (open) {
              onNavigate(indexRef.current);
            }
          }
        },
        onFocus() {
          if (open) {
            onNavigate(null);
          }
        },
        onPointerDown: checkVirtualPointer,
        onMouseDown: checkVirtualMouse,
        onClick: checkVirtualMouse
      },
      floating: {
        'aria-orientation': orientation === 'both' ? undefined : orientation,
        ...ariaActiveDescendantProp,
        onKeyDown,
        onPointerMove() {
          isPointerModalityRef.current = true;
        }
      },
      item
    };
  }, [domReference, refs, activeId, disabledIndicesRef, latestOpenRef, listRef, enabled, orientation, rtl, virtual, open, hasActiveIndex, nested, selectedIndex, openOnArrowKeyDown, allowEscape, cols, loop, focusItemOnOpen, onNavigate, onOpenChange, item]);
}

/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/useMergeRefs
 */
function useMergeRefs(refs) {
  return React.useMemo(() => {
    if (refs.every(ref => ref == null)) {
      return null;
    }
    return value => {
      refs.forEach(ref => {
        if (typeof ref === 'function') {
          ref(value);
        } else if (ref != null) {
          ref.current = value;
        }
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, refs);
}

/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */
function useRole(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    floatingId
  } = context;
  const {
    enabled = true,
    role = 'dialog'
  } = props;
  const referenceId = useId();
  return React.useMemo(() => {
    const floatingProps = {
      id: floatingId,
      role
    };
    if (!enabled) {
      return {};
    }
    if (role === 'tooltip') {
      return {
        reference: {
          'aria-describedby': open ? floatingId : undefined
        },
        floating: floatingProps
      };
    }
    return {
      reference: {
        'aria-expanded': open ? 'true' : 'false',
        'aria-haspopup': role === 'alertdialog' ? 'dialog' : role,
        'aria-controls': open ? floatingId : undefined,
        ...(role === 'listbox' && {
          role: 'combobox'
        }),
        ...(role === 'menu' && {
          id: referenceId
        })
      },
      floating: {
        ...floatingProps,
        ...(role === 'menu' && {
          'aria-labelledby': referenceId
        })
      }
    };
  }, [enabled, role, open, floatingId, referenceId]);
}

// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const camelCaseToKebabCase = str => str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? '-' : '') + $.toLowerCase());
function execWithArgsOrReturn(valueOrFn, args) {
  return typeof valueOrFn === 'function' ? valueOrFn(args) : valueOrFn;
}
function useDelayUnmount(open, durationMs) {
  const [isMounted, setIsMounted] = React.useState(open);
  if (open && !isMounted) {
    setIsMounted(true);
  }
  React.useEffect(() => {
    if (!open) {
      const timeout = setTimeout(() => setIsMounted(false), durationMs);
      return () => clearTimeout(timeout);
    }
  }, [open, durationMs]);
  return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */
function useTransitionStatus(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    elements: {
      floating
    }
  } = context;
  const {
    duration = 250
  } = props;
  const isNumberDuration = typeof duration === 'number';
  const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
  const [initiated, setInitiated] = React.useState(false);
  const [status, setStatus] = React.useState('unmounted');
  const isMounted = useDelayUnmount(open, closeDuration);

  // `initiated` check prevents this `setState` call from breaking
  // <FloatingPortal />. This call is necessary to ensure subsequent opens
  // after the initial one allows the correct side animation to play when the
  // placement has changed.
  index(() => {
    if (initiated && !isMounted) {
      setStatus('unmounted');
    }
  }, [initiated, isMounted]);
  index(() => {
    if (!floating) return;
    if (open) {
      setStatus('initial');
      const frame = requestAnimationFrame(() => {
        setStatus('open');
      });
      return () => {
        cancelAnimationFrame(frame);
      };
    } else {
      setInitiated(true);
      setStatus('close');
    }
  }, [open, floating]);
  return {
    isMounted,
    status
  };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */
function useTransitionStyles(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    initial: unstable_initial = {
      opacity: 0
    },
    open: unstable_open,
    close: unstable_close,
    common: unstable_common,
    duration = 250
  } = props;
  const placement = context.placement;
  const side = placement.split('-')[0];
  const fnArgs = React.useMemo(() => ({
    side,
    placement
  }), [side, placement]);
  const isNumberDuration = typeof duration === 'number';
  const openDuration = (isNumberDuration ? duration : duration.open) || 0;
  const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
  const [styles, setStyles] = React.useState(() => ({
    ...execWithArgsOrReturn(unstable_common, fnArgs),
    ...execWithArgsOrReturn(unstable_initial, fnArgs)
  }));
  const {
    isMounted,
    status
  } = useTransitionStatus(context, {
    duration
  });
  const initialRef = useLatestRef(unstable_initial);
  const openRef = useLatestRef(unstable_open);
  const closeRef = useLatestRef(unstable_close);
  const commonRef = useLatestRef(unstable_common);
  index(() => {
    const initialStyles = execWithArgsOrReturn(initialRef.current, fnArgs);
    const closeStyles = execWithArgsOrReturn(closeRef.current, fnArgs);
    const commonStyles = execWithArgsOrReturn(commonRef.current, fnArgs);
    const openStyles = execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key) => {
      acc[key] = '';
      return acc;
    }, {});
    if (status === 'initial') {
      setStyles(styles => ({
        transitionProperty: styles.transitionProperty,
        ...commonStyles,
        ...initialStyles
      }));
    }
    if (status === 'open') {
      setStyles({
        transitionProperty: Object.keys(openStyles).map(camelCaseToKebabCase).join(','),
        transitionDuration: openDuration + "ms",
        ...commonStyles,
        ...openStyles
      });
    }
    if (status === 'close') {
      const styles = closeStyles || initialStyles;
      setStyles({
        transitionProperty: Object.keys(styles).map(camelCaseToKebabCase).join(','),
        transitionDuration: closeDuration + "ms",
        ...commonStyles,
        ...styles
      });
    }
  }, [closeDuration, closeRef, initialRef, openRef, commonRef, openDuration, status, fnArgs]);
  return {
    isMounted,
    styles
  };
}

/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */
function useTypeahead(context, props) {
  var _ref;
  const {
    open,
    dataRef
  } = context;
  const {
    listRef,
    activeIndex,
    onMatch: unstable_onMatch,
    onTypingChange: unstable_onTypingChange,
    enabled = true,
    findMatch = null,
    resetMs = 750,
    ignoreKeys = [],
    selectedIndex = null
  } = props;
  const timeoutIdRef = React.useRef();
  const stringRef = React.useRef('');
  const prevIndexRef = React.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
  const matchIndexRef = React.useRef(null);
  const onMatch = useEffectEvent(unstable_onMatch);
  const onTypingChange = useEffectEvent(unstable_onTypingChange);
  const findMatchRef = useLatestRef(findMatch);
  const ignoreKeysRef = useLatestRef(ignoreKeys);
  index(() => {
    if (open) {
      clearTimeout(timeoutIdRef.current);
      matchIndexRef.current = null;
      stringRef.current = '';
    }
  }, [open]);
  index(() => {
    // Sync arrow key navigation but not typeahead navigation.
    if (open && stringRef.current === '') {
      var _ref2;
      prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
    }
  }, [open, selectedIndex, activeIndex]);
  return React.useMemo(() => {
    if (!enabled) {
      return {};
    }
    function setTypingChange(value) {
      if (value) {
        if (!dataRef.current.typing) {
          dataRef.current.typing = value;
          onTypingChange(value);
        }
      } else {
        if (dataRef.current.typing) {
          dataRef.current.typing = value;
          onTypingChange(value);
        }
      }
    }
    function getMatchingIndex(list, orderedList, string) {
      const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find(text => (text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
      return str ? list.indexOf(str) : -1;
    }
    function onKeyDown(event) {
      const listContent = listRef.current;
      if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
        if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) {
          setTypingChange(false);
        } else if (event.key === ' ') {
          stopEvent(event);
        }
      }
      if (listContent == null || ignoreKeysRef.current.includes(event.key) ||
      // Character key.
      event.key.length !== 1 ||
      // Modifier key.
      event.ctrlKey || event.metaKey || event.altKey) {
        return;
      }
      if (open && event.key !== ' ') {
        stopEvent(event);
        setTypingChange(true);
      }

      // Bail out if the list contains a word like "llama" or "aaron". TODO:
      // allow it in this case, too.
      const allowRapidSuccessionOfFirstLetter = listContent.every(text => {
        var _text$, _text$2;
        return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
      });

      // Allows the user to cycle through items that start with the same letter
      // in rapid succession.
      if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
        stringRef.current = '';
        prevIndexRef.current = matchIndexRef.current;
      }
      stringRef.current += event.key;
      clearTimeout(timeoutIdRef.current);
      timeoutIdRef.current = setTimeout(() => {
        stringRef.current = '';
        prevIndexRef.current = matchIndexRef.current;
        setTypingChange(false);
      }, resetMs);
      const prevIndex = prevIndexRef.current;
      const index = getMatchingIndex(listContent, [...listContent.slice((prevIndex || 0) + 1), ...listContent.slice(0, (prevIndex || 0) + 1)], stringRef.current);
      if (index !== -1) {
        onMatch(index);
        matchIndexRef.current = index;
      } else if (event.key !== ' ') {
        stringRef.current = '';
        setTypingChange(false);
      }
    }
    return {
      reference: {
        onKeyDown
      },
      floating: {
        onKeyDown,
        onKeyUp(event) {
          if (event.key === ' ') {
            setTypingChange(false);
          }
        }
      }
    };
  }, [enabled, open, dataRef, listRef, resetMs, ignoreKeysRef, findMatchRef, onMatch, onTypingChange]);
}

function getArgsWithCustomFloatingHeight(state, height) {
  return {
    ...state,
    rects: {
      ...state.rects,
      floating: {
        ...state.rects.floating,
        height
      }
    }
  };
}
/**
 * Positions the floating element such that an inner element inside
 * of it is anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 */
const inner = props => ({
  name: 'inner',
  options: props,
  async fn(state) {
    const {
      listRef,
      overflowRef,
      onFallbackChange,
      offset: innerOffset = 0,
      index = 0,
      minItemsVisible = 4,
      referenceOverflowThreshold = 0,
      scrollRef,
      ...detectOverflowOptions
    } = props;
    const {
      rects,
      elements: {
        floating
      }
    } = state;
    const item = listRef.current[index];
    if (false) {}
    if (!item) {
      return {};
    }
    const nextArgs = {
      ...state,
      ...(await offset(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state))
    };
    const el = (scrollRef == null ? void 0 : scrollRef.current) || floating;
    const overflow = await detectOverflow(getArgsWithCustomFloatingHeight(nextArgs, el.scrollHeight), detectOverflowOptions);
    const refOverflow = await detectOverflow(nextArgs, {
      ...detectOverflowOptions,
      elementContext: 'reference'
    });
    const diffY = Math.max(0, overflow.top);
    const nextY = nextArgs.y + diffY;
    const maxHeight = Math.max(0, el.scrollHeight - diffY - Math.max(0, overflow.bottom));
    el.style.maxHeight = maxHeight + "px";
    el.scrollTop = diffY;

    // There is not enough space, fallback to standard anchored positioning
    if (onFallbackChange) {
      if (el.offsetHeight < item.offsetHeight * Math.min(minItemsVisible, listRef.current.length - 1) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold) {
        flushSync(() => onFallbackChange(true));
      } else {
        flushSync(() => onFallbackChange(false));
      }
    }
    if (overflowRef) {
      overflowRef.current = await detectOverflow(getArgsWithCustomFloatingHeight({
        ...nextArgs,
        y: nextY
      }, el.offsetHeight), detectOverflowOptions);
    }
    return {
      y: nextY
    };
  }
});
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 */
function useInnerOffset(context, props) {
  const {
    open,
    elements
  } = context;
  const {
    enabled = true,
    overflowRef,
    scrollRef,
    onChange: unstable_onChange
  } = props;
  const onChange = useEffectEvent(unstable_onChange);
  const controlledScrollingRef = React.useRef(false);
  const prevScrollTopRef = React.useRef(null);
  const initialOverflowRef = React.useRef(null);
  React.useEffect(() => {
    if (!enabled) {
      return;
    }
    function onWheel(e) {
      if (e.ctrlKey || !el || overflowRef.current == null) {
        return;
      }
      const dY = e.deltaY;
      const isAtTop = overflowRef.current.top >= -0.5;
      const isAtBottom = overflowRef.current.bottom >= -0.5;
      const remainingScroll = el.scrollHeight - el.clientHeight;
      const sign = dY < 0 ? -1 : 1;
      const method = dY < 0 ? 'max' : 'min';
      if (el.scrollHeight <= el.clientHeight) {
        return;
      }
      if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
        e.preventDefault();
        flushSync(() => {
          onChange(d => d + Math[method](dY, remainingScroll * sign));
        });
      } else if (/firefox/i.test(getUserAgent())) {
        // Needed to propagate scrolling during momentum scrolling phase once
        // it gets limited by the boundary. UX improvement, not critical.
        el.scrollTop += dY;
      }
    }
    const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
    if (open && el) {
      el.addEventListener('wheel', onWheel);

      // Wait for the position to be ready.
      requestAnimationFrame(() => {
        prevScrollTopRef.current = el.scrollTop;
        if (overflowRef.current != null) {
          initialOverflowRef.current = {
            ...overflowRef.current
          };
        }
      });
      return () => {
        prevScrollTopRef.current = null;
        initialOverflowRef.current = null;
        el.removeEventListener('wheel', onWheel);
      };
    }
  }, [enabled, open, elements.floating, overflowRef, scrollRef, onChange]);
  return React.useMemo(() => {
    if (!enabled) {
      return {};
    }
    return {
      floating: {
        onKeyDown() {
          controlledScrollingRef.current = true;
        },
        onWheel() {
          controlledScrollingRef.current = false;
        },
        onPointerMove() {
          controlledScrollingRef.current = false;
        },
        onScroll() {
          const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
          if (!overflowRef.current || !el || !controlledScrollingRef.current) {
            return;
          }
          if (prevScrollTopRef.current !== null) {
            const scrollDiff = el.scrollTop - prevScrollTopRef.current;
            if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) {
              flushSync(() => onChange(d => d + scrollDiff));
            }
          }

          // [Firefox] Wait for the height change to have been applied.
          requestAnimationFrame(() => {
            prevScrollTopRef.current = el.scrollTop;
          });
        }
      }
    };
  }, [enabled, overflowRef, elements.floating, scrollRef, onChange]);
}

function isPointInPolygon(point, polygon) {
  const [x, y] = point;
  let isInside = false;
  const length = polygon.length;
  for (let i = 0, j = length - 1; i < length; j = i++) {
    const [xi, yi] = polygon[i] || [0, 0];
    const [xj, yj] = polygon[j] || [0, 0];
    const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
    if (intersect) {
      isInside = !isInside;
    }
  }
  return isInside;
}
function isInside(point, rect) {
  return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safePolygon
 */
function safePolygon(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    buffer = 0.5,
    blockPointerEvents = false,
    requireIntent = true
  } = options;
  let timeoutId;
  let hasLanded = false;
  let lastX = null;
  let lastY = null;
  let lastCursorTime = performance.now();
  function getCursorSpeed(x, y) {
    const currentTime = performance.now();
    const elapsedTime = currentTime - lastCursorTime;
    if (lastX === null || lastY === null || elapsedTime === 0) {
      lastX = x;
      lastY = y;
      lastCursorTime = currentTime;
      return null;
    }
    const deltaX = x - lastX;
    const deltaY = y - lastY;
    const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
    const speed = distance / elapsedTime; // px / ms

    lastX = x;
    lastY = y;
    lastCursorTime = currentTime;
    return speed;
  }
  const fn = _ref => {
    let {
      x,
      y,
      placement,
      elements,
      onClose,
      nodeId,
      tree
    } = _ref;
    return function onMouseMove(event) {
      function close() {
        clearTimeout(timeoutId);
        onClose();
      }
      clearTimeout(timeoutId);
      if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) {
        return;
      }
      const {
        clientX,
        clientY
      } = event;
      const clientPoint = [clientX, clientY];
      const target = getTarget(event);
      const isLeave = event.type === 'mouseleave';
      const isOverFloatingEl = contains(elements.floating, target);
      const isOverReferenceEl = contains(elements.domReference, target);
      const refRect = elements.domReference.getBoundingClientRect();
      const rect = elements.floating.getBoundingClientRect();
      const side = placement.split('-')[0];
      const cursorLeaveFromRight = x > rect.right - rect.width / 2;
      const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
      const isOverReferenceRect = isInside(clientPoint, refRect);
      const isFloatingWider = rect.width > refRect.width;
      const isFloatingTaller = rect.height > refRect.height;
      const left = (isFloatingWider ? refRect : rect).left;
      const right = (isFloatingWider ? refRect : rect).right;
      const top = (isFloatingTaller ? refRect : rect).top;
      const bottom = (isFloatingTaller ? refRect : rect).bottom;
      if (isOverFloatingEl) {
        hasLanded = true;
        if (!isLeave) {
          return;
        }
      }
      if (isOverReferenceEl) {
        hasLanded = false;
      }
      if (isOverReferenceEl && !isLeave) {
        hasLanded = true;
        return;
      }

      // Prevent overlapping floating element from being stuck in an open-close
      // loop: https://github.com/floating-ui/floating-ui/issues/1910
      if (isLeave && isElement(event.relatedTarget) && contains(elements.floating, event.relatedTarget)) {
        return;
      }

      // If any nested child is open, abort.
      if (tree && getChildren(tree.nodesRef.current, nodeId).some(_ref2 => {
        let {
          context
        } = _ref2;
        return context == null ? void 0 : context.open;
      })) {
        return;
      }

      // If the pointer is leaving from the opposite side, the "buffer" logic
      // creates a point where the floating element remains open, but should be
      // ignored.
      // A constant of 1 handles floating point rounding errors.
      if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) {
        return close();
      }

      // Ignore when the cursor is within the rectangular trough between the
      // two elements. Since the triangle is created from the cursor point,
      // which can start beyond the ref element's edge, traversing back and
      // forth from the ref to the floating element can cause it to close. This
      // ensures it always remains open in that case.
      let rectPoly = [];
      switch (side) {
        case 'top':
          rectPoly = [[left, refRect.top + 1], [left, rect.bottom - 1], [right, rect.bottom - 1], [right, refRect.top + 1]];
          break;
        case 'bottom':
          rectPoly = [[left, rect.top + 1], [left, refRect.bottom - 1], [right, refRect.bottom - 1], [right, rect.top + 1]];
          break;
        case 'left':
          rectPoly = [[rect.right - 1, bottom], [rect.right - 1, top], [refRect.left + 1, top], [refRect.left + 1, bottom]];
          break;
        case 'right':
          rectPoly = [[refRect.right - 1, bottom], [refRect.right - 1, top], [rect.left + 1, top], [rect.left + 1, bottom]];
          break;
      }
      function getPolygon(_ref3) {
        let [x, y] = _ref3;
        switch (side) {
          case 'top':
            {
              const cursorPointOne = [isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y + buffer + 1];
              const cursorPointTwo = [isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y + buffer + 1];
              const commonPoints = [[rect.left, cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top], [rect.right, cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer]];
              return [cursorPointOne, cursorPointTwo, ...commonPoints];
            }
          case 'bottom':
            {
              const cursorPointOne = [isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y - buffer];
              const cursorPointTwo = [isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y - buffer];
              const commonPoints = [[rect.left, cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom], [rect.right, cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer]];
              return [cursorPointOne, cursorPointTwo, ...commonPoints];
            }
          case 'left':
            {
              const cursorPointOne = [x + buffer + 1, isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const cursorPointTwo = [x + buffer + 1, isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const commonPoints = [[cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left, rect.top], [cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer, rect.bottom]];
              return [...commonPoints, cursorPointOne, cursorPointTwo];
            }
          case 'right':
            {
              const cursorPointOne = [x - buffer, isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const cursorPointTwo = [x - buffer, isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const commonPoints = [[cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right, rect.top], [cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer, rect.bottom]];
              return [cursorPointOne, cursorPointTwo, ...commonPoints];
            }
        }
      }
      if (isPointInPolygon([clientX, clientY], rectPoly)) {
        return;
      } else if (hasLanded && !isOverReferenceRect) {
        return close();
      }
      if (!isLeave && requireIntent) {
        const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
        const cursorSpeedThreshold = 0.1;
        if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) {
          return close();
        }
      }
      if (!isPointInPolygon([clientX, clientY], getPolygon([x, y]))) {
        close();
      } else if (!hasLanded && requireIntent) {
        timeoutId = window.setTimeout(close, 40);
      }
    };
  };
  fn.__options = {
    blockPointerEvents
  };
  return fn;
}



;// CONCATENATED MODULE: ./node_modules/.pnpm/@metatrustlabs+ui-base@0.2.13_react-dom@18.2.0_react@18.2.0_typescript@4.7.2/node_modules/@metatrustlabs/ui-base/dist/ui-base.esm.js









var calculateClasses = function calculateClasses(className, defaultClass) {
  if (!className) {
    return defaultClass;
  }
  if (typeof className === "string") {
    return (0,dist.cx)(defaultClass, className);
  } else {
    return (0,dist.cx)(defaultClass);
  }
};
var classx = function classx(originalClass, replacer) {
  if (!replacer) {
    return originalClass;
  }
  if (typeof replacer === "string") {
    return (0,dist.cx)(originalClass, replacer);
  } else {
    return replacer(originalClass);
  }
};

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var ProgressCircular = function ProgressCircular(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'h-5 w-5' : _ref$className;
  return react.createElement("svg", {
    className: (0,dist.cx)('animate-spin ', className),
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, react.createElement("circle", {
    className: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    strokeWidth: "4"
  }), react.createElement("path", {
    className: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  }));
};

var _excluded = ["isLoading", "className", "intent", "pill", "size", "href", "loadingIcon", "linkElement", "leadingIcon", "trailingIcon", "children"];
// const BUTTON_BASE_CLASS =
//   "group shadow-sm flex items-center justify-center active:shadow-none";
var BUTTON_BASE_CLASS = "group flex items-center justify-center active:shadow-none";
var DEFAULT_DISABLED_CLASS = "disabled:border-gray-300 disabled:text-gray-400 disabled:bg-gray-200 disabled:shadow-none";
var buttonStyle = /*#__PURE__*/(0,dist/* cva */.j)(BUTTON_BASE_CLASS, {
  variants: {
    intent: {
      primary: ["text-orange-500 hover:text-orange-600", "border border-orange-500 hover:border-orange-600 outline-orange-500", "bg-white hover:bg-orange-50 active:bg-orange-100", DEFAULT_DISABLED_CLASS],
      secondary: ["text-gray-500 hover:text-gray-600", "border border-gray-300 hover:border-gray-400 outline-gray-400", "bg-white hover:bg-gray-50 active:bg-gray-100", DEFAULT_DISABLED_CLASS],
      danger: ["text-white hover:text-red-50", "border border-red-500 hover:border-red-600 outline-red-200", "bg-red-500 hover:bg-red-600 active:bg-red-700", DEFAULT_DISABLED_CLASS],
      highlight: ["text-white hover:text-white", "border border-orange-400 outline-orange-300", "bg-gradient-to-br from-orange-400 to-red-500 hover:from-orange-500 hover:to-red-600 active:from-orange-600 active:to-red-600", "disabled:border-gray-300 disabled:text-gray-400 disabled:from-gray-200 disabled:to-gray-200 disabled:shadow-none"]
    },
    size: {
      xs: ["text-xs", "gap-1 py-1"],
      sm: ["text-sm", "gap-1.5 py-1.5"],
      base: ["text-base", "gap-2 py-2"],
      lg: ["text-lg", "gap-3 py-3"],
      xl: ["text-xl", "gap-4 py-3"]
    },
    pill: {
      "true": "",
      "false": ""
    }
  },
  compoundVariants: [{
    size: "xs",
    pill: true,
    "class": "rounded-full px-4"
  }, {
    size: "xs",
    pill: false,
    "class": "rounded px-3"
  }, {
    size: "sm",
    pill: true,
    "class": "rounded-full px-8"
  }, {
    size: "sm",
    pill: false,
    "class": "rounded-md px-5"
  }, {
    size: "base",
    pill: true,
    "class": "rounded-full px-10"
  }, {
    size: "base",
    pill: false,
    "class": "rounded-lg px-5"
  }, {
    size: "lg",
    pill: true,
    "class": "rounded-full px-12"
  }, {
    size: "lg",
    pill: false,
    "class": "rounded-lg px-8"
  }, {
    size: "xl",
    pill: true,
    "class": "rounded-full px-12"
  }, {
    size: "xl",
    pill: false,
    "class": "rounded-lg px-10"
  }],
  defaultVariants: {
    intent: "primary",
    size: "base"
  }
});
var iconStyle = /*#__PURE__*/(0,dist/* cva */.j)("flex items-center justify-center", {
  variants: {
    intent: {
      primary: "text-orange-500 group-hover:text-orange-600",
      secondary: "text-gray-500 group-hover:text-gray-600",
      danger: "text-white group-hover:text-red-50",
      highlight: "text-white group-hover:text-white"
    },
    size: {
      xs: "w-4 h-4",
      sm: "w-5 h-5",
      base: "w-6 h-6",
      lg: "w-7 h-7",
      xl: "w-8 h-8"
    },
    hasLeading: {
      "true": ""
    },
    hasTrailing: {
      "true": ""
    }
  },
  compoundVariants: [{
    size: "xs",
    hasLeading: true,
    "class": "-ml-1"
  }, {
    size: "xs",
    hasTrailing: true,
    "class": "-mr-1"
  }, {
    size: "sm",
    hasLeading: true,
    "class": "-ml-1"
  }, {
    size: "sm",
    hasTrailing: true,
    "class": "-mr-1"
  }, {
    size: "base",
    hasLeading: true,
    "class": "-ml-1.5"
  }, {
    size: "base",
    hasTrailing: true,
    "class": "-mr-1.5"
  }, {
    size: "lg",
    hasLeading: true,
    "class": "-ml-2"
  }, {
    size: "lg",
    hasTrailing: true,
    "class": "-mr-2"
  }, {
    size: "xl",
    hasLeading: true,
    "class": "-ml-3"
  }, {
    size: "xl",
    hasTrailing: true,
    "class": "-mr-3"
  }],
  defaultVariants: {
    intent: "primary",
    size: "base"
  }
});
var withFullSize = function withFullSize(icon) {
  return react.cloneElement(icon, {
    className: (icon.props.className || "") + " w-full h-full"
  });
};
var Button = /*#__PURE__*/(0,react.forwardRef)(function buttonWithRef(_ref, ref) {
  var _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? "primary" : _ref$intent,
    _ref$pill = _ref.pill,
    pill = _ref$pill === void 0 ? false : _ref$pill,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "base" : _ref$size,
    _ref$href = _ref.href,
    href = _ref$href === void 0 ? "" : _ref$href,
    _ref$loadingIcon = _ref.loadingIcon,
    loadingIcon = _ref$loadingIcon === void 0 ? react.createElement(ProgressCircular, {
      className: "h-5/6 w-5/6"
    }) : _ref$loadingIcon,
    _ref$linkElement = _ref.linkElement,
    Link = _ref$linkElement === void 0 ? "a" : _ref$linkElement,
    leadingIcon = _ref.leadingIcon,
    trailingIcon = _ref.trailingIcon,
    children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var iconClass = iconStyle({
    intent: intent,
    size: size,
    hasLeading: !!leadingIcon,
    hasTrailing: !!trailingIcon
  });
  var btnClass = classx(buttonStyle({
    intent: intent,
    pill: pill,
    size: size
  }), className);
  var iconLeftActual = react.createElement(react.Fragment, null, leadingIcon && react.createElement("div", {
    className: iconClass
  }, isLoading ? loadingIcon : withFullSize(leadingIcon)), isLoading && !leadingIcon && !trailingIcon && react.createElement("div", {
    className: iconClass
  }, loadingIcon));
  var iconRightActual = react.createElement(react.Fragment, null, trailingIcon && react.createElement("div", {
    className: iconClass
  }, isLoading ? loadingIcon : withFullSize(trailingIcon)));
  if (href) {
    return react.createElement(Link, {
      href: href,
      className: btnClass + " max-w-fit cursor-pointer"
    }, iconLeftActual, children, iconRightActual);
  } else {
    return react.createElement("button", Object.assign({
      className: btnClass,
      ref: ref
    }, props), iconLeftActual, children, iconRightActual);
  }
});

var iconWrapperCls = /*#__PURE__*/(0,dist/* cva */.j)("flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full", {
  variants: {
    intent: {
      info: "bg-blue-100",
      success: "bg-lime-50",
      warning: "bg-orange-100",
      error: "bg-red-100"
    }
  }
});
var iconCls = /*#__PURE__*/(0,dist/* cva */.j)("h-6 w-6", {
  variants: {
    intent: {
      info: "text-blue-600",
      success: "text-lime-600",
      warning: "text-orange-500",
      error: "text-red-600"
    }
  }
});
var getIcon = function getIcon(variant) {
  var wrapperClass = iconWrapperCls(variant);
  var iconClass = iconCls(variant);
  switch (variant.intent) {
    case "info":
      return react.createElement("div", {
        className: wrapperClass
      }, react.createElement(InformationCircleIcon, {
        className: iconClass,
        "aria-hidden": "true"
      }));
    case "success":
      return react.createElement("div", {
        className: wrapperClass
      }, react.createElement(CheckCircleIcon, {
        className: iconClass,
        "aria-hidden": "true"
      }));
    case "warning":
      return react.createElement("div", {
        className: wrapperClass
      }, react.createElement(ExclamationTriangleIcon, {
        className: iconClass,
        "aria-hidden": "true"
      }));
    case "error":
      return react.createElement("div", {
        className: wrapperClass
      }, react.createElement(ExclamationTriangleIcon, {
        className: iconClass,
        "aria-hidden": "true"
      }));
  }
  return react.createElement(react.Fragment, null);
};
var Alert = function Alert(_ref) {
  var title = _ref.title,
    content = _ref.content,
    icon = _ref.icon,
    isOpen = _ref.isOpen,
    confirmButton = _ref.confirmButton,
    cancelButton = _ref.cancelButton,
    extraFooter = _ref.extraFooter,
    className = _ref.className,
    _ref$onConfirm = _ref.onConfirm,
    onConfirm = _ref$onConfirm === void 0 ? function () {} : _ref$onConfirm,
    _ref$onCancel = _ref.onCancel,
    onCancel = _ref$onCancel === void 0 ? function () {} : _ref$onCancel,
    _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? "info" : _ref$intent,
    _ref$confirmLabel = _ref.confirmLabel,
    confirmLabel = _ref$confirmLabel === void 0 ? "Confirm" : _ref$confirmLabel,
    _ref$cancelLabel = _ref.cancelLabel,
    cancelLabel = _ref$cancelLabel === void 0 ? "Cancel" : _ref$cancelLabel;
  var cancelButtonRef = (0,react.useRef)(null);
  var iconActual = icon || getIcon({
    intent: intent
  });
  var confirmButtonActual = confirmButton || react.createElement(Button, {
    type: "button",
    intent: intent === "error" ? "danger" : "highlight",
    size: "sm",
    onClick: function onClick() {
      return onConfirm();
    }
  }, confirmLabel);
  var cancelButtonActual = cancelButton || react.createElement(Button, {
    type: "button",
    intent: "secondary",
    size: "sm",
    onClick: function onClick() {
      return onCancel();
    },
    ref: cancelButtonRef
  }, cancelLabel);
  return react.createElement(tt.Root, {
    show: isOpen,
    as: react.Fragment
  }, react.createElement(St, {
    as: "div",
    className: (0,dist.cx)("relative", className),
    initialFocus: cancelButtonRef,
    onClose: onCancel
  }, react.createElement(tt.Child, {
    as: react.Fragment,
    enter: "ease-out duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, react.createElement("div", {
    className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
  })), react.createElement("div", {
    className: "fixed inset-0 z-10 overflow-y-auto"
  }, react.createElement("div", {
    className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
  }, react.createElement(tt.Child, {
    as: react.Fragment,
    enter: "ease-out duration-300",
    enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
    enterTo: "opacity-100 translate-y-0 sm:scale-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
    leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
  }, react.createElement(St.Panel, {
    className: "relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg"
  }, react.createElement("div", {
    className: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4"
  }, react.createElement("div", {
    className: "sm:flex sm:items-start"
  }, iconActual, react.createElement("div", {
    className: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left"
  }, react.createElement(St.Title, {
    as: "h3",
    className: "text-lg leading-6 text-gray-900"
  }, title), react.createElement("div", {
    className: "mt-2"
  }, react.createElement("p", {
    className: "text-sm text-gray-500"
  }, content))))), react.createElement("div", {
    className: " flex flex-row-reverse items-center justify-between bg-gray-50 px-4 py-3"
  }, react.createElement("div", {
    className: "flex flex-row-reverse items-center gap-2"
  }, confirmButtonActual, cancelButtonActual), !!extraFooter && extraFooter)))))));
};

var _excluded$1 = ["className", "intent", "size", "bordered", "uppercase", "children"];
var baseCls = /*#__PURE__*/(0,dist/* cva */.j)("inline-flex items-center rounded-full", {
  variants: {
    intent: {
      info: "text-blue-600",
      success: "text-lime-700",
      warning: "text-orange-700",
      error: "text-red-600",
      secondary: "text-orange-600",
      tertiary: "text-gray-600",
      primary: "text-white"
    },
    bordered: {
      "true": "border"
    },
    uppercase: {
      "true": "uppercase tracking-wide"
    },
    size: {
      base: "px-2.5 py-0.5 text-xs",
      sm: "px-2 py-0.5 text-[10px] tracking-wide leading-tight",
      lg: "px-3 py-0.5 text-xs"
    }
  },
  compoundVariants: [{
    intent: "info",
    bordered: true,
    "class": "border-blue-200 bg-blue-50"
  }, {
    intent: "info",
    bordered: false,
    "class": "bg-blue-100"
  }, {
    intent: "success",
    bordered: true,
    "class": "border-lime-300 bg-lime-100"
  }, {
    intent: "success",
    bordered: false,
    "class": "bg-lime-100"
  }, {
    intent: "warning",
    bordered: true,
    "class": "border-orange-300 bg-orange-100"
  }, {
    intent: "warning",
    bordered: false,
    "class": "bg-orange-200"
  }, {
    intent: "error",
    bordered: true,
    "class": "border-red-200 bg-red-50"
  }, {
    intent: "error",
    bordered: false,
    "class": "bg-red-100"
  }, {
    intent: "tertiary",
    bordered: false,
    "class": "bg-gray-100"
  }, {
    intent: "secondary",
    bordered: true,
    "class": "bg-white border-orange-400"
  }, {
    intent: "secondary",
    bordered: false,
    "class": "bg-orange-100"
  }, {
    intent: "primary",
    bordered: true,
    "class": "border-orange-500 bg-orange-400"
  }, {
    intent: "primary",
    bordered: false,
    "class": "bg-orange-400"
  }]
});
var Badge = function Badge(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? "primary" : _ref$intent,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "base" : _ref$size,
    _ref$bordered = _ref.bordered,
    bordered = _ref$bordered === void 0 ? true : _ref$bordered,
    _ref$uppercase = _ref.uppercase,
    uppercase = _ref$uppercase === void 0 ? false : _ref$uppercase,
    children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  var cls = classx(baseCls({
    intent: intent,
    size: size,
    bordered: bordered,
    uppercase: uppercase
  }), className);
  return react.createElement("span", Object.assign({
    className: cls
  }, props), children);
};

var _excluded$2 = ["size", "className", "labelClass", "label", "id"];
var labelStyle = /*#__PURE__*/(0,dist/* cva */.j)("select-none text-gray-600 peer-disabled:text-gray-300", {
  variants: {
    size: {
      sm: "text-sm",
      base: "text-base",
      lg: "text-lg"
    }
  }
});
var inputStyle = /*#__PURE__*/(0,dist/* cva */.j)(["peer appearance-none border-gray-300 bg-gray-50 text-orange-400", "checked:ring-transparent checked:border-gray-200 hover:border-gray-200 focus:ring-orange-500/50 disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-100 disabled:ring-transparent"], {
  variants: {
    size: {
      sm: "h-4 w-4 rounded",
      base: "h-5 w-5 rounded",
      lg: "h-6 w-6 rounded-md"
    }
  }
});
var containerStyle = /*#__PURE__*/(0,dist/* cva */.j)("inline-flex items-center", {
  variants: {
    size: {
      sm: "gap-2.5",
      base: "gap-2.5",
      lg: "gap-3"
    }
  }
});
var Checkbox = function Checkbox(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? "base" : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$labelClass = _ref.labelClass,
    labelClass = _ref$labelClass === void 0 ? "" : _ref$labelClass,
    label = _ref.label,
    id = _ref.id,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  return react.createElement("div", {
    className: classx(containerStyle({
      size: size
    }), className)
  }, react.createElement("input", Object.assign({
    type: "checkbox",
    id: id,
    className: inputStyle({
      size: size
    })
  }, props)), label && react.createElement("label", {
    htmlFor: id,
    className: classx(labelStyle({
      size: size
    }), labelClass)
  }, label));
};

var titleCls = /*#__PURE__*/(0,dist/* cva */.j)("inline-flex items-center justify-start font-bold text-gray-500 hover:text-gray-700", {
  variants: {
    size: {
      sm: "text-xs gap-1 py-2",
      base: "text-sm gap-1 py-2",
      lg: "text-base gap-2 py-2.5"
    }
  }
});
var panelCls = /*#__PURE__*/(0,dist/* cva */.j)("flex flex-col", {
  variants: {
    size: {
      sm: "pl-5 py-1 gap-2",
      base: "pl-6 py-1.5 gap-2",
      lg: "pl-8 py-2 gap-3"
    }
  }
});
var chevronCls = /*#__PURE__*/(0,dist/* cva */.j)("transition-transform", {
  variants: {
    size: {
      sm: "h-4 w-4",
      base: "h-5 w-5",
      lg: "h-6 w-6"
    },
    open: {
      "true": "rotate-90"
    }
  }
});
var CheckboxGroup = function CheckboxGroup(_ref) {
  var title = _ref.title,
    _ref$titleClass = _ref.titleClass,
    titleClass = _ref$titleClass === void 0 ? "" : _ref$titleClass,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "base" : _ref$size,
    children = _ref.children;
  return React.createElement(Disclosure, {
    defaultOpen: true
  }, function (_ref2) {
    var open = _ref2.open;
    return React.createElement(React.Fragment, null, React.createElement(Disclosure.Button, {
      className: classx(titleCls({
        size: size
      }), titleClass)
    }, React.createElement(ChevronRightIcon, {
      className: chevronCls({
        size: size,
        open: open
      })
    }), title), React.createElement(Transition, {
      enter: "transition duration-100 ease-out",
      enterFrom: "transform opacity-0",
      enterTo: "transform opacity-100",
      leave: "transition duration-75 ease-out",
      leaveFrom: "transform opacity-100",
      leaveTo: "transform opacity-0"
    }, React.createElement(Disclosure.Panel, {
      className: panelCls({
        size: size
      })
    }, React.Children.map(children, function (child) {
      return React.cloneElement(child, {
        size: size
      });
    }))));
  });
};

var containerCls = /*#__PURE__*/(0,dist/* cva */.j)("border bg-white", {
  variants: {
    size: {
      sm: "rounded-md",
      base: "rounded-lg",
      lg: "rounded-lg"
    },
    shadow: {
      "true": "shadow-sm"
    },
    intent: {
      "default": "border-gray-300",
      danger: "border-red-200",
      light: "border-gray-200",
      info: "border-blue-200"
    }
  }
});
var Container = function Container(_ref) {
  var _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? "default" : _ref$intent,
    _ref$shadow = _ref.shadow,
    shadow = _ref$shadow === void 0 ? false : _ref$shadow,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "base" : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    children = _ref.children;
  return react.createElement("div", {
    className: classx(containerCls({
      intent: intent,
      size: size,
      shadow: shadow
    }), className)
  }, children);
};

var headerCls = /*#__PURE__*/(0,dist/* cva */.j)("flex items-center rounded-t-lg justify-between", {
  variants: {
    intent: {
      "default": "bg-gray-800 text-gray-50",
      light: "bg-gray-300 text-gray-800",
      danger: "bg-red-600 text-red-50"
    },
    size: {
      sm: "px-6 py-2 text-sm",
      base: "px-7 py-2.5 text-base",
      lg: "px-8 py-3 text-lg"
    }
  }
});
var footerCls = /*#__PURE__*/(0,dist/* cva */.j)(" flex flex-row-reverse items-center rounded-b-lg justify-between bg-gray-50", {
  variants: {
    size: {
      sm: "px-6 py-4",
      base: "px-7 py-5",
      lg: "px-8 py-6"
    }
  }
});
var iconCls$1 = /*#__PURE__*/(0,dist/* cva */.j)("flex items-stretch justify-center", {
  variants: {
    intent: {
      "default": "text-orange-500",
      light: "text-orange-500",
      danger: "text-red-50"
    },
    size: {
      sm: "h-5 w-5",
      base: "h-6 w-6",
      lg: "h-7 w-7"
    }
  }
});
var elementCls = /*#__PURE__*/(0,dist/* cva */.j)("flex items-center py-2", {
  variants: {
    size: {
      sm: "gap-2",
      base: "gap-3",
      lg: "gap-3"
    }
  }
});
var dialogCls = /*#__PURE__*/(0,dist/* cva */.j)("relative w-full transform rounded-lg bg-gray-50 text-left shadow-xl outline outline-1 outline-gray-500 transition-all", {
  variants: {
    width: {
      "default": "max-w-4xl",
      narrow: "max-w-3xl",
      spacious: "max-w-5xl"
    }
  }
});
var DialogHeader = function DialogHeader(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? "" : _ref$title,
    icon = _ref.icon,
    _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? "default" : _ref$intent,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "base" : _ref$size,
    leadingHeaderElement = _ref.leadingHeaderElement,
    trailingHeaderElement = _ref.trailingHeaderElement,
    _ref$headerClass = _ref.headerClass,
    headerClass = _ref$headerClass === void 0 ? "" : _ref$headerClass,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose;
  var leadingElement = leadingHeaderElement || react.createElement("div", {
    className: elementCls({
      size: size
    })
  }, icon && react.createElement("div", {
    className: iconCls$1({
      intent: intent,
      size: size
    })
  }, icon), react.createElement(St.Title, {
    as: "h3",
    className: "leading-6 "
  }, title));
  var trailingElement = trailingHeaderElement || react.createElement("button", {
    onClick: function onClick() {
      return onClose();
    },
    className: iconCls$1({
      size: size,
      "class": "opacity-70 outline-gray-500 hover:opacity-100"
    })
  }, react.createElement(XMarkIcon, null));
  return react.createElement("div", {
    className: classx(headerCls({
      intent: intent,
      size: size
    }), headerClass)
  }, leadingElement, trailingElement);
};
var Dialog = function Dialog(_ref2) {
  var _ref2$title = _ref2.title,
    title = _ref2$title === void 0 ? "" : _ref2$title,
    _ref2$showTitle = _ref2.showTitle,
    showTitle = _ref2$showTitle === void 0 ? true : _ref2$showTitle,
    footer = _ref2.footer,
    icon = _ref2.icon,
    _ref2$intent = _ref2.intent,
    intent = _ref2$intent === void 0 ? "default" : _ref2$intent,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? "base" : _ref2$size,
    leadingHeaderElement = _ref2.leadingHeaderElement,
    trailingHeaderElement = _ref2.trailingHeaderElement,
    _ref2$headerClass = _ref2.headerClass,
    headerClass = _ref2$headerClass === void 0 ? "" : _ref2$headerClass,
    isOpen = _ref2.isOpen,
    confirmButton = _ref2.confirmButton,
    closeButton = _ref2.closeButton,
    extraFooter = _ref2.extraFooter,
    children = _ref2.children,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? "" : _ref2$className,
    _ref2$width = _ref2.width,
    width = _ref2$width === void 0 ? "default" : _ref2$width,
    _ref2$onConfirm = _ref2.onConfirm,
    onConfirm = _ref2$onConfirm === void 0 ? function () {} : _ref2$onConfirm,
    _ref2$onClose = _ref2.onClose,
    onClose = _ref2$onClose === void 0 ? function () {} : _ref2$onClose,
    _ref2$confirmLabel = _ref2.confirmLabel,
    confirmLabel = _ref2$confirmLabel === void 0 ? "Confirm" : _ref2$confirmLabel,
    _ref2$closeLabel = _ref2.closeLabel,
    closeLabel = _ref2$closeLabel === void 0 ? "Cancel" : _ref2$closeLabel,
    _ref2$cancelable = _ref2.cancelable,
    cancelable = _ref2$cancelable === void 0 ? true : _ref2$cancelable;
  var closeButtonRef = (0,react.useRef)(null);
  var confirmButtonActual = confirmButton || react.createElement(Button, {
    type: "button",
    intent: intent === "danger" ? "danger" : "highlight",
    size: size === "sm" ? "sm" : "base",
    onClick: function onClick() {
      return onConfirm();
    }
  }, confirmLabel);
  var closeButtonActual = closeButton || react.createElement(Button, {
    type: "button",
    intent: "secondary",
    size: size === "sm" ? "sm" : "base",
    onClick: function onClick() {
      return onClose();
    },
    ref: closeButtonRef
  }, closeLabel);
  return react.createElement(tt.Root, {
    show: isOpen,
    as: react.Fragment
  }, react.createElement(St, {
    as: "div",
    className: "relative z-20",
    initialFocus: closeButtonRef,
    onClose: cancelable ? onClose : function () {}
  }, react.createElement(tt.Child, {
    as: react.Fragment,
    enter: "ease-out duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, react.createElement("div", {
    className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
  })), react.createElement("div", {
    className: "fixed inset-0 z-10 overflow-y-auto"
  }, react.createElement("div", {
    className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
  }, react.createElement(tt.Child, {
    as: react.Fragment,
    enter: "ease-out duration-300",
    enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
    enterTo: "opacity-100 translate-y-0 sm:scale-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
    leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
  }, react.createElement(St.Panel, {
    className: classx(dialogCls({
      width: width
    }), className)
  }, showTitle && react.createElement(DialogHeader, {
    title: title,
    icon: icon,
    leadingHeaderElement: leadingHeaderElement,
    trailingHeaderElement: trailingHeaderElement,
    intent: intent,
    size: size,
    onClose: onClose,
    headerClass: headerClass
  }), children, footer !== null && react.createElement("div", {
    className: footerCls({
      size: size
    })
  }, footer ? footer({
    className: footerCls({
      size: size
    }),
    confirmButton: confirmButtonActual,
    cancelButton: closeButtonActual,
    onConfirm: onConfirm,
    onClose: onClose
  }) : react.createElement(react.Fragment, null, react.createElement("div", {
    className: "flex flex-row-reverse items-center gap-2"
  }, confirmButtonActual, closeButtonActual), !!extraFooter && extraFooter))))))));
};

var labelBaseCls = "w-full truncate text-center text-gray-700";
var FileUpload = function FileUpload(_ref) {
  var value = _ref.value,
    _ref$fileSizeLimit = _ref.fileSizeLimit,
    fileSizeLimit = _ref$fileSizeLimit === void 0 ? 20000000 : _ref$fileSizeLimit,
    fileTypes = _ref.fileTypes,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? "Drag file here or click to browse files" : _ref$label,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? function (sizeLimt) {
      return "File size limit: " + formatFileSize(sizeLimt);
    } : _ref$description,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$labelClass = _ref.labelClass,
    labelClass = _ref$labelClass === void 0 ? "" : _ref$labelClass,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? React.createElement(DocumentArrowUpIcon, {
      className: "h-12 w-12 text-orange-500"
    }) : _ref$icon,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? function () {} : _ref$onError;
  var fileInput = useRef(null);
  // const [value, setValue] = useState<File>();
  var handleFileChange = function handleFileChange(e) {
    if (e.target.files && e.target.files.length === 1) {
      var file = e.target.files[0];
      if (file.size < fileSizeLimit) {
        onChange(file);
      } else {
        onError("Uploaded file cannot be larger than " + formatFileSize(fileSizeLimit));
      }
    }
  };
  var handleFileRemove = function handleFileRemove(e) {
    e.preventDefault();
    onChange(undefined);
    if (fileInput.current && fileInput.current.value) {
      fileInput.current.value = "";
    }
  };
  var handleFileDrop = function handleFileDrop(e) {
    if (e.dataTransfer.files.length) {
      var file = e.dataTransfer.files[0];
      var fileTypeMatches = file.type && fileTypes.indexOf(file.type) !== -1;
      var fileSuffixMatches = file.name && fileTypes.some(function (x) {
        return file.name.endsWith(x);
      });
      if (fileTypeMatches || fileSuffixMatches) {
        return;
      } else {
        onError("This file type " + file.type + " is not allowed");
      }
    }
    e.preventDefault();
  };
  return React.createElement("div", {
    className: classx("relative flex flex-col items-center gap-3 rounded-lg border-2 border-dashed p-6", className)
  }, React.createElement("input", {
    type: "file",
    title: "",
    ref: fileInput,
    accept: fileTypes.join(","),
    onChange: handleFileChange,
    onDrop: handleFileDrop,
    className: "absolute inset-0 block h-full w-full cursor-pointer opacity-0"
  }), icon, value ? React.createElement("div", {
    className: "w-full space-y-0.5"
  }, React.createElement("p", {
    className: classx(labelBaseCls, labelClass)
  }, value.name), React.createElement("p", {
    className: "w-full text-center text-sm text-gray-400"
  }, formatFileSize(value.size)), React.createElement("button", {
    className: "absolute bottom-2 right-2 text-red-400 hover:text-red-600",
    onClick: handleFileRemove
  }, React.createElement(TrashIcon, {
    className: "h-5 w-5"
  }))) : React.createElement("div", {
    className: "space-y-0.5"
  }, React.createElement("p", {
    className: classx(labelBaseCls, labelClass)
  }, label), React.createElement("div", {
    className: "w-full text-center text-sm text-gray-400"
  }, typeof description === "function" ? description(fileSizeLimit, fileTypes) : description)));
};

var LoadingCircular = function LoadingCircular(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "h-5 w-5" : _ref$className;
  return react.createElement("svg", {
    className: (0,dist.cx)("animate-spin ", className),
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, react.createElement("circle", {
    className: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    strokeWidth: "4"
  }), react.createElement("path", {
    className: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  }));
};

var LoadingDotted = function LoadingDotted(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "text-gray-500" : _ref$className,
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? "2s" : _ref$duration;
  return React.createElement("svg", {
    className: classx("h-2 w-14", className),
    viewBox: "0 0 56 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("circle", {
    cx: "4",
    cy: "4",
    r: "4",
    fill: "currentColor"
  }, React.createElement("animate", {
    attributeName: "opacity",
    values: "0.1;1;0.1;0.1;0.1;0.1",
    dur: duration,
    repeatCount: "indefinite"
  })), React.createElement("circle", {
    cx: "20",
    cy: "4",
    r: "4",
    fill: "currentColor"
  }, React.createElement("animate", {
    attributeName: "opacity",
    values: "0.1;0.1;1;0.1;0.1;0.1",
    dur: duration,
    repeatCount: "indefinite"
  })), React.createElement("circle", {
    cx: "36",
    cy: "4",
    r: "4",
    fill: "currentColor"
  }, React.createElement("animate", {
    attributeName: "opacity",
    values: "0.1;0.1;0.1;1;0.1;0.1",
    dur: duration,
    repeatCount: "indefinite"
  })), React.createElement("circle", {
    cx: "52",
    cy: "4",
    r: "4",
    fill: "currentColor"
  }, React.createElement("animate", {
    attributeName: "opacity",
    values: "0.1;0.1;0.1;0.1;1;0.1",
    dur: duration,
    repeatCount: "indefinite"
  })));
};

var _marked = /*#__PURE__*/_regeneratorRuntime().mark(pageGenerator);
function pageGenerator(current, total) {
  var i;
  return _regeneratorRuntime().wrap(function pageGenerator$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        i = 1;
      case 1:
        if (!(i <= total)) {
          _context.next = 23;
          break;
        }
        if (!(total <= 7 || i === 1 || i === total)) {
          _context.next = 7;
          break;
        }
        _context.next = 5;
        return i;
      case 5:
        _context.next = 20;
        break;
      case 7:
        if (!(i === 2)) {
          _context.next = 12;
          break;
        }
        _context.next = 10;
        return current > 4 ? null : i;
      case 10:
        _context.next = 20;
        break;
      case 12:
        if (!(i === total - 1)) {
          _context.next = 17;
          break;
        }
        _context.next = 15;
        return current < total - 3 ? null : i;
      case 15:
        _context.next = 20;
        break;
      case 17:
        if (!(Math.abs(current - i) < 2 || current <= 4 && i <= 5 || current >= total - 3 && i >= total - 4)) {
          _context.next = 20;
          break;
        }
        _context.next = 20;
        return i;
      case 20:
        ++i;
        _context.next = 1;
        break;
      case 23:
      case "end":
        return _context.stop();
    }
  }, _marked);
}
var buttonStyle$1 = /*#__PURE__*/(0,dist/* cva */.j)("", {
  variants: {
    size: {
      xs: "py-0.5 px-1.5",
      sm: "py-0.5 px-2",
      base: "py-0.5 px-2.5",
      lg: "py-0.5 px-3",
      xl: "py-1 px-3.5"
    }
  }
});
var resetClass = function resetClass(overrideCls) {
  return function (cls) {
    return cls.replace(/p[xy]-\d/g, "") + (" " + overrideCls);
  };
};
var Pagination = function Pagination(_ref) {
  var currentPage = _ref.currentPage,
    totalPages = _ref.totalPages,
    onPageChange = _ref.onPageChange,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "base" : _ref$size,
    isLoading = _ref.isLoading,
    _ref$hideForSinglePag = _ref.hideForSinglePage,
    hideForSinglePage = _ref$hideForSinglePag === void 0 ? true : _ref$hideForSinglePag;
  var page = Array.from(pageGenerator(currentPage, totalPages));
  var sizeClass = buttonStyle$1({
    size: size
  });
  if (hideForSinglePage && totalPages === 1) {
    return react.createElement("div", null);
  } else {
    return react.createElement("div", {
      className: "flex items-center gap-2"
    }, react.createElement("button", {
      className: "p-1 text-gray-400 outline-orange-400 hover:text-orange-500 disabled:text-gray-200",
      onClick: function onClick() {
        return onPageChange(Math.max(1, currentPage - 1));
      },
      disabled: currentPage <= 1
    }, react.createElement(ChevronLeftIcon, {
      className: "h-6 w-6"
    })), isLoading && new Array(7).fill(0).map(function (_, key) {
      return react.createElement(Button, {
        className: resetClass(sizeClass + " animate-pulse"),
        disabled: true,
        key: key,
        onClick: function onClick() {},
        size: size
      }, "\xA0");
    }), !isLoading && page.map(function (p, idx) {
      return p === null ? react.createElement("div", {
        className: sizeClass + " flex flex-col items-center justify-center",
        key: idx
      }, react.createElement(EllipsisHorizontalIcon, {
        className: "h-5 w-5 text-gray-400"
      })) : react.createElement(Button, {
        className: resetClass(sizeClass),
        key: idx,
        intent: p === currentPage ? "highlight" : "secondary",
        onClick: function onClick() {
          return onPageChange(p);
        },
        size: size
      }, p);
    }), react.createElement("button", {
      className: "p-1 text-gray-400 outline-orange-400 hover:text-orange-500 disabled:text-gray-200",
      disabled: currentPage >= totalPages,
      onClick: function onClick() {
        return onPageChange(Math.min(currentPage + 1, totalPages));
      }
    }, react.createElement(solid_ChevronRightIcon, {
      className: "h-6 w-6"
    })));
  }
};

var elementCls$1 = /*#__PURE__*/(0,dist/* cva */.j)("flex items-center py-2", {
  variants: {
    size: {
      sm: "gap-2",
      base: "gap-3",
      lg: "gap-3"
    }
  }
});
var iconCls$2 = /*#__PURE__*/(0,dist/* cva */.j)("flex items-stretch justify-center", {
  variants: {
    intent: {
      "default": "text-orange-500",
      light: "text-orange-500",
      danger: "text-red-500"
    },
    size: {
      sm: "h-5 w-5",
      base: "h-6 w-6",
      lg: "h-7 w-7"
    }
  }
});
var headerCls$1 = /*#__PURE__*/(0,dist/* cva */.j)("flex items-center justify-between", {
  variants: {
    intent: {
      "default": "bg-gray-100 text-gray-600",
      light: "text-gray-600",
      danger: "bg-red-50 text-red-600"
    },
    size: {
      sm: "px-5 py-2 text-xs",
      base: "px-7 py-2.5 text-sm",
      lg: "px-8 py-3 text-base"
    }
  }
});
var bodyCls = /*#__PURE__*/(0,dist/* cva */.j)("text-gray-800", {
  variants: {
    size: {
      sm: "px-5 py-5 text-xs",
      base: "px-7 py-6 text-sm",
      lg: "px-8 py-7 text-base"
    }
  }
});
var containerCls$1 = /*#__PURE__*/(0,dist/* cva */.j)("divide-y overflow-hidden", {
  variants: {
    intent: {
      "default": "divide-gray-200",
      light: "divide-gray-100",
      danger: "divide-red-200"
    }
  }
});
var PanelHeader = function PanelHeader(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? "" : _ref$title,
    icon = _ref.icon,
    _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? "default" : _ref$intent,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "base" : _ref$size,
    leadingHeaderElement = _ref.leadingHeaderElement,
    trailingHeaderElement = _ref.trailingHeaderElement,
    _ref$headerClass = _ref.headerClass,
    headerClass = _ref$headerClass === void 0 ? "" : _ref$headerClass;
  var leadingElement = leadingHeaderElement || react.createElement("div", {
    className: elementCls$1({
      size: size
    })
  }, icon && react.createElement("div", {
    className: iconCls$2({
      intent: intent,
      size: size
    })
  }, icon), react.createElement("div", null, title));
  return react.createElement("div", {
    className: classx(headerCls$1({
      intent: intent,
      size: size
    }), headerClass)
  }, leadingElement, !!trailingHeaderElement && trailingHeaderElement);
};
var Panel = function Panel(_ref2) {
  var title = _ref2.title,
    icon = _ref2.icon,
    shadow = _ref2.shadow,
    leadingHeaderElement = _ref2.leadingHeaderElement,
    trailingHeaderElement = _ref2.trailingHeaderElement,
    footer = _ref2.footer,
    _ref2$intent = _ref2.intent,
    intent = _ref2$intent === void 0 ? "default" : _ref2$intent,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? "base" : _ref2$size,
    _ref2$headerClass = _ref2.headerClass,
    headerClass = _ref2$headerClass === void 0 ? "" : _ref2$headerClass,
    _ref2$bodyClass = _ref2.bodyClass,
    bodyClass = _ref2$bodyClass === void 0 ? "" : _ref2$bodyClass,
    _ref2$className = _ref2.className,
    _className = _ref2$className === void 0 ? "" : _ref2$className,
    children = _ref2.children;
  return react.createElement(Container, {
    className: function className(cls) {
      return classx((0,dist.cx)(cls, containerCls$1({
        intent: intent
      })), _className);
    },
    intent: intent,
    shadow: shadow,
    size: size
  }, react.createElement(PanelHeader, {
    title: title,
    icon: icon,
    leadingHeaderElement: leadingHeaderElement,
    trailingHeaderElement: trailingHeaderElement,
    intent: intent,
    size: size,
    headerClass: headerClass
  }), react.createElement("div", {
    className: classx(bodyCls({
      size: size
    }), bodyClass)
  }, children), !!footer && footer);
};

var _excluded$3 = ["size", "className", "labelClass", "label", "id"];
var labelStyle$1 = /*#__PURE__*/(0,dist/* cva */.j)("select-none text-gray-600 peer-disabled:text-gray-300", {
  variants: {
    size: {
      sm: "text-sm",
      base: "text-base",
      lg: "text-lg"
    }
  }
});
var inputStyle$1 = /*#__PURE__*/(0,dist/* cva */.j)(["peer appearance-none border-gray-300 bg-gray-50 text-orange-400 rounded-full", "checked:ring-transparent checked:border-gray-200 hover:border-gray-200 focus:ring-orange-500/50 disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-100 disabled:ring-transparent"], {
  variants: {
    size: {
      sm: "h-4 w-4",
      base: "h-5 w-5",
      lg: "h-6 w-6"
    }
  }
});
var containerStyle$1 = /*#__PURE__*/(0,dist/* cva */.j)("inline-flex items-center", {
  variants: {
    size: {
      sm: "gap-2.5",
      base: "gap-2.5",
      lg: "gap-3"
    }
  }
});
var Checkbox$1 = function Checkbox(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? "base" : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$labelClass = _ref.labelClass,
    labelClass = _ref$labelClass === void 0 ? "" : _ref$labelClass,
    label = _ref.label,
    id = _ref.id,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  return react.createElement("div", {
    className: classx(containerStyle$1({
      size: size
    }), className)
  }, react.createElement("input", Object.assign({
    type: "radio",
    id: id,
    className: inputStyle$1({
      size: size
    })
  }, props)), label && react.createElement("label", {
    htmlFor: id,
    className: classx(labelStyle$1({
      size: size
    }), labelClass)
  }, label));
};

var containerCls$2 = /*#__PURE__*/(0,dist/* cva */.j)("flex", {
  variants: {
    labelPlacement: {
      left: "flex-row gap-2 items-center",
      top: "flex-col gap-1 items-stretch"
    }
  }
});
var labelCls = /*#__PURE__*/(0,dist/* cva */.j)("block text-gray-500", {
  variants: {
    labelPlacement: {
      left: "",
      top: ""
    },
    size: {
      sm: "",
      base: "",
      lg: ""
    }
  },
  compoundVariants: [{
    size: "sm",
    labelPlacement: "top",
    "class": "text-xs"
  }, {
    size: "sm",
    labelPlacement: "left",
    "class": "text-sm"
  }, {
    size: "base",
    labelPlacement: "top",
    "class": "text-xs"
  }, {
    size: "base",
    labelPlacement: "left",
    "class": "text-basen"
  }, {
    size: "lg",
    labelPlacement: "top",
    "class": "text-sm"
  }, {
    size: "lg",
    labelPlacement: "left",
    "class": "text-base"
  }]
});
var buttonCls = /*#__PURE__*/(0,dist/* cva */.j)("relative block w-full cursor-default text-left group", {
  variants: {
    size: {
      sm: "rounded-md py-1.5 pl-3 pr-9 text-sm",
      base: "rounded-lg py-2 pl-3 pr-10 text-base ",
      lg: "rounded-lg py-3 pl-4 pr-12 text-base"
    },
    variant: {
      normal: ["border border-gray-300 bg-white text-gray-700", "focus:border-orange-500 focus:outline-none focus:ring-2 focus:ring-orange-500/50"],
      highlight: ["border border-orange-400 text-white", "bg-gradient-to-br from-orange-400 to-red-500 hover:from-orange-500 hover:to-red-600 active:from-orange-600 active:to-red-600", "focus:border-orange-500 focus:outline-none focus:ring-2 focus:ring-orange-500/50"],
      borderless: "text-gray-700"
    }
  }
});
var buttonIconCls = /*#__PURE__*/(0,dist/* cva */.j)("", {
  variants: {
    wrapper: {
      "true": "pointer-events-none absolute inset-y-0 right-2 flex items-center "
    },
    size: {
      sm: "",
      base: "",
      lg: ""
    },
    variant: {
      normal: "text-gray-400",
      highlight: "text-orange-300",
      borderless: "text-gray-400 group-hover:text-orange-500"
    }
  },
  compoundVariants: [{
    size: "sm",
    wrapper: false,
    variant: "borderless",
    "class": "h-4 w-4"
  }, {
    size: "sm",
    wrapper: false,
    "class": "h-5 w-5"
  }, {
    size: "base",
    wrapper: false,
    "class": "h-5 w-5"
  }, {
    size: "lg",
    wrapper: false,
    "class": "h-6 w-6"
  }]
});
var optionCls = /*#__PURE__*/(0,dist/* cva */.j)("relative cursor-pointer select-none", {
  variants: {
    size: {
      sm: "text-sm py-1.5",
      base: "text-base py-2",
      lg: "text-base py-3"
    },
    checkIconPlacement: {
      left: "",
      right: ""
    },
    active: {
      "true": "bg-orange-100 text-orange-500",
      "false": "text-gray-700"
    }
  },
  compoundVariants: [{
    size: "sm",
    checkIconPlacement: "left",
    "class": "pl-7 pr-3"
  }, {
    size: "sm",
    checkIconPlacement: "right",
    "class": "pl-3 pr-8"
  }, {
    size: "base",
    checkIconPlacement: "left",
    "class": "pl-8 pr-4"
  }, {
    size: "base",
    checkIconPlacement: "right",
    "class": "pl-3 pr-9"
  }, {
    size: "lg",
    checkIconPlacement: "left",
    "class": "pl-8 pr-4"
  }, {
    size: "lg",
    checkIconPlacement: "right",
    "class": "pl-3 pr-9"
  }]
});
var optionCheckCls = /*#__PURE__*/(0,dist/* cva */.j)("", {
  variants: {
    size: {
      sm: "h-4 w-4",
      base: "h-5 w-5",
      lg: "h-5 w-5"
    },
    checkIconPlacement: {
      left: "left-1.5",
      right: "right-4"
    },
    wrapper: {
      "true": "absolute inset-y-0 flex items-center"
    },
    active: {
      "true": "text-orange-500",
      "false": "text-orange-400"
    }
  }
});
var extraCls = /*#__PURE__*/(0,dist/* cva */.j)("border-gray-100 text-orange-500", {
  variants: {
    size: {
      sm: "text-sm py-1.5 px-3",
      base: "text-base py-2 px-3",
      lg: "text-base py-3 px-3"
    },
    leading: {
      "true": "border-b",
      "false": "border-t"
    }
  }
});
var defaultFieldElement = function defaultFieldElement(value, displayField) {
  return react.createElement("span", {
    className: "block truncate"
  }, (value === undefined || value === null) && "\xA0", value && displayField !== undefined && value[displayField], value && !displayField && value);
};
var defaultOptionElement = function defaultOptionElement(option, displayField, selected) {
  return react.createElement("span", {
    className: (0,dist.cx)(selected ? "font-bold" : "font-normal", "block truncate")
  }, displayField ? option[displayField] : option);
};
var SelectField = function SelectField(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? "" : _ref$label,
    _ref$labelPlacement = _ref.labelPlacement,
    labelPlacement = _ref$labelPlacement === void 0 ? "top" : _ref$labelPlacement,
    _ref$checkIconPlaceme = _ref.checkIconPlacement,
    checkIconPlacement = _ref$checkIconPlaceme === void 0 ? "right" : _ref$checkIconPlaceme,
    _ref$fieldElement = _ref.fieldElement,
    fieldElement = _ref$fieldElement === void 0 ? defaultFieldElement : _ref$fieldElement,
    _ref$optionElement = _ref.optionElement,
    optionElement = _ref$optionElement === void 0 ? defaultOptionElement : _ref$optionElement,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "base" : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "normal" : _ref$variant,
    options = _ref.options,
    displayField = _ref.displayField,
    value = _ref.value,
    menuExtra = _ref.menuExtra,
    disabled = _ref.disabled,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$labelClass = _ref.labelClass,
    labelClass = _ref$labelClass === void 0 ? "" : _ref$labelClass,
    _ref$fieldClass = _ref.fieldClass,
    fieldClass = _ref$fieldClass === void 0 ? "" : _ref$fieldClass,
    _ref$noSelection = _ref.noSelection,
    noSelection = _ref$noSelection === void 0 ? false : _ref$noSelection,
    listboxCls = _ref.listboxCls;
  var _useFloating = (0,floating_ui_react_dom_esm/* useFloating */.YF)({
      placement: "bottom-start",
      middleware: [(0,floating_ui_core_browser_min/* flip */.RR)(), (0,floating_ui_core_browser_min/* offset */.cv)(function (_ref2) {
        var placement = _ref2.placement;
        return placement.indexOf("bottom") >= 0 ? 2 : 12;
      }), (0,floating_ui_core_browser_min/* shift */.uY)()]
    }),
    x = _useFloating.x,
    y = _useFloating.y,
    refs = _useFloating.refs,
    strategy = _useFloating.strategy;
  return react.createElement(Bt, {
    value: value,
    onChange: onChange,
    disabled: disabled
  }, function (_ref3) {
    var _refs$reference$curre;
    var open = _ref3.open;
    return react.createElement("div", {
      className: classx(containerCls$2({
        labelPlacement: labelPlacement
      }), className)
    }, label && react.createElement(Bt.Label, {
      className: classx(labelCls({
        size: size,
        labelPlacement: labelPlacement
      }), labelClass)
    }, label), react.createElement("div", {
      className: "relative flex-grow"
    }, react.createElement(Bt.Button, {
      ref: refs.setReference,
      className: classx(buttonCls({
        size: size,
        variant: variant
      }), disabled ? "opacity-50 " + fieldClass : fieldClass)
    }, typeof fieldElement === "function" ? fieldElement(value, displayField) : fieldElement, react.createElement("span", {
      className: buttonIconCls({
        size: size,
        variant: variant,
        wrapper: true
      })
    }, react.createElement(ChevronUpDownIcon, {
      className: buttonIconCls({
        size: size,
        variant: variant,
        wrapper: false
      }),
      "aria-hidden": "true"
    }))), react.createElement(portal_te, null, react.createElement(tt, {
      show: open,
      as: react.Fragment,
      enter: "transition ease-out duration-100",
      enterFrom: "opacity-0",
      enterTo: "opacity-100",
      leave: "transition ease-in duration-100",
      leaveFrom: "opacity-100",
      leaveTo: "opacity-0"
    }, react.createElement(Bt.Options, {
      style: {
        position: strategy,
        top: y != null ? y : 0,
        left: x != null ? x : 0,
        width: (_refs$reference$curre = refs.reference.current) == null ? void 0 : _refs$reference$curre.getBoundingClientRect().width
      },
      ref: refs.setFloating,
      className: (0,dist.cx)("absolute z-10 mt-1 max-h-60 w-fit overflow-auto rounded-md border border-orange-200 bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none", listboxCls ? listboxCls : "w-full")
    }, (menuExtra == null ? void 0 : menuExtra.leading) && react.createElement("div", {
      className: extraCls({
        size: size,
        leading: true
      })
    }, menuExtra.leading), options.map(function (option, idx) {
      return react.createElement(Bt.Option, {
        key: idx,
        className: function className(_ref4) {
          var active = _ref4.active;
          return optionCls({
            size: size,
            checkIconPlacement: checkIconPlacement,
            active: active
          });
        },
        value: option
      }, function (_ref5) {
        var selected = _ref5.selected,
          active = _ref5.active;
        return react.createElement(react.Fragment, null, typeof optionElement === "function" ? optionElement(option, displayField, selected && !noSelection) : optionElement, selected && !noSelection ? react.createElement("span", {
          className: optionCheckCls({
            wrapper: true,
            checkIconPlacement: checkIconPlacement,
            active: active
          })
        }, react.createElement(CheckIcon, {
          className: optionCheckCls({
            size: size
          }),
          "aria-hidden": "true"
        })) : null);
      });
    }), (menuExtra == null ? void 0 : menuExtra.trailing) && react.createElement("div", {
      className: extraCls({
        size: size,
        leading: false
      })
    }, menuExtra.trailing))))));
  });
};

var textStyle = /*#__PURE__*/(0,dist/* cva */.j)("animate-pulse", {
  variants: {
    variant: {
      "default": "bg-gray-200"
    },
    size: {
      sm: "h-3.5 rounded",
      base: "h-4 rounded-md",
      lg: "h-5 rounded-lg"
    }
  }
});
var spacingStyle = /*#__PURE__*/(0,dist/* cva */.j)("", {
  variants: {
    size: {
      sm: "space-y-1.5 py-0.5",
      base: "space-y-2 py-1",
      lg: "space-y-2.5 py-1"
    }
  }
});
var pictureStyle = /*#__PURE__*/(0,dist/* cva */.j)("animate-pulse rounded-full", {
  variants: {
    variant: {
      "default": "bg-gray-200"
    }
  }
});
var Skeleton = function Skeleton(_ref) {
  var children = _ref.children,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? true : _ref$isLoading,
    _ref$lines = _ref.lines,
    lines = _ref$lines === void 0 ? 1 : _ref$lines,
    _ref$isPicture = _ref.isPicture,
    isPicture = _ref$isPicture === void 0 ? false : _ref$isPicture,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "default" : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "base" : _ref$size;
  if (isLoading) {
    if (isPicture) {
      var skeletonCls = classx(pictureStyle({
        variant: variant
      }), className);
      return react.createElement("div", {
        className: skeletonCls
      });
    } else {
      var _skeletonCls = classx(textStyle({
        size: size,
        variant: variant
      }), className);
      return react.createElement("div", {
        className: spacingStyle({
          size: size
        })
      }, Array.from(Array(lines)).map(function (_, idx) {
        return react.createElement("div", {
          className: (0,dist.cx)(_skeletonCls, idx === lines - 1 && idx ? "w-2/3" : ""),
          key: idx
        });
      }));
    }
  } else {
    return react.createElement(react.Fragment, null, children);
  }
};

var _excluded$4 = ["children", "className", "labelClass", "inputClass", "size", "variant", "intent", "labelPlacement", "label", "leadingIcon", "trailingIcon", "showClearButton", "onChange", "onClear", "id"];
var containerCls$3 = /*#__PURE__*/(0,dist/* cva */.j)("flex", {
  variants: {
    labelPlacement: {
      top: "flex-col items-stretch gap-1",
      left: "flex-row items-center gap-3"
    }
  }
});
var labelCls$1 = /*#__PURE__*/(0,dist/* cva */.j)("block text-gray-500", {
  variants: {
    size: {
      sm: "",
      base: "",
      lg: ""
    },
    labelPlacement: {
      top: "",
      left: ""
    }
  },
  compoundVariants: [{
    size: "sm",
    labelPlacement: "top",
    "class": "text-xs"
  }, {
    size: "sm",
    labelPlacement: "left",
    "class": "text-sm"
  }, {
    size: "base",
    labelPlacement: "top",
    "class": "text-xs"
  }, {
    size: "base",
    labelPlacement: "left",
    "class": "text-base"
  }, {
    size: "lg",
    labelPlacement: "top",
    "class": "text-sm"
  }, {
    size: "lg",
    labelPlacement: "left",
    "class": "text-base"
  }]
});
var clearButtonCls = /*#__PURE__*/(0,dist/* cva */.j)("text-gray-400 hover:text-orange-500 absolute", {
  variants: {
    size: {
      sm: "w-5 h-5 top-1.5 right-2",
      base: "w-6 h-6 top-2 right-3",
      lg: "w-7 h-7 top-2.5 right-3"
    }
  }
});
var iconCls$3 = /*#__PURE__*/(0,dist/* cva */.j)("pointer-events-none absolute flex items-center justify-center text-orange-400", {
  variants: {
    size: {
      sm: "w-5 h-5 top-1.5",
      base: "w-6 h-6 top-2",
      lg: "w-7 h-7 top-2.5"
    },
    isLeading: {
      "true": ""
    }
  },
  compoundVariants: [{
    size: "sm",
    isLeading: true,
    "class": "left-2"
  }, {
    size: "sm",
    isLeading: false,
    "class": "right-2"
  }, {
    size: "base",
    isLeading: true,
    "class": "left-3"
  }, {
    size: "base",
    isLeading: false,
    "class": "right-3"
  }, {
    size: "lg",
    isLeading: true,
    "class": "left-3"
  }, {
    size: "lg",
    isLeading: false,
    "class": "right-3"
  }]
});
var inputCls = /*#__PURE__*/(0,dist/* cva */.j)(["block w-full border outline-none", "text-gray-700  placeholder:text-gray-400", "focus:bg-white", "disabled:bg-gray-100 disabled:text-gray-400"], {
  variants: {
    intent: {
      "default": "focus:border-orange-500 focus:ring-2 focus:ring-orange-500/50",
      success: "border-lime-400 bg-lime-50 focus:border-lime-500 focus:ring-2 focus:ring-lime-500/50",
      error: "border-red-300 bg-red-50 focus:border-red-500 focus:ring-2 focus:ring-red-500/50"
    },
    variant: {
      "default": "border-gray-300 bg-gray-50",
      borderless: "border-transparent shadow-inner",
      light: "border-gray-300"
    },
    size: {
      sm: ["text-sm py-1.5 rounded-md", "py-1"],
      base: ["text-base py-2 rounded-lg", "py-2"],
      lg: ["text-base py-3 rounded-lg", "py-3"]
    },
    hasLeadingIcon: {
      "true": ""
    },
    hasTrailingIcon: {
      "true": ""
    }
  },
  compoundVariants: [{
    size: "sm",
    hasLeadingIcon: true,
    "class": "pl-9 pr-3"
  }, {
    size: "base",
    hasLeadingIcon: true,
    "class": "pl-11 pr-3"
  }, {
    size: "lg",
    hasLeadingIcon: true,
    "class": "pl-12 pr-5"
  }, {
    size: "sm",
    hasTrailingIcon: true,
    "class": "pr-9 pl-3"
  }, {
    size: "base",
    hasTrailingIcon: true,
    "class": "pr-11 pl-3"
  }, {
    size: "lg",
    hasTrailingIcon: true,
    "class": "pr-12 pl-5"
  }, {
    size: "sm",
    hasLeadingIcon: false,
    hasTrailingIcon: false,
    "class": "px-3"
  }, {
    size: "base",
    hasLeadingIcon: false,
    hasTrailingIcon: false,
    "class": "px-3"
  }, {
    size: "lg",
    hasLeadingIcon: false,
    hasTrailingIcon: false,
    "class": "px-5"
  }]
});
var TextField = function TextField(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$labelClass = _ref.labelClass,
    labelClass = _ref$labelClass === void 0 ? "" : _ref$labelClass,
    _ref$inputClass = _ref.inputClass,
    inputClass = _ref$inputClass === void 0 ? "" : _ref$inputClass,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "base" : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "default" : _ref$variant,
    _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? "default" : _ref$intent,
    _ref$labelPlacement = _ref.labelPlacement,
    labelPlacement = _ref$labelPlacement === void 0 ? "top" : _ref$labelPlacement,
    label = _ref.label,
    leadingIcon = _ref.leadingIcon,
    trailingIcon = _ref.trailingIcon,
    _ref$showClearButton = _ref.showClearButton,
    showClearButton = _ref$showClearButton === void 0 ? false : _ref$showClearButton,
    _onChange = _ref.onChange,
    _ref$onClear = _ref.onClear,
    onClear = _ref$onClear === void 0 ? function () {} : _ref$onClear,
    id = _ref.id,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  var _useState = (0,react.useState)(false),
    clearButtonVisible = _useState[0],
    setClearButtonVisible = _useState[1];
  return react.createElement("div", {
    className: classx(containerCls$3({
      labelPlacement: labelPlacement
    }), className)
  }, label && react.createElement("label", {
    htmlFor: id,
    className: classx(labelCls$1({
      size: size,
      labelPlacement: labelPlacement
    }), labelClass)
  }, label), react.createElement("div", {
    className: "relative rounded-md"
  }, leadingIcon && react.createElement("div", {
    className: iconCls$3({
      size: size,
      isLeading: true
    })
  }, leadingIcon), react.createElement("input", Object.assign({
    id: id,
    className: classx(inputCls({
      size: size,
      variant: variant,
      intent: intent,
      hasLeadingIcon: !!leadingIcon,
      hasTrailingIcon: !!trailingIcon
    }), inputClass),
    onChange: function onChange(e) {
      setClearButtonVisible(!!e.target.value && !e.target.disabled);
      _onChange && _onChange(e);
    }
  }, props)), showClearButton && clearButtonVisible && react.createElement("button", {
    className: clearButtonCls({
      size: size
    }),
    onClick: function onClick() {
      return onClear();
    }
  }, react.createElement(XMarkIcon, {
    className: "h-5/6 w-5/6"
  })), trailingIcon && react.createElement("div", {
    className: iconCls$3({
      size: size,
      isLeading: false
    })
  }, trailingIcon)));
};

var _excluded$5 = ["className", "labelClass", "inputClass", "size", "variant", "intent", "labelPlacement", "label", "leadingIcon", "trailingIcon", "showClearButton", "onChange", "onClear", "id"];
// HTMLTextAreaElement
var containerCls$4 = /*#__PURE__*/(0,dist/* cva */.j)("flex", {
  variants: {
    labelPlacement: {
      top: "flex-col items-stretch gap-1",
      left: "flex-row items-center gap-3"
    }
  }
});
var labelCls$2 = /*#__PURE__*/(0,dist/* cva */.j)("block text-gray-500", {
  variants: {
    size: {
      sm: "",
      base: "",
      lg: ""
    },
    labelPlacement: {
      top: "",
      left: ""
    }
  },
  compoundVariants: [{
    size: "sm",
    labelPlacement: "top",
    "class": "text-xs"
  }, {
    size: "sm",
    labelPlacement: "left",
    "class": "text-sm"
  }, {
    size: "base",
    labelPlacement: "top",
    "class": "text-xs"
  }, {
    size: "base",
    labelPlacement: "left",
    "class": "text-base"
  }, {
    size: "lg",
    labelPlacement: "top",
    "class": "text-sm"
  }, {
    size: "lg",
    labelPlacement: "left",
    "class": "text-base"
  }]
});
var clearButtonCls$1 = /*#__PURE__*/(0,dist/* cva */.j)("text-gray-400 hover:text-orange-500 absolute", {
  variants: {
    size: {
      sm: "w-5 h-5 top-2 right-2",
      base: "w-6 h-6 top-2.5 right-3",
      lg: "w-7 h-7 top-3 right-3"
    }
  }
});
var iconCls$4 = /*#__PURE__*/(0,dist/* cva */.j)("pointer-events-none absolute flex items-center justify-center text-orange-400", {
  variants: {
    size: {
      sm: "w-5 h-5 top-1.5",
      base: "w-6 h-6 top-2",
      lg: "w-7 h-7 top-2.5"
    },
    isLeading: {
      "true": ""
    }
  },
  compoundVariants: [{
    size: "sm",
    isLeading: true,
    "class": "left-2"
  }, {
    size: "sm",
    isLeading: false,
    "class": "right-2"
  }, {
    size: "base",
    isLeading: true,
    "class": "left-3"
  }, {
    size: "base",
    isLeading: false,
    "class": "right-3"
  }, {
    size: "lg",
    isLeading: true,
    "class": "left-3"
  }, {
    size: "lg",
    isLeading: false,
    "class": "right-3"
  }]
});
var inputCls$1 = /*#__PURE__*/(0,dist/* cva */.j)(["block w-full border outline-none", "text-gray-700  placeholder:text-gray-400", "focus:bg-white", "disabled:bg-gray-100 disabled:text-gray-400"], {
  variants: {
    intent: {
      "default": "focus:border-orange-500 focus:ring-2 focus:ring-orange-500/50",
      success: "border-lime-400 bg-lime-50 focus:border-lime-500 focus:ring-2 focus:ring-lime-500/50",
      error: "border-red-300 bg-red-50 focus:border-red-500 focus:ring-2 focus:ring-red-500/50"
    },
    variant: {
      "default": "border-gray-300 bg-gray-50",
      borderless: "border-transparent shadow-inner",
      light: "border-gray-300"
    },
    size: {
      sm: ["text-sm py-1.5 rounded-md", "py-1"],
      base: ["text-base py-2 rounded-lg", "py-2"],
      lg: ["text-base py-3 rounded-lg", "py-3"]
    },
    hasLeadingIcon: {
      "true": ""
    },
    hasTrailingIcon: {
      "true": ""
    }
  },
  compoundVariants: [{
    size: "sm",
    hasLeadingIcon: true,
    "class": "pl-9 pr-3"
  }, {
    size: "base",
    hasLeadingIcon: true,
    "class": "pl-11 pr-3"
  }, {
    size: "lg",
    hasLeadingIcon: true,
    "class": "pl-12 pr-5"
  }, {
    size: "sm",
    hasTrailingIcon: true,
    "class": "pr-9 pl-3"
  }, {
    size: "base",
    hasTrailingIcon: true,
    "class": "pr-11 pl-3"
  }, {
    size: "lg",
    hasTrailingIcon: true,
    "class": "pr-12 pl-5"
  }, {
    size: "sm",
    hasLeadingIcon: false,
    hasTrailingIcon: false,
    "class": "px-3"
  }, {
    size: "base",
    hasLeadingIcon: false,
    hasTrailingIcon: false,
    "class": "px-3"
  }, {
    size: "lg",
    hasLeadingIcon: false,
    hasTrailingIcon: false,
    "class": "px-5"
  }]
});
var TextAreaField = function TextAreaField(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$labelClass = _ref.labelClass,
    labelClass = _ref$labelClass === void 0 ? "" : _ref$labelClass,
    _ref$inputClass = _ref.inputClass,
    inputClass = _ref$inputClass === void 0 ? "" : _ref$inputClass,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "base" : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "default" : _ref$variant,
    _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? "default" : _ref$intent,
    _ref$labelPlacement = _ref.labelPlacement,
    labelPlacement = _ref$labelPlacement === void 0 ? "top" : _ref$labelPlacement,
    label = _ref.label,
    leadingIcon = _ref.leadingIcon,
    trailingIcon = _ref.trailingIcon,
    _ref$showClearButton = _ref.showClearButton,
    showClearButton = _ref$showClearButton === void 0 ? false : _ref$showClearButton,
    _onChange = _ref.onChange,
    _ref$onClear = _ref.onClear,
    onClear = _ref$onClear === void 0 ? function () {} : _ref$onClear,
    id = _ref.id,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$5);
  var _useState = (0,react.useState)(false),
    clearButtonVisible = _useState[0],
    setClearButtonVisible = _useState[1];
  return react.createElement("div", {
    className: classx(containerCls$4({
      labelPlacement: labelPlacement
    }), className)
  }, label && react.createElement("label", {
    htmlFor: id,
    className: classx(labelCls$2({
      size: size,
      labelPlacement: labelPlacement
    }), labelClass)
  }, label), react.createElement("div", {
    className: "relative rounded-md"
  }, leadingIcon && react.createElement("div", {
    className: iconCls$4({
      size: size,
      isLeading: true
    })
  }, leadingIcon), react.createElement("textarea", Object.assign({
    id: id,
    className: classx(inputCls$1({
      size: size,
      variant: variant,
      intent: intent,
      hasLeadingIcon: !!leadingIcon,
      hasTrailingIcon: !!trailingIcon
    }), inputClass),
    onChange: function onChange(e) {
      setClearButtonVisible(!!e.target.value && !e.target.disabled);
      _onChange && _onChange(e);
    }
  }, props)), showClearButton && clearButtonVisible && react.createElement("button", {
    className: clearButtonCls$1({
      size: size
    }),
    onClick: function onClick() {
      return onClear();
    }
  }, react.createElement(XMarkIcon, {
    className: "h-5/6 w-5/6"
  })), trailingIcon && react.createElement("div", {
    className: iconCls$4({
      size: size,
      isLeading: false
    })
  }, trailingIcon)));
};

var CONTAINER_CLS = "";
var TOOLTIP_CLS = "rounded-md bg-gray-50 px-3 py-1.5 text-xs font-normal text-gray-600 shadow-lg ring-1 ring-gray-500/30 z-30";
var Tooltip = function Tooltip(_ref) {
  var content = _ref.content,
    children = _ref.children,
    className = _ref.className,
    _ref$tooltipOffset = _ref.tooltipOffset,
    tooltipOffset = _ref$tooltipOffset === void 0 ? 5 : _ref$tooltipOffset,
    tooltipClassName = _ref.tooltipClassName,
    _ref$event = _ref.event,
    event = _ref$event === void 0 ? "hover" : _ref$event,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? 800 : _ref$delay;
  var _useState = (0,react.useState)(false),
    open = _useState[0],
    setOpen = _useState[1];
  var _useFloating = useFloating({
      open: open,
      onOpenChange: setOpen,
      placement: "bottom-start",
      middleware: [(0,floating_ui_core_browser_min/* flip */.RR)(), (0,floating_ui_core_browser_min/* offset */.cv)(tooltipOffset), (0,floating_ui_core_browser_min/* shift */.uY)()]
    }),
    x = _useFloating.x,
    y = _useFloating.y,
    refs = _useFloating.refs,
    strategy = _useFloating.strategy,
    context = _useFloating.context;
  var _useInteractions = useInteractions([useHover(context, {
      delay: delay,
      enabled: event === "hover" && !disabled
    }), useClick(context, {
      enabled: event === "click" && !disabled
    })]),
    getReferenceProps = _useInteractions.getReferenceProps,
    getFloatingProps = _useInteractions.getFloatingProps;
  var containerCls = calculateClasses(className, CONTAINER_CLS);
  var tooltipCls = calculateClasses(tooltipClassName, TOOLTIP_CLS);
  return react.createElement(react.Fragment, null, react.createElement("div", Object.assign({
    className: containerCls,
    ref: refs.setReference
  }, getReferenceProps()), children), react.createElement(portal_te, null, react.createElement(tt, Object.assign({
    show: open,
    enter: "transition-opacity duration-75",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "transition-opacity duration-150",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0",
    ref: refs.setFloating,
    style: {
      position: strategy,
      top: y != null ? y : 0,
      left: x != null ? x : 0
    },
    className: tooltipCls
  }, getFloatingProps()), content)));
};

var containerCls$5 = /*#__PURE__*/(0,dist/* cva */.j)("flex relative", {
  variants: {
    labelPlacement: {
      left: "flex-row gap-2 items-center",
      top: "flex-col gap-1 items-stretch"
    }
  }
});
var labelCls$3 = /*#__PURE__*/(0,dist/* cva */.j)("block text-gray-500", {
  variants: {
    labelPlacement: {
      left: "",
      top: ""
    },
    size: {
      sm: "",
      base: "",
      lg: ""
    }
  },
  compoundVariants: [{
    size: "sm",
    labelPlacement: "top",
    "class": "text-xs"
  }, {
    size: "sm",
    labelPlacement: "left",
    "class": "text-sm"
  }, {
    size: "base",
    labelPlacement: "top",
    "class": "text-xs"
  }, {
    size: "base",
    labelPlacement: "left",
    "class": "text-basen"
  }, {
    size: "lg",
    labelPlacement: "top",
    "class": "text-sm"
  }, {
    size: "lg",
    labelPlacement: "left",
    "class": "text-base"
  }]
});
var inputCls$2 = /*#__PURE__*/(0,dist/* cva */.j)("relative block w-full cursor-default text-left group placeholder:text-gray-300", {
  variants: {
    size: {
      sm: "rounded-md py-1.5 pl-3 pr-9 text-sm",
      base: "rounded-lg py-2 pl-3 pr-10 text-base ",
      lg: "rounded-lg py-3 pl-4 pr-12 text-base"
    },
    variant: {
      normal: ["border border-gray-300 bg-white text-gray-700", "focus:border-orange-500 focus:outline-none focus:ring-2 focus:ring-orange-500/50"],
      highlight: ["border border-orange-400 text-white", "bg-gradient-to-br from-orange-400 to-red-500 hover:from-orange-500 hover:to-red-600 active:from-orange-600 active:to-red-600", "focus:border-orange-500 focus:outline-none focus:ring-2 focus:ring-orange-500/50"],
      borderless: "text-gray-700"
    }
  }
});
var optionCls$1 = /*#__PURE__*/(0,dist/* cva */.j)("relative cursor-pointer select-none", {
  variants: {
    size: {
      sm: "text-sm py-1.5",
      base: "text-base py-2",
      lg: "text-base py-3"
    },
    checkIconPlacement: {
      left: "",
      right: ""
    },
    active: {
      "true": "bg-orange-100 text-orange-500",
      "false": "text-gray-700"
    }
  },
  compoundVariants: [{
    size: "sm",
    checkIconPlacement: "left",
    "class": "pl-7 pr-3"
  }, {
    size: "sm",
    checkIconPlacement: "right",
    "class": "pl-3 pr-8"
  }, {
    size: "base",
    checkIconPlacement: "left",
    "class": "pl-8 pr-4"
  }, {
    size: "base",
    checkIconPlacement: "right",
    "class": "pl-3 pr-9"
  }, {
    size: "lg",
    checkIconPlacement: "left",
    "class": "pl-8 pr-4"
  }, {
    size: "lg",
    checkIconPlacement: "right",
    "class": "pl-3 pr-9"
  }]
});
var optionCheckCls$1 = /*#__PURE__*/(0,dist/* cva */.j)("", {
  variants: {
    size: {
      sm: "h-4 w-4",
      base: "h-5 w-5",
      lg: "h-5 w-5"
    },
    checkIconPlacement: {
      left: "left-1.5",
      right: "right-4"
    },
    wrapper: {
      "true": "absolute inset-y-0 flex items-center"
    },
    active: {
      "true": "text-orange-500",
      "false": "text-orange-400"
    }
  }
});
var ComboboxFields = function ComboboxFields(_ref) {
  var _refs$reference$curre;
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? "" : _ref$label,
    _ref$labelPlacement = _ref.labelPlacement,
    labelPlacement = _ref$labelPlacement === void 0 ? "top" : _ref$labelPlacement,
    _ref$checkIconPlaceme = _ref.checkIconPlacement,
    checkIconPlacement = _ref$checkIconPlaceme === void 0 ? "right" : _ref$checkIconPlaceme,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "base" : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "normal" : _ref$variant,
    options = _ref.options,
    displayField = _ref.displayField,
    value = _ref.value,
    disabled = _ref.disabled,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$onInputChange = _ref.onInputChange,
    onInputChange = _ref$onInputChange === void 0 ? function () {} : _ref$onInputChange,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$labelClass = _ref.labelClass,
    labelClass = _ref$labelClass === void 0 ? "" : _ref$labelClass,
    _ref$fieldClass = _ref.fieldClass,
    fieldClass = _ref$fieldClass === void 0 ? "" : _ref$fieldClass,
    listboxCls = _ref.listboxCls,
    id = _ref.id,
    placeholder = _ref.placeholder,
    textFieldProps = _ref.textFieldProps;
  var _useState = (0,react.useState)(""),
    query = _useState[0],
    setQuery = _useState[1];
  var filteredData = query === "" ? options : options.filter(function (option) {
    return (displayField ? option[displayField] : String(option)).toLowerCase().replace(/\s+/g, "").includes(query.toLowerCase().replace(/\s+/g, ""));
  });
  var _useFloating = (0,floating_ui_react_dom_esm/* useFloating */.YF)({
      placement: "bottom-start",
      middleware: [(0,floating_ui_core_browser_min/* flip */.RR)(), (0,floating_ui_core_browser_min/* offset */.cv)(function (_ref2) {
        var placement = _ref2.placement;
        return placement.indexOf("bottom") >= 0 ? 2 : 12;
      }), (0,floating_ui_core_browser_min/* shift */.uY)()]
    }),
    x = _useFloating.x,
    y = _useFloating.y,
    refs = _useFloating.refs,
    strategy = _useFloating.strategy;
  return options && options.length > 0 ? react.createElement("div", {
    className: classx(containerCls$5({
      labelPlacement: labelPlacement
    }), className)
  }, label && react.createElement("label", {
    htmlFor: id,
    className: classx(labelCls$3({
      size: size,
      labelPlacement: labelPlacement
    }), labelClass)
  }, label), react.createElement(Ko, {
    value: value,
    onChange: onChange,
    disabled: disabled
  }, react.createElement("div", {
    className: ""
  }, react.createElement("div", {
    className: "relative",
    ref: refs.setReference
  }, react.createElement(Ko.Input, {
    id: id,
    className: classx(inputCls$2({
      size: size,
      variant: variant
    }), disabled ? "opacity-50 " + fieldClass : fieldClass),
    displayValue: function displayValue(data) {
      if (displayField) {
        return displayField && data ? data[displayField] : "";
      } else {
        return String(data);
      }
    },
    placeholder: placeholder,
    onChange: function onChange(event) {
      setQuery(event.target.value);
      onInputChange(event.target.value);
    }
  }), react.createElement(Ko.Button, {
    className: "absolute inset-y-0 right-0 flex items-center pr-2"
  }, react.createElement(ChevronUpDownIcon, {
    className: "h-5 w-5 text-gray-400",
    "aria-hidden": "true"
  }))), react.createElement(portal_te, null, react.createElement(tt, {
    as: react.Fragment,
    leave: "transition ease-in duration-100",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0",
    afterLeave: function afterLeave() {
      return setQuery("");
    }
  }, react.createElement(Ko.Options, {
    ref: refs.setFloating,
    style: {
      position: strategy,
      top: y != null ? y : 0,
      left: x != null ? x : 0,
      width: (_refs$reference$curre = refs.reference.current) == null ? void 0 : _refs$reference$curre.getBoundingClientRect().width
    },
    className: (0,dist.cx)("absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md border border-orange-200 bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none", listboxCls ? listboxCls : "w-full")
  }, filteredData.length === 0 && query !== "" ? react.createElement("div", null, query.length > 0 && react.createElement(Ko.Option, {
    className: function className(_ref3) {
      var active = _ref3.active;
      return optionCls$1({
        size: size,
        checkIconPlacement: checkIconPlacement,
        active: active
      });
    },
    value: query
  }, "Create \"", query, "\"")) : filteredData.map(function (data, idx) {
    return react.createElement(Ko.Option, {
      key: idx,
      className: function className(_ref4) {
        var active = _ref4.active;
        return optionCls$1({
          size: size,
          checkIconPlacement: checkIconPlacement,
          active: active
        });
      },
      value: data
    }, function (_ref5) {
      var selected = _ref5.selected,
        active = _ref5.active;
      return react.createElement(react.Fragment, null, react.createElement("span", {
        className: "block truncate " + (selected ? "font-bold" : "font-normal")
      }, displayField ? data[displayField] : String(data)), selected ? react.createElement("span", {
        className: optionCheckCls$1({
          wrapper: true,
          checkIconPlacement: checkIconPlacement,
          active: active
        })
      }, react.createElement(CheckIcon, {
        className: optionCheckCls$1({
          size: size
        }),
        "aria-hidden": "true"
      })) : null);
    });
  }))))))) : react.createElement(TextField, Object.assign({}, textFieldProps));
};


//# sourceMappingURL=ui-base.esm.js.map


/***/ }),

/***/ 74637:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p=function(t){return t instanceof _},S=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=v;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t)}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return O},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),l=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(h){case c:return r?l(1,0):l(31,11);case f:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),l=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,l=this;r=Number(r);var $=O.p(h),y=function(t){var e=w(l);return O.w(e.date(e.date()+Math.round(t*r)),l)};if($===f)return this.set(f,this.$M+r);if($===c)return this.set(c,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},$={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||$[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,v=this-M,g=O.m(this,M);return g=($={},$[c]=g/12,$[f]=g,$[h]=g/3,$[o]=(v-m)/6048e5,$[a]=(v-m)/864e5,$[u]=v/n,$[s]=v/e,$[i]=v/t,$)[y]||v,l?g:O.a(g)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),T=_.prototype;return w.prototype=T,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){T[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[g],w.Ls=D,w.p={},w}));

/***/ }),

/***/ 23005:
/***/ (function(module) {

!function(t,s){ true?module.exports=s():0}(this,(function(){"use strict";var t,s,n=1e3,i=6e4,e=36e5,r=864e5,o=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,u=31536e6,h=2592e6,a=/^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/,d={years:u,months:h,days:r,hours:e,minutes:i,seconds:n,milliseconds:1,weeks:6048e5},c=function(t){return t instanceof p},f=function(t,s,n){return new p(t,n,s.$l)},m=function(t){return s.p(t)+"s"},l=function(t){return t<0},$=function(t){return l(t)?Math.ceil(t):Math.floor(t)},y=function(t){return Math.abs(t)},g=function(t,s){return t?l(t)?{negative:!0,format:""+y(t)+s}:{negative:!1,format:""+t+s}:{negative:!1,format:""}},p=function(){function l(t,s,n){var i=this;if(this.$d={},this.$l=n,void 0===t&&(this.$ms=0,this.parseFromMilliseconds()),s)return f(t*d[m(s)],this);if("number"==typeof t)return this.$ms=t,this.parseFromMilliseconds(),this;if("object"==typeof t)return Object.keys(t).forEach((function(s){i.$d[m(s)]=t[s]})),this.calMilliseconds(),this;if("string"==typeof t){var e=t.match(a);if(e){var r=e.slice(2).map((function(t){return null!=t?Number(t):0}));return this.$d.years=r[0],this.$d.months=r[1],this.$d.weeks=r[2],this.$d.days=r[3],this.$d.hours=r[4],this.$d.minutes=r[5],this.$d.seconds=r[6],this.calMilliseconds(),this}}return this}var y=l.prototype;return y.calMilliseconds=function(){var t=this;this.$ms=Object.keys(this.$d).reduce((function(s,n){return s+(t.$d[n]||0)*d[n]}),0)},y.parseFromMilliseconds=function(){var t=this.$ms;this.$d.years=$(t/u),t%=u,this.$d.months=$(t/h),t%=h,this.$d.days=$(t/r),t%=r,this.$d.hours=$(t/e),t%=e,this.$d.minutes=$(t/i),t%=i,this.$d.seconds=$(t/n),t%=n,this.$d.milliseconds=t},y.toISOString=function(){var t=g(this.$d.years,"Y"),s=g(this.$d.months,"M"),n=+this.$d.days||0;this.$d.weeks&&(n+=7*this.$d.weeks);var i=g(n,"D"),e=g(this.$d.hours,"H"),r=g(this.$d.minutes,"M"),o=this.$d.seconds||0;this.$d.milliseconds&&(o+=this.$d.milliseconds/1e3);var u=g(o,"S"),h=t.negative||s.negative||i.negative||e.negative||r.negative||u.negative,a=e.format||r.format||u.format?"T":"",d=(h?"-":"")+"P"+t.format+s.format+i.format+a+e.format+r.format+u.format;return"P"===d||"-P"===d?"P0D":d},y.toJSON=function(){return this.toISOString()},y.format=function(t){var n=t||"YYYY-MM-DDTHH:mm:ss",i={Y:this.$d.years,YY:s.s(this.$d.years,2,"0"),YYYY:s.s(this.$d.years,4,"0"),M:this.$d.months,MM:s.s(this.$d.months,2,"0"),D:this.$d.days,DD:s.s(this.$d.days,2,"0"),H:this.$d.hours,HH:s.s(this.$d.hours,2,"0"),m:this.$d.minutes,mm:s.s(this.$d.minutes,2,"0"),s:this.$d.seconds,ss:s.s(this.$d.seconds,2,"0"),SSS:s.s(this.$d.milliseconds,3,"0")};return n.replace(o,(function(t,s){return s||String(i[t])}))},y.as=function(t){return this.$ms/d[m(t)]},y.get=function(t){var s=this.$ms,n=m(t);return"milliseconds"===n?s%=1e3:s="weeks"===n?$(s/d[n]):this.$d[n],0===s?0:s},y.add=function(t,s,n){var i;return i=s?t*d[m(s)]:c(t)?t.$ms:f(t,this).$ms,f(this.$ms+i*(n?-1:1),this)},y.subtract=function(t,s){return this.add(t,s,!0)},y.locale=function(t){var s=this.clone();return s.$l=t,s},y.clone=function(){return f(this.$ms,this)},y.humanize=function(s){return t().add(this.$ms,"ms").locale(this.$l).fromNow(!s)},y.milliseconds=function(){return this.get("milliseconds")},y.asMilliseconds=function(){return this.as("milliseconds")},y.seconds=function(){return this.get("seconds")},y.asSeconds=function(){return this.as("seconds")},y.minutes=function(){return this.get("minutes")},y.asMinutes=function(){return this.as("minutes")},y.hours=function(){return this.get("hours")},y.asHours=function(){return this.as("hours")},y.days=function(){return this.get("days")},y.asDays=function(){return this.as("days")},y.weeks=function(){return this.get("weeks")},y.asWeeks=function(){return this.as("weeks")},y.months=function(){return this.get("months")},y.asMonths=function(){return this.as("months")},y.years=function(){return this.get("years")},y.asYears=function(){return this.as("years")},l}();return function(n,i,e){t=e,s=e().$utils(),e.duration=function(t,s){var n=e.locale();return f(t,{$l:n},s)},e.isDuration=c;var r=i.prototype.add,o=i.prototype.subtract;i.prototype.add=function(t,s){return c(t)&&(t=t.asMilliseconds()),r.bind(this)(t,s)},i.prototype.subtract=function(t,s){return c(t)&&(t=t.asMilliseconds()),o.bind(this)(t,s)}}}));

/***/ }),

/***/ 54498:
/***/ (function(module) {

!function(r,e){ true?module.exports=e():0}(this,(function(){"use strict";return function(r,e,t){r=r||{};var n=e.prototype,o={future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"};function i(r,e,t,o){return n.fromToBase(r,e,t,o)}t.en.relativeTime=o,n.fromToBase=function(e,n,i,d,u){for(var f,a,s,l=i.$locale().relativeTime||o,h=r.thresholds||[{l:"s",r:44,d:"second"},{l:"m",r:89},{l:"mm",r:44,d:"minute"},{l:"h",r:89},{l:"hh",r:21,d:"hour"},{l:"d",r:35},{l:"dd",r:25,d:"day"},{l:"M",r:45},{l:"MM",r:10,d:"month"},{l:"y",r:17},{l:"yy",d:"year"}],m=h.length,c=0;c<m;c+=1){var y=h[c];y.d&&(f=d?t(e).diff(i,y.d,!0):i.diff(e,y.d,!0));var p=(r.rounding||Math.round)(Math.abs(f));if(s=f>0,p<=y.r||!y.r){p<=1&&c>0&&(y=h[c-1]);var v=l[y.l];u&&(p=u(""+p)),a="string"==typeof v?v.replace("%d",p):v(p,n,y.l,s);break}}if(n)return a;var M=s?l.future:l.past;return"function"==typeof M?M(a):M.replace("%s",a)},n.to=function(r,e){return i(r,e,this,!0)},n.from=function(r,e){return i(r,e,this)};var d=function(r){return r.$u?t.utc():t()};n.toNow=function(r){return this.to(d(this),r)},n.fromNow=function(r){return this.from(d(this),r)}}}));

/***/ }),

/***/ 42660:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JB": function() { return /* binding */ s; },
/* harmony export */   "RR": function() { return /* binding */ A; },
/* harmony export */   "cv": function() { return /* binding */ L; },
/* harmony export */   "oo": function() { return /* binding */ r; },
/* harmony export */   "uY": function() { return /* binding */ O; }
/* harmony export */ });
/* unused harmony exports arrow, autoPlacement, detectOverflow, hide, inline, limitShift, size */
function t(t){return t.split("-")[1]}function e(t){return"y"===t?"height":"width"}function n(t){return t.split("-")[0]}function o(t){return["top","bottom"].includes(n(t))?"x":"y"}function i(i,r,a){let{reference:l,floating:s}=i;const c=l.x+l.width/2-s.width/2,f=l.y+l.height/2-s.height/2,m=o(r),u=e(m),g=l[u]/2-s[u]/2,d="x"===m;let p;switch(n(r)){case"top":p={x:c,y:l.y-s.height};break;case"bottom":p={x:c,y:l.y+l.height};break;case"right":p={x:l.x+l.width,y:f};break;case"left":p={x:l.x-s.width,y:f};break;default:p={x:l.x,y:l.y}}switch(t(r)){case"start":p[m]-=g*(a&&d?-1:1);break;case"end":p[m]+=g*(a&&d?-1:1)}return p}const r=async(t,e,n)=>{const{placement:o="bottom",strategy:r="absolute",middleware:a=[],platform:l}=n,s=a.filter(Boolean),c=await(null==l.isRTL?void 0:l.isRTL(e));let f=await l.getElementRects({reference:t,floating:e,strategy:r}),{x:m,y:u}=i(f,o,c),g=o,d={},p=0;for(let n=0;n<s.length;n++){const{name:a,fn:h}=s[n],{x:y,y:x,data:w,reset:v}=await h({x:m,y:u,initialPlacement:o,placement:g,strategy:r,middlewareData:d,rects:f,platform:l,elements:{reference:t,floating:e}});m=null!=y?y:m,u=null!=x?x:u,d={...d,[a]:{...d[a],...w}},v&&p<=50&&(p++,"object"==typeof v&&(v.placement&&(g=v.placement),v.rects&&(f=!0===v.rects?await l.getElementRects({reference:t,floating:e,strategy:r}):v.rects),({x:m,y:u}=i(f,g,c))),n=-1)}return{x:m,y:u,placement:g,strategy:r,middlewareData:d}};function a(t,e){return"function"==typeof t?t(e):t}function l(t){return"number"!=typeof t?function(t){return{top:0,right:0,bottom:0,left:0,...t}}(t):{top:t,right:t,bottom:t,left:t}}function s(t){return{...t,top:t.y,left:t.x,right:t.x+t.width,bottom:t.y+t.height}}async function c(t,e){var n;void 0===e&&(e={});const{x:o,y:i,platform:r,rects:c,elements:f,strategy:m}=t,{boundary:u="clippingAncestors",rootBoundary:g="viewport",elementContext:d="floating",altBoundary:p=!1,padding:h=0}=a(e,t),y=l(h),x=f[p?"floating"===d?"reference":"floating":d],w=s(await r.getClippingRect({element:null==(n=await(null==r.isElement?void 0:r.isElement(x)))||n?x:x.contextElement||await(null==r.getDocumentElement?void 0:r.getDocumentElement(f.floating)),boundary:u,rootBoundary:g,strategy:m})),v="floating"===d?{...c.floating,x:o,y:i}:c.reference,b=await(null==r.getOffsetParent?void 0:r.getOffsetParent(f.floating)),A=await(null==r.isElement?void 0:r.isElement(b))&&await(null==r.getScale?void 0:r.getScale(b))||{x:1,y:1},R=s(r.convertOffsetParentRelativeRectToViewportRelativeRect?await r.convertOffsetParentRelativeRectToViewportRelativeRect({rect:v,offsetParent:b,strategy:m}):v);return{top:(w.top-R.top+y.top)/A.y,bottom:(R.bottom-w.bottom+y.bottom)/A.y,left:(w.left-R.left+y.left)/A.x,right:(R.right-w.right+y.right)/A.x}}const f=Math.min,m=Math.max;function u(t,e,n){return m(t,f(e,n))}const g=n=>({name:"arrow",options:n,async fn(i){const{x:r,y:s,placement:c,rects:m,platform:g,elements:d}=i,{element:p,padding:h=0}=a(n,i)||{};if(null==p)return{};const y=l(h),x={x:r,y:s},w=o(c),v=e(w),b=await g.getDimensions(p),A="y"===w,R=A?"top":"left",P=A?"bottom":"right",E=A?"clientHeight":"clientWidth",T=m.reference[v]+m.reference[w]-x[w]-m.floating[v],D=x[w]-m.reference[w],L=await(null==g.getOffsetParent?void 0:g.getOffsetParent(p));let k=L?L[E]:0;k&&await(null==g.isElement?void 0:g.isElement(L))||(k=d.floating[E]||m.floating[v]);const O=T/2-D/2,B=k/2-b[v]/2-1,C=f(y[R],B),H=f(y[P],B),S=C,F=k-b[v]-H,M=k/2-b[v]/2+O,V=u(S,M,F),W=null!=t(c)&&M!=V&&m.reference[v]/2-(M<S?C:H)-b[v]/2<0?M<S?S-M:F-M:0;return{[w]:x[w]-W,data:{[w]:V,centerOffset:M-V+W}}}}),d=["top","right","bottom","left"],p=d.reduce(((t,e)=>t.concat(e,e+"-start",e+"-end")),[]),h={left:"right",right:"left",bottom:"top",top:"bottom"};function y(t){return t.replace(/left|right|bottom|top/g,(t=>h[t]))}function x(n,i,r){void 0===r&&(r=!1);const a=t(n),l=o(n),s=e(l);let c="x"===l?a===(r?"end":"start")?"right":"left":"start"===a?"bottom":"top";return i.reference[s]>i.floating[s]&&(c=y(c)),{main:c,cross:y(c)}}const w={start:"end",end:"start"};function v(t){return t.replace(/start|end/g,(t=>w[t]))}const b=function(e){return void 0===e&&(e={}),{name:"autoPlacement",options:e,async fn(o){var i,r,l;const{rects:s,middlewareData:f,placement:m,platform:u,elements:g}=o,{crossAxis:d=!1,alignment:h,allowedPlacements:y=p,autoAlignment:w=!0,...b}=a(e,o),A=void 0!==h||y===p?function(e,o,i){return(e?[...i.filter((n=>t(n)===e)),...i.filter((n=>t(n)!==e))]:i.filter((t=>n(t)===t))).filter((n=>!e||t(n)===e||!!o&&v(n)!==n))}(h||null,w,y):y,R=await c(o,b),P=(null==(i=f.autoPlacement)?void 0:i.index)||0,E=A[P];if(null==E)return{};const{main:T,cross:D}=x(E,s,await(null==u.isRTL?void 0:u.isRTL(g.floating)));if(m!==E)return{reset:{placement:A[0]}};const L=[R[n(E)],R[T],R[D]],k=[...(null==(r=f.autoPlacement)?void 0:r.overflows)||[],{placement:E,overflows:L}],O=A[P+1];if(O)return{data:{index:P+1,overflows:k},reset:{placement:O}};const B=k.map((e=>{const n=t(e.placement);return[e.placement,n&&d?e.overflows.slice(0,2).reduce(((t,e)=>t+e),0):e.overflows[0],e.overflows]})).sort(((t,e)=>t[1]-e[1])),C=(null==(l=B.filter((e=>e[2].slice(0,t(e[0])?2:3).every((t=>t<=0))))[0])?void 0:l[0])||B[0][0];return C!==m?{data:{index:P+1,overflows:k},reset:{placement:C}}:{}}}};const A=function(e){return void 0===e&&(e={}),{name:"flip",options:e,async fn(o){var i;const{placement:r,middlewareData:l,rects:s,initialPlacement:f,platform:m,elements:u}=o,{mainAxis:g=!0,crossAxis:d=!0,fallbackPlacements:p,fallbackStrategy:h="bestFit",fallbackAxisSideDirection:w="none",flipAlignment:b=!0,...A}=a(e,o),R=n(r),P=n(f)===f,E=await(null==m.isRTL?void 0:m.isRTL(u.floating)),T=p||(P||!b?[y(f)]:function(t){const e=y(t);return[v(t),e,v(e)]}(f));p||"none"===w||T.push(...function(e,o,i,r){const a=t(e);let l=function(t,e,n){const o=["left","right"],i=["right","left"],r=["top","bottom"],a=["bottom","top"];switch(t){case"top":case"bottom":return n?e?i:o:e?o:i;case"left":case"right":return e?r:a;default:return[]}}(n(e),"start"===i,r);return a&&(l=l.map((t=>t+"-"+a)),o&&(l=l.concat(l.map(v)))),l}(f,b,w,E));const D=[f,...T],L=await c(o,A),k=[];let O=(null==(i=l.flip)?void 0:i.overflows)||[];if(g&&k.push(L[R]),d){const{main:t,cross:e}=x(r,s,E);k.push(L[t],L[e])}if(O=[...O,{placement:r,overflows:k}],!k.every((t=>t<=0))){var B,C;const t=((null==(B=l.flip)?void 0:B.index)||0)+1,e=D[t];if(e)return{data:{index:t,overflows:O},reset:{placement:e}};let n=null==(C=O.filter((t=>t.overflows[0]<=0)).sort(((t,e)=>t.overflows[1]-e.overflows[1]))[0])?void 0:C.placement;if(!n)switch(h){case"bestFit":{var H;const t=null==(H=O.map((t=>[t.placement,t.overflows.filter((t=>t>0)).reduce(((t,e)=>t+e),0)])).sort(((t,e)=>t[1]-e[1]))[0])?void 0:H[0];t&&(n=t);break}case"initialPlacement":n=f}if(r!==n)return{reset:{placement:n}}}return{}}}};function R(t,e){return{top:t.top-e.height,right:t.right-e.width,bottom:t.bottom-e.height,left:t.left-e.width}}function P(t){return d.some((e=>t[e]>=0))}const E=function(t){return void 0===t&&(t={}),{name:"hide",options:t,async fn(e){const{rects:n}=e,{strategy:o="referenceHidden",...i}=a(t,e);switch(o){case"referenceHidden":{const t=R(await c(e,{...i,elementContext:"reference"}),n.reference);return{data:{referenceHiddenOffsets:t,referenceHidden:P(t)}}}case"escaped":{const t=R(await c(e,{...i,altBoundary:!0}),n.floating);return{data:{escapedOffsets:t,escaped:P(t)}}}default:return{}}}}};function T(t){const e=f(...t.map((t=>t.left))),n=f(...t.map((t=>t.top)));return{x:e,y:n,width:m(...t.map((t=>t.right)))-e,height:m(...t.map((t=>t.bottom)))-n}}const D=function(t){return void 0===t&&(t={}),{name:"inline",options:t,async fn(e){const{placement:i,elements:r,rects:c,platform:u,strategy:g}=e,{padding:d=2,x:p,y:h}=a(t,e),y=Array.from(await(null==u.getClientRects?void 0:u.getClientRects(r.reference))||[]),x=function(t){const e=t.slice().sort(((t,e)=>t.y-e.y)),n=[];let o=null;for(let t=0;t<e.length;t++){const i=e[t];!o||i.y-o.y>o.height/2?n.push([i]):n[n.length-1].push(i),o=i}return n.map((t=>s(T(t))))}(y),w=s(T(y)),v=l(d);const b=await u.getElementRects({reference:{getBoundingClientRect:function(){if(2===x.length&&x[0].left>x[1].right&&null!=p&&null!=h)return x.find((t=>p>t.left-v.left&&p<t.right+v.right&&h>t.top-v.top&&h<t.bottom+v.bottom))||w;if(x.length>=2){if("x"===o(i)){const t=x[0],e=x[x.length-1],o="top"===n(i),r=t.top,a=e.bottom,l=o?t.left:e.left,s=o?t.right:e.right;return{top:r,bottom:a,left:l,right:s,width:s-l,height:a-r,x:l,y:r}}const t="left"===n(i),e=m(...x.map((t=>t.right))),r=f(...x.map((t=>t.left))),a=x.filter((n=>t?n.left===r:n.right===e)),l=a[0].top,s=a[a.length-1].bottom;return{top:l,bottom:s,left:r,right:e,width:e-r,height:s-l,x:r,y:l}}return w}},floating:r.floating,strategy:g});return c.reference.x!==b.reference.x||c.reference.y!==b.reference.y||c.reference.width!==b.reference.width||c.reference.height!==b.reference.height?{reset:{rects:b}}:{}}}};const L=function(e){return void 0===e&&(e=0),{name:"offset",options:e,async fn(i){const{x:r,y:l}=i,s=await async function(e,i){const{placement:r,platform:l,elements:s}=e,c=await(null==l.isRTL?void 0:l.isRTL(s.floating)),f=n(r),m=t(r),u="x"===o(r),g=["left","top"].includes(f)?-1:1,d=c&&u?-1:1,p=a(i,e);let{mainAxis:h,crossAxis:y,alignmentAxis:x}="number"==typeof p?{mainAxis:p,crossAxis:0,alignmentAxis:null}:{mainAxis:0,crossAxis:0,alignmentAxis:null,...p};return m&&"number"==typeof x&&(y="end"===m?-1*x:x),u?{x:y*d,y:h*g}:{x:h*g,y:y*d}}(i,e);return{x:r+s.x,y:l+s.y,data:s}}}};function k(t){return"x"===t?"y":"x"}const O=function(t){return void 0===t&&(t={}),{name:"shift",options:t,async fn(e){const{x:i,y:r,placement:l}=e,{mainAxis:s=!0,crossAxis:f=!1,limiter:m={fn:t=>{let{x:e,y:n}=t;return{x:e,y:n}}},...g}=a(t,e),d={x:i,y:r},p=await c(e,g),h=o(n(l)),y=k(h);let x=d[h],w=d[y];if(s){const t="y"===h?"bottom":"right";x=u(x+p["y"===h?"top":"left"],x,x-p[t])}if(f){const t="y"===y?"bottom":"right";w=u(w+p["y"===y?"top":"left"],w,w-p[t])}const v=m.fn({...e,[h]:x,[y]:w});return{...v,data:{x:v.x-i,y:v.y-r}}}}},B=function(t){return void 0===t&&(t={}),{options:t,fn(e){const{x:i,y:r,placement:l,rects:s,middlewareData:c}=e,{offset:f=0,mainAxis:m=!0,crossAxis:u=!0}=a(t,e),g={x:i,y:r},d=o(l),p=k(d);let h=g[d],y=g[p];const x=a(f,e),w="number"==typeof x?{mainAxis:x,crossAxis:0}:{mainAxis:0,crossAxis:0,...x};if(m){const t="y"===d?"height":"width",e=s.reference[d]-s.floating[t]+w.mainAxis,n=s.reference[d]+s.reference[t]-w.mainAxis;h<e?h=e:h>n&&(h=n)}if(u){var v,b;const t="y"===d?"width":"height",e=["top","left"].includes(n(l)),o=s.reference[p]-s.floating[t]+(e&&(null==(v=c.offset)?void 0:v[p])||0)+(e?0:w.crossAxis),i=s.reference[p]+s.reference[t]+(e?0:(null==(b=c.offset)?void 0:b[p])||0)-(e?w.crossAxis:0);y<o?y=o:y>i&&(y=i)}return{[d]:h,[p]:y}}}},C=function(e){return void 0===e&&(e={}),{name:"size",options:e,async fn(i){const{placement:r,rects:l,platform:s,elements:u}=i,{apply:g=(()=>{}),...d}=a(e,i),p=await c(i,d),h=n(r),y=t(r),x="x"===o(r),{width:w,height:v}=l.floating;let b,A;"top"===h||"bottom"===h?(b=h,A=y===(await(null==s.isRTL?void 0:s.isRTL(u.floating))?"start":"end")?"left":"right"):(A=h,b="end"===y?"top":"bottom");const R=v-p[b],P=w-p[A],E=!i.middlewareData.shift;let T=R,D=P;if(x){const t=w-p.left-p.right;D=y||E?f(P,t):t}else{const t=v-p.top-p.bottom;T=y||E?f(R,t):t}if(E&&!y){const t=m(p.left,0),e=m(p.right,0),n=m(p.top,0),o=m(p.bottom,0);x?D=w-2*(0!==t||0!==e?t+e:m(p.left,p.right)):T=v-2*(0!==n||0!==o?n+o:m(p.top,p.bottom))}await g({...i,availableWidth:D,availableHeight:T});const L=await s.getDimensions(u.floating);return w!==L.width||v!==L.height?{reset:{rects:!0}}:{}}}};


/***/ }),

/***/ 82622:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kx": function() { return /* binding */ D; },
/* harmony export */   "Me": function() { return /* binding */ A; },
/* harmony export */   "oo": function() { return /* binding */ B; }
/* harmony export */ });
/* unused harmony export platform */
/* harmony import */ var _floating_ui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42660);
function n(t){var e;return(null==t||null==(e=t.ownerDocument)?void 0:e.defaultView)||window}function o(t){return n(t).getComputedStyle(t)}function i(t){return t instanceof n(t).Node}function r(t){return i(t)?(t.nodeName||"").toLowerCase():"#document"}function c(t){return t instanceof n(t).HTMLElement}function l(t){return"undefined"!=typeof ShadowRoot&&(t instanceof n(t).ShadowRoot||t instanceof ShadowRoot)}function s(t){const{overflow:e,overflowX:n,overflowY:i,display:r}=o(t);return/auto|scroll|overlay|hidden|clip/.test(e+i+n)&&!["inline","contents"].includes(r)}function f(t){return["table","td","th"].includes(r(t))}function u(t){const e=a(),n=o(t);return"none"!==n.transform||"none"!==n.perspective||!!n.containerType&&"normal"!==n.containerType||!e&&!!n.backdropFilter&&"none"!==n.backdropFilter||!e&&!!n.filter&&"none"!==n.filter||["transform","perspective","filter"].some((t=>(n.willChange||"").includes(t)))||["paint","layout","strict","content"].some((t=>(n.contain||"").includes(t)))}function a(){return!("undefined"==typeof CSS||!CSS.supports)&&CSS.supports("-webkit-backdrop-filter","none")}function d(t){return["html","body","#document"].includes(r(t))}const h=Math.min,p=Math.max,m=Math.round,g=Math.floor,y=t=>({x:t,y:t});function w(t){const e=o(t);let n=parseFloat(e.width)||0,i=parseFloat(e.height)||0;const r=c(t),l=r?t.offsetWidth:n,s=r?t.offsetHeight:i,f=m(n)!==l||m(i)!==s;return f&&(n=l,i=s),{width:n,height:i,$:f}}function x(t){return t instanceof n(t).Element}function v(t){return x(t)?t:t.contextElement}function b(t){const e=v(t);if(!c(e))return y(1);const n=e.getBoundingClientRect(),{width:o,height:i,$:r}=w(e);let l=(r?m(n.width):n.width)/o,s=(r?m(n.height):n.height)/i;return l&&Number.isFinite(l)||(l=1),s&&Number.isFinite(s)||(s=1),{x:l,y:s}}const L=y(0);function T(t){const e=n(t);return a()&&e.visualViewport?{x:e.visualViewport.offsetLeft,y:e.visualViewport.offsetTop}:L}function R(e,o,i,r){void 0===o&&(o=!1),void 0===i&&(i=!1);const c=e.getBoundingClientRect(),l=v(e);let s=y(1);o&&(r?x(r)&&(s=b(r)):s=b(e));const f=function(t,e,o){return void 0===e&&(e=!1),!(!o||e&&o!==n(t))&&e}(l,i,r)?T(l):y(0);let u=(c.left+f.x)/s.x,a=(c.top+f.y)/s.y,d=c.width/s.x,h=c.height/s.y;if(l){const t=n(l),e=r&&x(r)?n(r):r;let o=t.frameElement;for(;o&&r&&e!==t;){const t=b(o),e=o.getBoundingClientRect(),i=getComputedStyle(o),r=e.left+(o.clientLeft+parseFloat(i.paddingLeft))*t.x,c=e.top+(o.clientTop+parseFloat(i.paddingTop))*t.y;u*=t.x,a*=t.y,d*=t.x,h*=t.y,u+=r,a+=c,o=n(o).frameElement}}return (0,_floating_ui_core__WEBPACK_IMPORTED_MODULE_0__/* .rectToClientRect */ .JB)({width:d,height:h,x:u,y:a})}function S(t){return x(t)?{scrollLeft:t.scrollLeft,scrollTop:t.scrollTop}:{scrollLeft:t.pageXOffset,scrollTop:t.pageYOffset}}function C(t){return((i(t)?t.ownerDocument:t.document)||window.document).documentElement}function E(t){return R(C(t)).left+S(t).scrollLeft}function F(t){if("html"===r(t))return t;const e=t.assignedSlot||t.parentNode||l(t)&&t.host||C(t);return l(e)?e.host:e}function O(t){const e=F(t);return d(e)?t.ownerDocument?t.ownerDocument.body:t.body:c(e)&&s(e)?e:O(e)}function D(t,e){var o;void 0===e&&(e=[]);const i=O(t),r=i===(null==(o=t.ownerDocument)?void 0:o.body),c=n(i);return r?e.concat(c,c.visualViewport||[],s(i)?i:[]):e.concat(i,D(i))}function W(e,i,r){let l;if("viewport"===i)l=function(t,e){const o=n(t),i=C(t),r=o.visualViewport;let c=i.clientWidth,l=i.clientHeight,s=0,f=0;if(r){c=r.width,l=r.height;const t=a();(!t||t&&"fixed"===e)&&(s=r.offsetLeft,f=r.offsetTop)}return{width:c,height:l,x:s,y:f}}(e,r);else if("document"===i)l=function(t){const e=C(t),n=S(t),i=t.ownerDocument.body,r=p(e.scrollWidth,e.clientWidth,i.scrollWidth,i.clientWidth),c=p(e.scrollHeight,e.clientHeight,i.scrollHeight,i.clientHeight);let l=-n.scrollLeft+E(t);const s=-n.scrollTop;return"rtl"===o(i).direction&&(l+=p(e.clientWidth,i.clientWidth)-r),{width:r,height:c,x:l,y:s}}(C(e));else if(x(i))l=function(t,e){const n=R(t,!0,"fixed"===e),o=n.top+t.clientTop,i=n.left+t.clientLeft,r=c(t)?b(t):y(1);return{width:t.clientWidth*r.x,height:t.clientHeight*r.y,x:i*r.x,y:o*r.y}}(i,r);else{const t=T(e);l={...i,x:i.x-t.x,y:i.y-t.y}}return (0,_floating_ui_core__WEBPACK_IMPORTED_MODULE_0__/* .rectToClientRect */ .JB)(l)}function H(t,e){const n=F(t);return!(n===e||!x(n)||d(n))&&("fixed"===o(n).position||H(n,e))}function z(t,e,n){const o=c(e),i=C(e),l="fixed"===n,f=R(t,!0,l,e);let u={scrollLeft:0,scrollTop:0};const a=y(0);if(o||!o&&!l)if(("body"!==r(e)||s(i))&&(u=S(e)),c(e)){const t=R(e,!0,l,e);a.x=t.x+e.clientLeft,a.y=t.y+e.clientTop}else i&&(a.x=E(i));return{x:f.left+u.scrollLeft-a.x,y:f.top+u.scrollTop-a.y,width:f.width,height:f.height}}function M(t,e){return c(t)&&"fixed"!==o(t).position?e?e(t):t.offsetParent:null}function P(t,e){const i=n(t);if(!c(t))return i;let l=M(t,e);for(;l&&f(l)&&"static"===o(l).position;)l=M(l,e);return l&&("html"===r(l)||"body"===r(l)&&"static"===o(l).position&&!u(l))?i:l||function(t){let e=F(t);for(;c(e)&&!d(e);){if(u(e))return e;e=F(e)}return null}(t)||i}const V={convertOffsetParentRelativeRectToViewportRelativeRect:function(t){let{rect:e,offsetParent:n,strategy:o}=t;const i=c(n),l=C(n);if(n===l)return e;let f={scrollLeft:0,scrollTop:0},u=y(1);const a=y(0);if((i||!i&&"fixed"!==o)&&(("body"!==r(n)||s(l))&&(f=S(n)),c(n))){const t=R(n);u=b(n),a.x=t.x+n.clientLeft,a.y=t.y+n.clientTop}return{width:e.width*u.x,height:e.height*u.y,x:e.x*u.x-f.scrollLeft*u.x+a.x,y:e.y*u.y-f.scrollTop*u.y+a.y}},getDocumentElement:C,getClippingRect:function(t){let{element:e,boundary:n,rootBoundary:i,strategy:c}=t;const l=[..."clippingAncestors"===n?function(t,e){const n=e.get(t);if(n)return n;let i=D(t).filter((t=>x(t)&&"body"!==r(t))),c=null;const l="fixed"===o(t).position;let f=l?F(t):t;for(;x(f)&&!d(f);){const e=o(f),n=u(f);n||"fixed"!==e.position||(c=null),(l?!n&&!c:!n&&"static"===e.position&&c&&["absolute","fixed"].includes(c.position)||s(f)&&!n&&H(t,f))?i=i.filter((t=>t!==f)):c=e,f=F(f)}return e.set(t,i),i}(e,this._c):[].concat(n),i],f=l[0],a=l.reduce(((t,n)=>{const o=W(e,n,c);return t.top=p(o.top,t.top),t.right=h(o.right,t.right),t.bottom=h(o.bottom,t.bottom),t.left=p(o.left,t.left),t}),W(e,f,c));return{width:a.right-a.left,height:a.bottom-a.top,x:a.left,y:a.top}},getOffsetParent:P,getElementRects:async function(t){let{reference:e,floating:n,strategy:o}=t;const i=this.getOffsetParent||P,r=this.getDimensions;return{reference:z(e,await i(n),o),floating:{x:0,y:0,...await r(n)}}},getClientRects:function(t){return Array.from(t.getClientRects())},getDimensions:function(t){return w(t)},getScale:b,isElement:x,isRTL:function(t){return"rtl"===getComputedStyle(t).direction}};function A(t,e,n,o){void 0===o&&(o={});const{ancestorScroll:i=!0,ancestorResize:r=!0,elementResize:c="function"==typeof ResizeObserver,layoutShift:l="function"==typeof IntersectionObserver,animationFrame:s=!1}=o,f=v(t),u=i||r?[...f?D(f):[],...D(e)]:[];u.forEach((t=>{i&&t.addEventListener("scroll",n,{passive:!0}),r&&t.addEventListener("resize",n)}));const a=f&&l?function(t,e){let n,o=null;const i=C(t);function r(){clearTimeout(n),o&&o.disconnect(),o=null}return function c(l,s){void 0===l&&(l=!1),void 0===s&&(s=1),r();const{left:f,top:u,width:a,height:d}=t.getBoundingClientRect();if(l||e(),!a||!d)return;const m={rootMargin:-g(u)+"px "+-g(i.clientWidth-(f+a))+"px "+-g(i.clientHeight-(u+d))+"px "+-g(f)+"px",threshold:p(0,h(1,s))||1};let y=!0;function w(t){const e=t[0].intersectionRatio;if(e!==s){if(!y)return c();e?c(!1,e):n=setTimeout((()=>{c(!1,1e-7)}),100)}y=!1}try{o=new IntersectionObserver(w,{...m,root:i.ownerDocument})}catch(t){o=new IntersectionObserver(w,m)}o.observe(t)}(!0),r}(f,n):null;let d,m=-1,y=null;c&&(y=new ResizeObserver((t=>{let[o]=t;o&&o.target===f&&y&&(y.unobserve(e),cancelAnimationFrame(m),m=requestAnimationFrame((()=>{y&&y.observe(e)}))),n()})),f&&!s&&y.observe(f),y.observe(e));let w=s?R(t):null;return s&&function e(){const o=R(t);!w||o.x===w.x&&o.y===w.y&&o.width===w.width&&o.height===w.height||n();w=o,d=requestAnimationFrame(e)}(),n(),()=>{u.forEach((t=>{i&&t.removeEventListener("scroll",n),r&&t.removeEventListener("resize",n)})),a&&a(),y&&y.disconnect(),y=null,s&&cancelAnimationFrame(d)}}const B=(t,n,o)=>{const i=new Map,r={platform:V,...o},c={...r.platform,_c:i};return (0,_floating_ui_core__WEBPACK_IMPORTED_MODULE_0__/* .computePosition */ .oo)(t,n,{...r,platform:c})};


/***/ })

}]);